import React, { useState, useEffect, createContext, useContext, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc, getDocs, addDoc, setDoc, updateDoc, deleteDoc, onSnapshot, collection, query, where, serverTimestamp, orderBy, increment, limit, Timestamp, startAfter, writeBatch, documentId } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { Helmet } from 'react-helmet';
import ReCAPTCHA from "react-google-recaptcha";

import firebaseConfig from './firebaseConfig';
import { Routes, Route, Outlet, Link, useNavigate,useParams, useLocation } from 'react-router-dom';
import AirportCabs from './AirportCabs';
import VisaImmigration from './VisaImmigration'; // ✨ ADD THIS IMPORT
import MoneyTransfer from './MoneyTransfer';
import FindJobs from './FindJobs';
import CVHelp from './CVHelp';
import IndianMortgages from './IndianMortgages';
import UkTourTrips from './UkTourTrips';
import IndianFestivals from './IndianFestivals';
import ITCourses from './ITCourses';
import PartnerWithUs from './PartnerWithUs';
import StudentAdmissions from './StudentAdmissions';
import LondonAreasGuide from './LondonAreasGuide';
import LondonAttractions from './LondonAttractions';
import UkEssentials from './UkEssentials';
import EssentialsAdmin from './EssentialsAdmin';
import NRIMatrimonials from './NRIMatrimonials';
import NotFound from './NotFound';
import FirstWeekUK from './FirstWeekUK';
import HomeSeoContent from './components/HomeSeoContent';
import Breadcrumbs from './components/Breadcrumbs';
import RelatedGuides from './components/RelatedGuides';
import areas, { areaNameFromSlug, areasMentionedIn } from './data/areas';
import { useToast } from './ToastContext';
import { getAuthErrorMessage, maskPhoneNumbers } from './utils';
import PricingModal from './components/PricingModal';
import WhatsAppEnquiryForm from './components/WhatsAppEnquiryForm';
import PaymentCheckout from './components/PaymentCheckout';
import PremiumBadge from './components/PremiumBadge';
import LockedContactInfo from './components/LockedContactInfo';
import PremiumUpsellPopup from './components/PremiumUpsellPopup';
import AdminSubscriptionPanel from './components/AdminSubscriptionPanel';
import { shouldShowUpsellPopup, dismissUpsellPopup, shouldShowRenewalPopup, dismissRenewalPopup } from './utils/returningUserDetection';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

// Context for Firebase and User
export const AppContext = createContext(null);
// Tidy user-typed text for page titles/descriptions: drops emoji and a leading
// "Location:" label, collapses spaces, and removes stray spaces before commas.
const cleanText = (text = '') => text.toString()
    .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, '')
    .replace(/^\s*(location|address|area)\s*:\s*/i, '')
    .replace(/\s+/g, ' ')
    .replace(/\s+,/g, ',')
    .replace(/^[\s,]+|[\s,]+$/g, '');

// Adds ", London" only when the area doesn't already mention it
const withLondon = (area) => (/london/i.test(area) ? area : `${area}, London`);

// "Double room available in Manor Park" + area "Manor park" -> don't repeat "in Manor park"
const roomSeoPlace = (title, area) =>
    area && title.toLowerCase().includes(area.toLowerCase()) ? '' : ` in ${withLondon(area)}`;

const slugify = (text = '') => {
    const stopWords = new Set(['i', 'a', 'an', 'am', 'in', 'is', 'it', 'for', 'of', 'the', 'to', 'have', 'id']);

    let processedText = text
      .toString()
      .toLowerCase()
      .replace(/[0-9]/g, '') // remove all digits
      .replace(/'s\b/g, '') // remove apostrophe s
      .replace(/[^\w\s]/g, '') // remove non-word characters except spaces
      .split(' ')
      .filter(word => word && !stopWords.has(word)) // remove stop words and empty strings
      .join(' ');

    return processedText
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
};

// Add this helper function near the top of App.js

const formatDateForDisplay = (dateString) => {
  // Return a default string if the date is missing
  if (!dateString || typeof dateString !== 'string') return 'Not specified';

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to midnight for an accurate date-only comparison

  // Split the date string to avoid timezone issues when parsing
  const dateParts = dateString.split('-');
  if (dateParts.length !== 3) return dateString; // Return original if format is unexpected

  // Create the date object from parts (month is 0-indexed)
  const postDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

  // If the post's date is today or in the past, show "Immediately"
  if (postDate <= today) {
    return 'Immediately';
  }

  // Otherwise, return the original date
  return dateString;
};


const getFirebaseConfig = () => {
    return firebaseConfig;
};
function Footer() {
    const currentYear = new Date().getFullYear(); // This will correctly display 2025
    return (
        <footer className="bg-white dark:bg-gray-800 shadow-inner mt-auto py-6 px-4">
            <div className="container mx-auto text-center text-gray-600 dark:text-gray-400">

                {/* Section for navigation links */}
                <div className="flex justify-center items-center flex-wrap gap-x-6 gap-y-2 mb-4 text-sm font-semibold">
                                        <Link to="/roommates" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
    Browse Roommates
</Link>
                                        <Link to="/uk-essentials-for-indians" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
    UK Essentials Guide
</Link>
                    <Link to="/indian-areas-in-london" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
    London Area Guide
</Link>
                    <Link to="/top-london-attractions" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
    Top London Attractions
</Link>
                    <Link
                        to="/airport-cabs"
                        className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
                        Airport Cabs
                    </Link>

                    {/* ✨ NEW LINKS ADDED HERE */}
                    <Link
                        to="/visa-and-immigration-support"
                        className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
                        Visa Support
                    </Link>
                    <Link
                        to="/money-transfer-to-india"
                        className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200"
                    >
                        Money Transfer
                    </Link>
                    <Link to="/uk-jobs-for-indians" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">
                        Find Jobs
                    </Link>
                                        <Link to="/student-admissions-uk" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">Student Admissions</Link>

                                 <Link to="/cv-and-interview-help" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">CV & Interview Help</Link>
                                                                         <Link to="/it-courses-and-certifications" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">IT Courses</Link>

                    <Link to="/mortgages-for-indians" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">UK Mortgages</Link>
                    <Link to="/uk-tour-trips" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">UK Group Tour Trips</Link>
                    <Link to="/indian-events-and-festivals" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">Events & Festivals</Link>

                    <Link to="/partner-with-us" className="text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors duration-200">Partner With Us</Link>
                    <Link to="/nri-matrimonials-uk" className="text-pink-600 hover:text-pink-800 dark:text-pink-400 dark:hover:text-pink-300 hover:underline transition-colors duration-200 font-bold">💍 NRI Matrimonials</Link>
                </div>

                {/* VivahMilap Partner Banner */}
                <div className="my-4 py-3 px-4 bg-gradient-to-r from-pink-50 to-purple-50 dark:from-gray-700 dark:to-gray-700 rounded-lg border border-pink-200 dark:border-gray-600">
                    <p className="text-sm text-gray-700 dark:text-gray-300">
                        Looking for your life partner? 💑{' '}
                        <a
                            href="https://vivahmilap.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-pink-600 hover:text-pink-800 dark:text-pink-400 font-bold hover:underline"
                        >
                            VivahMilap.com
                        </a>
                        {' '}— Trusted NRI Matrimonials for UK Indians. Find verified Indian brides &amp; grooms across London, Birmingham, Manchester &amp; more.{' '}
                        <a
                            href="https://vivahmilap.com/register"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-purple-600 hover:text-purple-800 dark:text-purple-400 font-semibold hover:underline"
                        >
                            Create free profile →
                        </a>
                    </p>
                </div>

                {/* Copyright notice */}
                <p className="text-xs text-gray-500 dark:text-gray-500">
                    © {currentYear} IndianFlatmates. All rights Reserved.
                </p>

            </div>
        </footer>
    );
}

const capitalize = (s) => s && s.charAt(0).toUpperCase() + s.slice(1);

// --- "Fill My Room for Me" concierge service ---
const FILL_MY_ROOM_PHONE = '919703491968';
const buildFillMyRoomWaUrl = (source, listingUrl) => {
    const listingLine = listingUrl ? ` My listing: ${listingUrl}` : '';
    const text = `Hi! I'd like help filling my room in London.${listingLine} Please let me know the next steps. (via ${source})`;
    return `https://wa.me/${FILL_MY_ROOM_PHONE}?text=${encodeURIComponent(text)}`;
};

function FillMyRoomView({ onBack }) {
    return (
        <div className="bg-white dark:bg-gray-800 p-6 md:p-8 rounded-lg shadow-md max-w-3xl mx-auto my-6">
            <div className="text-center mb-6">
                <h2 className="text-2xl md:text-3xl font-bold text-indigo-700 dark:text-indigo-300 mb-2">
                    🙌 We'll Fill Your Room For You
                </h2>
                <p className="text-gray-700 dark:text-gray-300 max-w-xl mx-auto">
                    Sit back. We find, screen, and connect you with compatible Indian flatmates — usually within 7-14 days.
                </p>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/30 dark:to-emerald-900/30 border-2 border-green-400 rounded-lg p-5 mb-6 text-center">
                <div className="text-3xl font-bold text-green-700 dark:text-green-300 mb-1">
                    💷 Pay Only 1 Week's Rent
                </div>
                <div className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                    No flatmate = no fee. We only get paid when your room is filled.
                </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200 mb-3">What you get</h3>
                    <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                        <li className="flex gap-2"><span className="text-green-600">✓</span> We post & promote your listing</li>
                        <li className="flex gap-2"><span className="text-green-600">✓</span> We screen enquiries — no time-wasters</li>
                        <li className="flex gap-2"><span className="text-green-600">✓</span> We schedule viewings that suit you</li>
                        <li className="flex gap-2"><span className="text-green-600">✓</span> WhatsApp support throughout</li>
                        <li className="flex gap-2"><span className="text-green-600">✓</span> Replacement search if tenant leaves within 1 month</li>
                    </ul>
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200 mb-3">How it works</h3>
                    <ol className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                        <li className="flex gap-2"><span className="font-bold text-indigo-600">1.</span> Share your room details on WhatsApp</li>
                        <li className="flex gap-2"><span className="font-bold text-indigo-600">2.</span> We list & start matching within 24 hrs</li>
                        <li className="flex gap-2"><span className="font-bold text-indigo-600">3.</span> You approve shortlisted tenants</li>
                        <li className="flex gap-2"><span className="font-bold text-indigo-600">4.</span> Pay 1 week's rent once they move in</li>
                    </ol>
                </div>
            </div>

            <div className="text-center">
                <WhatsAppEnquiryForm
                    id="fill-my-room-enquiry"
                    className="mb-4"
                    title="Tell us about your room"
                    intro="We'll open WhatsApp with your room details ready to send."
                    greeting="Hi! I'd like help filling my room in London. (via fill_tab)"
                    closing="Please let me know the next steps. Thanks!"
                    submitLabel="Send Room Details on WhatsApp"
                    fields={[
                        { name: "name", label: "Your name", required: true },
                        { name: "area", label: "Area / postcode", required: true, placeholder: "e.g. East Ham, E6" },
                        { name: "station", label: "Nearest station", placeholder: "e.g. East Ham (District line)" },
                        { name: "roomType", label: "Room type", type: "select", required: true, options: ["Single room", "Double room", "En-suite room", "Studio", "Whole flat / house", "Other"] },
                        { name: "rooms", label: "Rooms to fill", type: "number", min: "1", max: "10", defaultValue: 1, required: true },
                        { name: "rent", label: "Rent per month (£)", type: "number", min: "0", required: true, placeholder: "e.g. 750" },
                        { name: "bills", label: "Bills included?", type: "select", required: true, options: ["Yes, all bills", "Some bills", "No, bills extra"] },
                        { name: "available", label: "Available from", type: "date", min: "today", required: true },
                        { name: "preference", label: "Preferred flatmate", type: "select", options: ["Anyone", "Male only", "Female only", "Couples welcome", "Students", "Working professionals"] },
                        { name: "notes", label: "Anything else?", type: "textarea", requiredIfOther: true, placeholder: "Veg-only house, deposit, parking, photos to follow..." },
                    ]}
                />
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-3">
                    Or call: <a href={`tel:+${FILL_MY_ROOM_PHONE}`} className="text-indigo-600 dark:text-indigo-400 font-semibold hover:underline">+91 97034 91968</a>
                </p>
                {onBack && (
                    <button
                        onClick={onBack}
                        className="mt-4 text-sm text-gray-500 dark:text-gray-400 hover:underline"
                    >
                        ← Back to listings
                    </button>
                )}
            </div>
        </div>
    );
}

function FillMyRoomSuccessNudge({ onDismiss, listingUrl }) {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[80]">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6 relative">
                <button
                    onClick={onDismiss}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div className="text-center">
                    <div className="text-4xl mb-2">✅</div>
                    <h3 className="text-xl font-bold text-indigo-700 dark:text-indigo-300 mb-2">
                        Listing created!
                    </h3>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                        Want to fill it <span className="font-bold">faster</span>? We can promote it and screen tenants for you — pay <span className="font-bold">1 week's rent only</span> when we find a match.
                    </p>
                    <div className="flex flex-col gap-2">
                        <a
                            href={buildFillMyRoomWaUrl('fill_success', listingUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={onDismiss}
                            className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg shadow-md transition"
                        >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654z"/>
                            </svg>
                            Chat with Us on WhatsApp
                        </a>
                        <button
                            onClick={onDismiss}
                            className="px-5 py-2 text-sm text-gray-500 dark:text-gray-400 hover:underline"
                        >
                            No thanks
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function FillMyRoomBanner() {
    const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('fill_banner_dismissed') === '1');
    if (dismissed) return null;
    const handleDismiss = () => {
        sessionStorage.setItem('fill_banner_dismissed', '1');
        setDismissed(true);
    };
    return (
        <div className="bg-green-50 dark:bg-green-900/30 border-2 border-green-400 rounded-lg p-3 mb-4 flex items-center justify-between gap-3">
            <div className="text-sm text-gray-800 dark:text-gray-200 flex-1">
                🙌 <span className="font-semibold">Short on time?</span> We'll fill your room for you — pay only <span className="font-semibold">1 week's rent</span> when we find a match.
            </div>
            <div className="flex items-center gap-2 shrink-0">
                <a
                    href={buildFillMyRoomWaUrl('fill_banner')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white text-xs font-semibold rounded-md whitespace-nowrap"
                >
                    Learn →
                </a>
                <button
                    onClick={handleDismiss}
                    className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                    aria-label="Dismiss"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

function AppLayout() {
    // ✅ 1. Get the chatRecipient state from the context.
    const { chatRecipient, setChatRecipient, userProfile, setShowPricingModal, setSelectedPlan } = useContext(AppContext);

    return (
        <>
            <Header />
            {/* ✨ Premium Benefits Banner */}
            {userProfile && !userProfile?.isPremium && (
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-3 shadow-lg">
                    <div className="container mx-auto flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <svg className="w-6 h-6 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                            <div>
                                <p className="font-bold text-sm">Unlock Premium Benefits!</p>
                                <p className="text-xs opacity-90">View contact info • See premium members • Get verified</p>
                            </div>
                        </div>
                        <button
                            onClick={() => {
                                setSelectedPlan('1-month');
                                setShowPricingModal(true);
                            }}
                            className="bg-white text-indigo-600 font-bold px-4 py-2 rounded-lg hover:bg-gray-100 transition duration-200 whitespace-nowrap"
                        >
                            Upgrade Now
                        </button>
                    </div>
                </div>
            )}
            <main className="flex-grow">
                {/* ✅ 2. Check if a chat recipient is set. */}
                {chatRecipient ? (
                    // If YES, render the Chat component.
                    <div className="container mx-auto p-4">
                        <Chat
                            recipient={chatRecipient}
                            onBack={() => {
                                setChatRecipient(null);
                                // We don't need to manipulate history here, just clear the state.
                            }}
                        />
                    </div>
                ) : (
                    // If NO, render the current page's content from the router.
                    <>
                        <Breadcrumbs />
                        <Outlet />
                        <RelatedGuides />
                    </>
                )}
            </main>
            <Footer />
        </>
    );
}
function PostDetailPage({ setPageMeta }) {
    const { db, handleStartChat } = useContext(AppContext);
    const { slug } = useParams();
    const location = useLocation();

    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [notFound, setNotFound] = useState(false);

    const isRoomListing = location.pathname.startsWith('/room/');

    useEffect(() => {
        setPost(null);
        setLoading(true);
        setError(null);
        setNotFound(false);

        if (!db || !slug) return;

         const fetchPost = async () => {
        try {
            const postId = slug.split('-id-').pop();
            if (!postId) {
                throw new Error("Invalid post URL format.");
            }

            const collectionName = isRoomListing ? 'room_listings' : 'roommate_requests';
            const collectionPath = `artifacts/${getFirebaseConfig().appId}/public/data/${collectionName}`;
            const docRef = doc(db, collectionPath, postId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const postData = { id: docSnap.id, ...docSnap.data() };

                // ✨ NEW: Fetch the author's profile to get premium status
                if (postData.userId) {
                    const profileRef = doc(db, `artifacts/${getFirebaseConfig().appId}/public/data/user_profiles`, postData.userId);
                    const profileSnap = await getDoc(profileRef);
                    if (profileSnap.exists()) {
                        postData.isPremium = profileSnap.data().isPremium || false;
                    }
                }

                setPost(postData);

                    const defaultImage = "https://indianflatmates.co.uk/logo512.png";
                    const postImage = (isRoomListing && postData.images?.length > 0) ? postData.images[0] : (postData.profilePicture || defaultImage);

                    let seoTitle, seoDescription, seoKeywords;
                    if (isRoomListing) {
                        const roomTitle = cleanText(maskPhoneNumbers(postData.title || ''));
                        const roomArea = cleanText(postData.address);
                        seoTitle = `${roomTitle}${roomSeoPlace(roomTitle, roomArea)} - £${postData.rent}/month | IndianFlatmates`;
                        const descParts = [
                            `${postData.furnished ? postData.furnished + ' ' : ''}room in ${withLondon(roomArea)}`,
                            `£${postData.rent}/month${postData.billsIncluded ? ', bills included' : ''}`,
                            postData.availableFrom ? `available ${postData.availableFrom}` : null,
                        ].filter(Boolean).join('. ');
                        seoDescription = `${descParts}. ${maskPhoneNumbers(postData.description || '').substring(0, 80)}`.substring(0, 160);
                        seoKeywords = `room in ${roomArea}, Indian flatmate ${roomArea}, ${roomTitle}, Indian room rent ${roomArea} London`;
                    } else {
                        // First name only — full names in search results expose people's identity
                        const firstName = cleanText(postData.userName || 'Room seeker').split(' ')[0];
                        const seekerName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
                        const seekerAreas = cleanText(postData.preferredLocations);
                        seoTitle = `${seekerName} looking for room in ${seekerAreas} - £${postData.budget}/month | IndianFlatmates`;
                        seoDescription = `${seekerName}${postData.profession ? ', ' + cleanText(postData.profession) : ''} seeking room in ${seekerAreas}. Budget £${postData.budget}/month. ${maskPhoneNumbers(postData.requirements || '').substring(0, 70)}`.substring(0, 160);
                        seoKeywords = `Indian roommate wanted ${seekerAreas}, find Indian flatmate ${seekerAreas}, Indian flatmate London`;
                    }

                    setPageMeta({
                        title: seoTitle,
                        description: seoDescription,
                        keywords: seoKeywords,
                        url: window.location.href,
                        image: postImage,
                    });

                } else {
                    // Deleted or never existed: render the 404 page (noindex), not a soft 404
                    setNotFound(true);
                }
            } catch (e) {
                console.error("Error fetching post:", e);
                setError("Could not load the post. It may have been removed.");
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [db, slug, isRoomListing, setPageMeta]);

    if (loading) {
        return <div className="text-center py-10">Loading post...</div>;
    }

    if (notFound) {
        return <NotFound />;
    }

    if (error) {
        return <div className="text-center py-10 text-red-500">{error}</div>;
    }

    // Text is masked like the visible page: phone numbers are a premium feature
    // and must not leak through the JSON-LD
    const pageUrl = `https://indianflatmates.co.uk${location.pathname}`;
    const listingSchema = post ? (isRoomListing ? {
        "@context": "https://schema.org",
        "@type": "Offer",
        "name": cleanText(maskPhoneNumbers(post.title || '')),
        "url": pageUrl,
        "price": post.rent || 0,
        "priceCurrency": "GBP",
        "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "price": post.rent || 0,
            "priceCurrency": "GBP",
            "unitText": "MONTH"
        },
        // Older listings have no status field; the app treats them as active
        "availability": (!post.status || post.status === 'active') ? "https://schema.org/InStock" : "https://schema.org/SoldOut",
        "itemOffered": {
            "@type": "Accommodation",
            "name": cleanText(maskPhoneNumbers(post.title || '')),
            "description": maskPhoneNumbers(post.description || ''),
            "image": post.images?.length > 0 ? post.images : ["https://indianflatmates.co.uk/logo512.png"],
            "address": {
                "@type": "PostalAddress",
                "addressLocality": cleanText(post.address || ''),
                // The postcode field is free text ("London, UK" etc.) — only use real UK postcodes
                ...(/^[A-Z]{1,2}\d[A-Z\d]?(\s*\d[A-Z]{2})?$/i.test((post.postcode || '').trim()) ? { "postalCode": post.postcode.trim().toUpperCase() } : {}),
                "addressRegion": "London",
                "addressCountry": "GB"
            }
        }
    } : {
        "@context": "https://schema.org",
        "@type": "Person",
        // First name only, matching the page title
        "name": cleanText(post.userName || 'Room seeker').split(' ')[0],
        "description": maskPhoneNumbers(post.requirements || ''),
        "url": pageUrl,
    }) : null;

    return (
        <>
            {listingSchema && (
                <Helmet>
                    <script type="application/ld+json">{JSON.stringify(listingSchema)}</script>
                </Helmet>
            )}
            <div className="container mx-auto">
                 {post && <PostDetailView post={post} isRoomListing={isRoomListing} onStartChat={handleStartChat} />}
                 {post && isRoomListing && <OtherRoomsInArea post={post} />}
            </div>
        </>
    );
}

function LocationPage({ setPageMeta }) {
    const { db } = useContext(AppContext);
    const { location } = useParams();
    const area = areas[location];
    const areaName = areaNameFromSlug(location);

    const [postsForSchema, setPostsForSchema] = useState([]);

    useEffect(() => {
        if (!db || !location) return;

        const fetchTopPosts = async () => {
            const collectionPath = `artifacts/${getFirebaseConfig().appId}/public/data/room_listings`;
            const q = query(
                collection(db, collectionPath),
                orderBy('status', 'asc'),
                orderBy('lastActivity', 'desc'),
                limit(60)
            );
            const snapshot = await getDocs(q);
            // Same matching as BrowsePosts' location filter, so the schema lists this area's rooms only
            const needle = areaName.toLowerCase();
            const fetchedPosts = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(post => `${post.address || ''} ${post.postcode || ''}`.toLowerCase().includes(needle))
                .slice(0, 5);
            setPostsForSchema(fetchedPosts);
        };

        fetchTopPosts();
    }, [db, location, areaName]);


    useEffect(() => {
        if (location) {
            const representativeImage = postsForSchema[0]?.images?.[0] || 'https://indianflatmates.co.uk/logo512.png';
            let description = `Rooms to rent, flatshares and Indian flatmates in ${areaName}, London. ${area ? area.transport : 'Browse listings and message owners directly.'}`;
            if (description.length < 120) description += ' Browse listings and message owners directly.';

            setPageMeta({
                title: `Indian Rooms & Flatmates in ${areaName} | IndianFlatmates`,
                description: description.length > 158 ? description.slice(0, 155).replace(/\s+\S*$/, '') + '...' : description,
                keywords: `rooms in ${areaName}, indian flatmates ${areaName}`,
                url: `https://indianflatmates.co.uk/rooms/${location}`,
                image: representativeImage,
            });
        }
    }, [location, setPageMeta, postsForSchema, area, areaName]);

    const itemListSchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": `Indian Rooms and Flatshares in ${areaName}`,
        "description": `Rooms for rent and flatshares for Indians in ${areaName}, London.`,
        "itemListElement": postsForSchema.map((post, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "@type": "Residence",
                "name": cleanText(post.title),
                "description": post.description,
                "image": post.images?.[0] || 'https://indianflatmates.co.uk/room.jpeg',
                "url": `https://indianflatmates.co.uk/room/${slugify(post.title)}-id-${post.id}`,
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": cleanText(post.address),
                    "addressRegion": "London",
                    "postalCode": post.postcode,
                    "addressCountry": "UK"
                }
            }
        }))
    };

    return (
        <>
            {postsForSchema.length > 0 && (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(itemListSchema)}
                    </script>
                </Helmet>
            )}

            <div className="container mx-auto p-4">
                <div className="mb-6 text-center">
                    <h1 className="text-2xl md:text-3xl font-bold text-indigo-700 dark:text-indigo-300 mb-3">
                        Rooms and Indian flatmates in {areaName}
                    </h1>
                    {area && (
                        <div className="max-w-3xl mx-auto text-gray-700 dark:text-gray-300 space-y-2">
                            <p>{area.intro}</p>
                            <p className="text-sm text-gray-600 dark:text-gray-400">🚇 {area.transport}</p>
                            <p className="text-sm">
                                <Link to="/indian-areas-in-london" className="text-indigo-600 dark:text-indigo-400 hover:underline">
                                    Compare the best areas for Indians in London →
                                </Link>
                            </p>
                        </div>
                    )}
                </div>
                <BrowsePosts isPublicView={true} locationFilter={location} hideHeader />

                {area && (
                    <section className="mt-10 bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 md:p-8 text-gray-700 dark:text-gray-300">
                        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">Renting a room in {areaName}: what to check</h2>
                        <ul className="list-disc list-inside space-y-2 mb-6">
                            <li><strong>What the rent covers</strong> — ask whether bills (gas, electricity, water, broadband) and council tax are included. They often are for rooms, but not always.</li>
                            <li><strong>Right to Rent</strong> — in England, landlords must check that you have the right to rent, so keep your passport and eVisa share code ready.</li>
                            <li><strong>Deposit protection</strong> — on an assured shorthold tenancy, your deposit must be protected in a government-approved scheme. Different rules apply if you live with your landlord as a lodger.</li>
                            <li><strong>View first</strong> — see the room in person or on a video call, and meet the people you will live with, before paying anything.</li>
                            <li><strong>Your commute</strong> — check the journey from {areaName} to your university or workplace at peak time.</li>
                        </ul>
                        {area.nearby.length > 0 && (
                            <>
                                <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3">Rooms in nearby areas</h2>
                                <ul className="flex flex-wrap gap-2">
                                    {area.nearby.map((slug) => (
                                        <li key={slug}>
                                            <Link
                                                to={`/rooms/${slug}`}
                                                className="inline-block px-3 py-1.5 rounded-full bg-indigo-50 dark:bg-gray-700 text-indigo-700 dark:text-indigo-300 text-sm font-medium hover:bg-indigo-100 dark:hover:bg-gray-600"
                                            >
                                                Rooms in {areaNameFromSlug(slug)}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </section>
                )}
            </div>
        </>
    );
}

function RoommatesPage({ setPageMeta }) {
    const { db } = useContext(AppContext);
    const [profilesForSchema, setProfilesForSchema] = useState([]);

    useEffect(() => {
        if (!db) return;
        const fetchTop = async () => {
            try {
                const appId = getFirebaseConfig().appId;
                const q = query(
                    collection(db, `artifacts/${appId}/public/data/roommate_requests`),
                    orderBy('status', 'asc'),
                    orderBy('lastActivity', 'desc'),
                    limit(5)
                );
                const snap = await getDocs(q);
                setProfilesForSchema(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (e) {
                console.error('Failed to load roommates schema data:', e);
            }
        };
        fetchTop();
    }, [db]);

    useEffect(() => {
        setPageMeta({
            title: 'Indian Roommates & Flatmate Requests in London',
            description: 'Browse Indian students and professionals looking for rooms and flatmates across London. Post your room to find a compatible roommate fast.',
            keywords: 'Indian roommates London, Indian flatmates wanted London, Telugu roommates London, Tamil roommates London, Indian flatmate seeker, female Indian roommate London, male Indian roommate London, Indian room seeker UK, Desi flatmate search',
            url: 'https://indianflatmates.co.uk/roommates',
            image: 'https://indianflatmates.co.uk/logo512.png',
        });
    }, [setPageMeta]);

    const itemListSchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "Indian Roommates and Flatmate Requests in London",
        "description": "Indian students and professionals looking for rooms and flatmates in London.",
        "itemListElement": profilesForSchema.map((p, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "@type": "Person",
                "name": (p.userName || 'Room Seeker').split(' ')[0],
                "description": p.requirements || p.aboutMe || 'Looking for a room/flatmate in London.',
                "jobTitle": p.profession || undefined,
                "url": `https://indianflatmates.co.uk/roommate/${slugify(p.requirements || p.userName || 'profile')}-id-${p.id}`,
                "homeLocation": p.preferredLocations ? {
                    "@type": "Place",
                    "name": p.preferredLocations,
                    "address": { "@type": "PostalAddress", "addressRegion": "London", "addressCountry": "UK" }
                } : undefined,
            }
        }))
    };

    return (
        <>
            {profilesForSchema.length > 0 && (
                <Helmet>
                    <script type="application/ld+json">{JSON.stringify(itemListSchema)}</script>
                </Helmet>
            )}
            <div className="container mx-auto p-4">
                <BrowsePosts isPublicView={true} initialMode="roommates" />
                <HomeSeoContent variant="roommates" />
            </div>
        </>
    );
}


function HomePage() {
    const {
        userId,
        userRole,
        pendingChatRecipient
    } = useContext(AppContext);

    if (!userId) {
        return (
            <div className="container mx-auto p-4">
                <RoommateTeaserRow />
                <BrowsePosts isPublicView={true} />
                <HomeSeoContent />
            </div>
        );
    }

    if (!userRole) {
        return <div className="flex items-center justify-center h-full"><p>Please select your role to continue...</p></div>;
    }

    return <MainContent pendingChatRecipient={pendingChatRecipient} />;
}
// --- Role Selection Modal ---
function RoleSelectionModal() {
    const { db, userId, userProfile, setUserProfile, setUserRole, setShowRoleModal, setShowPhoneNumberModal, setPendingRole } = useContext(AppContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const showToast = useToast();

    const handleRoleSelect = async (role) => {
        if (!userId || !db) return;
             if (!userProfile?.phoneNumber) {
            setPendingRole(role);
            setShowPhoneNumberModal(true);
            setShowRoleModal(false);
            return; // Stop execution to show phone modal first
        }
        setIsSubmitting(true);
        try {
            const appId = getFirebaseConfig().appId;
            const publicProfileRef = doc(db, `artifacts/${appId}/public/data/user_profiles/${userId}`);
            await setDoc(publicProfileRef, { role }, { merge: true });

            setUserProfile(prevProfile => ({ ...prevProfile, role }));
            setUserRole(role);
            setShowRoleModal(false);
        } catch (error) {
            console.error("Error saving user role:", error);
            showToast('Failed to save user role. Please try again.', 'error');

        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[70]">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg relative p-8">
                <h2 className="text-2xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">
                    Select Your Profile
                </h2>
                <p className="text-center text-gray-600 dark:text-gray-400 mb-6">Please select what you're here to do. This will set up your initial view.</p>
                <div className="flex flex-col sm:flex-row gap-6">
                    <button
                        onClick={() => handleRoleSelect('I Have Room')}
                        disabled={isSubmitting}
                        className="flex-1 flex flex-col items-center p-6 bg-green-500 text-white rounded-xl shadow-lg hover:bg-green-600 transition duration-300 transform hover:scale-105 disabled:opacity-50"
                    >
                        <svg className="w-12 h-12 mb-3" fill="currentColor" viewBox="0 0 20 20"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                        <span className="text-xl font-bold">I Have Room</span>
                        <span className="text-sm mt-1">Offer a room/flat</span>
                    </button>
                    <button
                        onClick={() => handleRoleSelect('I Need Room')}
                        disabled={isSubmitting}
                        className="flex-1 flex flex-col items-center p-6 bg-blue-500 text-white rounded-xl shadow-lg hover:bg-blue-600 transition duration-300 transform hover:scale-105 disabled:opacity-50"
                    >
                        <svg className="w-12 h-12 mb-3" fill="currentColor" viewBox="0 0 20 20"><path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"></path></svg>
                        <span className="text-xl font-bold">I Need Room</span>
                        <span className="text-sm mt-1">Search for a room</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

const InstallPWAButton = ({ installPromptEvent, setInstallPromptEvent }) => {
    const showToast = useToast();
    if (!installPromptEvent) {
        return null;
    }

    const handleInstallClick = async () => {
        installPromptEvent.prompt();
        const { outcome } = await installPromptEvent.userChoice;
        if (outcome === 'accepted') {
            showToast('App installed successfully!', 'success');
        } else {
            showToast('App installation canceled.', 'info');
        }
        setInstallPromptEvent(null);
    };

    return (
        <button
            onClick={handleInstallClick}
            className="fixed bottom-4 right-4 bg-indigo-600 text-white font-bold py-3 px-5 rounded-full shadow-lg hover:bg-indigo-700 transition duration-300 z-50 animate-bounce"
            aria-label="Install App"
        >
            <svg className="w-6 h-6 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
            Install App
        </button>
    );
};
function IosInstallPrompt({ onClose }) {
    return (
        <div className="fixed bottom-0 left-0 right-0 bg-gray-100 dark:bg-gray-800 p-4 border-t-2 border-indigo-500 shadow-lg z-50 text-center">
            <p className="text-sm text-gray-800 dark:text-gray-200 mb-3">
                To install this app on your iPhone, tap the Share button and then 'Add to Home Screen'.
            </p>
            <div className="flex justify-center items-center text-sm text-gray-600 dark:text-gray-400">
                <span>Tap</span>
                <svg className="w-6 h-6 mx-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8m-4-6l-4-4-4 4m4-4v12"></path></svg>
                <span>then</span>
                <svg className="w-6 h-6 mx-2 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path></svg>
                <span>'Add to Home Screen'</span>
            </div>
            <button
                onClick={onClose}
                className="absolute top-1 right-1 p-1 text-gray-500 dark:text-gray-400"
                aria-label="Close"
            >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
            </button>
        </div>
    );
}
function App() {
    const [db, setDb] = useState(null);
    const [auth, setAuth] = useState(null);
    const [storage, setStorage] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null);
    const [totalUnreadCount, setTotalUnreadCount] = useState(0);
    // --- NEW CODE ---
const [isDarkMode, setIsDarkMode] = useState(() => {
  const storedPreference = localStorage.getItem('isDarkMode');
  // If no preference is stored in localStorage, default to dark (true).
  // Otherwise, use the stored preference.
  return storedPreference !== null ? storedPreference === 'true' : true;
});
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [navigationTarget, setNavigationTarget] = useState(null);
    const [chatRecipient, setChatRecipient] = useState(null);
    const [pendingChatRecipient, setPendingChatRecipient] = useState(null);
    const [showRoleModal, setShowRoleModal] = useState(false);
      const [showPhoneNumberModal, setShowPhoneNumberModal] = useState(false); // ✨ ADD THIS
    const [pendingRole, setPendingRole] = useState(null); // ✨ ADD THIS
    const [installPromptEvent, setInstallPromptEvent] = useState(null);
    const [showIosInstallMessage, setShowIosInstallMessage] = useState(false);

    // Premium subscription states
    const [showPricingModal, setShowPricingModal] = useState(false);
    const [showPaymentCheckout, setShowPaymentCheckout] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showPremiumUpsellPopup, setShowPremiumUpsellPopup] = useState(false);
    const [premiumUpsellVariant, setPremiumUpsellVariant] = useState('homepage');
    const [showRenewalPopup, setShowRenewalPopup] = useState(false);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [paymentError, setPaymentError] = useState(null);
    const [pendingPremiumUnlock, setPendingPremiumUnlock] = useState(null);

    const pendingChatRecipientRef = useRef(pendingChatRecipient);
    useEffect(() => {
        pendingChatRecipientRef.current = pendingChatRecipient;
    }, [pendingChatRecipient]);

    const defaultMeta = {
        title: "Indian Roommates & Flatmates in London | Rooms & PG",
        description: "Find your perfect Indian roommates and flatmates in London. Connect with students and professionals for rooms, flat shares, and PG accommodation.",
        url: "https://indianflatmates.co.uk",
        image: "https://indianflatmates.co.uk/logo512.png",
        keywords: ""
    };
    const [pageMeta, setPageMeta] = useState(defaultMeta);
    const { pathname } = useLocation();
    // Every page is its own canonical — without this, pages that don't call
    // setPageMeta inherited the homepage URL and told Google they were duplicates
    const canonicalUrl = `https://indianflatmates.co.uk${pathname.replace(/\/+$/, '')}`;

    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
            event.preventDefault();
            setInstallPromptEvent(event);
        };
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }, []);

    const showToast = useToast();

    useEffect(() => {
        const isIos = () => /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        if (isIos() && !isInStandaloneMode()) {
            setShowIosInstallMessage(true);
        }
    }, []);

    // Handle payment success toast
    useEffect(() => {
        if (paymentSuccessful) {
            showToast('Premium subscription activated!', 'success');
            setPaymentSuccessful(false);
        }
    }, [paymentSuccessful, showToast]);

    // Handle payment error toast
    useEffect(() => {
        if (paymentError) {
            showToast(`Payment error: ${paymentError}`, 'error');
            setPaymentError(null);
        }
    }, [paymentError, showToast]);

    // ✨ After login, if user had pending premium unlock, show pricing modal
    useEffect(() => {
        if (userId && pendingPremiumUnlock && !showAuthModal) {
            setShowAuthModal(false);
            setShowPricingModal(true);
            // Keep the pending unlock so it can be used after payment
        }
    }, [userId, pendingPremiumUnlock, showAuthModal]);

useEffect(() => {
    const firebaseConfig = getFirebaseConfig();
    const firebaseApp = initializeApp(firebaseConfig);
    const firestoreDb = getFirestore(firebaseApp);
    const firebaseAuth = getAuth(firebaseApp);
    const firebaseStorage = getStorage(firebaseApp);

    setDb(firestoreDb);
    setAuth(firebaseAuth);
    setStorage(firebaseStorage);

    const unsubscribe = onAuthStateChanged(firebaseAuth, async (user) => {
        setLoading(true);
        if (user) {
            setUserId(user.uid);
            const appId = firebaseConfig.appId;

            const publicProfileRef = doc(firestoreDb, `artifacts/${appId}/public/data/user_profiles`, user.uid);
            const publicSnap = await getDoc(publicProfileRef);

            let finalProfile = {};

            if (publicSnap.exists()) {
                finalProfile = publicSnap.data();
            } else {
                // First login — create public profile from Firebase auth data
                finalProfile = {
                    name: user.displayName || '',
                    email: user.email || '',
                    phoneNumber: user.phoneNumber || '',
                    userId: user.uid,
                    createdAt: serverTimestamp(),
                    isAdmin: false,
                    isPremium: false,
                };
                await setDoc(publicProfileRef, finalProfile);
            }

            finalProfile.email = finalProfile.email || user.email;
            finalProfile.name = finalProfile.name || user.displayName;

            setUserProfile(finalProfile);

            const currentPendingChat = pendingChatRecipientRef.current;

            if (currentPendingChat && currentPendingChat.userId !== user.uid) {
                // ✨ FIX: Changed 'profile.role' to 'finalProfile.role'
                if (finalProfile.role) {
                    setUserRole(finalProfile.role);
                    setChatRecipient(currentPendingChat);
                    setPendingChatRecipient(null);
                } else if (finalProfile.isAdmin) {
                    // Admin users - auto-assign "I Have Room"
                    const adminRole = 'I Have Room';
                    try {
                        const appId = getFirebaseConfig().appId;
                        const publicProfileRef = doc(firestoreDb, `artifacts/${appId}/public/data/user_profiles/${user.uid}`);
                        await setDoc(publicProfileRef, { role: adminRole }, { merge: true });

                        setUserProfile(prev => ({ ...prev, role: adminRole }));
                        setUserRole(adminRole);

                        setChatRecipient(currentPendingChat);
                        setPendingChatRecipient(null);
                    } catch (error) {
                        console.error("Error auto-setting admin role:", error);
                        setShowRoleModal(true);
                    }
                } else {
                    const roleToSet = 'I Need Room';
                    try {
                        const appId = getFirebaseConfig().appId;
                        const publicProfileRef = doc(firestoreDb, `artifacts/${appId}/public/data/user_profiles/${user.uid}`);
                        await setDoc(publicProfileRef, { role: roleToSet }, { merge: true });

                        setUserProfile(prev => ({ ...prev, role: roleToSet }));
                        setUserRole(roleToSet);

                        setChatRecipient(currentPendingChat);
                        setPendingChatRecipient(null);
                    } catch (error) {
                        console.error("Error auto-setting user role:", error);
                        setShowRoleModal(true);
                    }
                }
            } else {
                 // ✨ FIX: Changed 'profile.role' to 'finalProfile.role'
                if (finalProfile.role) {
                    setUserRole(finalProfile.role);
                } else if (finalProfile.isAdmin) {
                    // Admin users don't need to select a role - auto-assign "I Have Room"
                    const adminRole = 'I Have Room';
                    try {
                        const appId = getFirebaseConfig().appId;
                        const publicProfileRef = doc(firestoreDb, `artifacts/${appId}/public/data/user_profiles/${user.uid}`);
                        await setDoc(publicProfileRef, { role: adminRole }, { merge: true });
                        setUserProfile(prev => ({ ...prev, role: adminRole }));
                        setUserRole(adminRole);
                    } catch (error) {
                        console.error("Error auto-setting admin role:", error);
                        setShowRoleModal(true);
                    }
                } else {
                    setShowRoleModal(true);
                }
            }
        } else {
            setUserId(null);
            setUserProfile(null);
            setUserRole(null);
            setPendingChatRecipient(null);
            setChatRecipient(null);
        }
        setLoading(false);
    });
    return () => unsubscribe();
}, [db]); // Keep 'db' in the dependency array

    useEffect(() => {
        if (!db || !userId) {
            setTotalUnreadCount(0);
            return;
        }
        const q = query(collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/conversations`), where('participants', 'array-contains', userId));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            let totalCount = 0;
            snapshot.forEach(doc => {
                totalCount += doc.data().unreadCount?.[userId] || 0;
            });
            setTotalUnreadCount(totalCount);
        });
        return () => unsubscribe();
    }, [db, userId]);

    useEffect(() => {
        localStorage.setItem('userRole', userRole || '');
    }, [userRole]);

    useEffect(() => {
        document.documentElement.classList.toggle('dark', isDarkMode);
        localStorage.setItem('isDarkMode', isDarkMode);
    }, [isDarkMode]);

    const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

    // Check for premium popups when user profile loads
    useEffect(() => {
        if (!userId || !userProfile) return;

        // Check if should show upsell popup (on homepage for non-premium users)
        if (shouldShowUpsellPopup(userId, userProfile.isPremium)) {
            setShowPremiumUpsellPopup(true);
            setPremiumUpsellVariant('homepage');
        }

        // Check if should show renewal popup (10 days before expiry)
        if (userProfile.subscriptionEndDate && shouldShowRenewalPopup(userProfile.subscriptionEndDate, userId)) {
            setShowRenewalPopup(true);
        }
    }, [userId, userProfile]);

    const handleStartChat = (post) => {
        if (!userId) {
            setPendingChatRecipient(post);
            setShowAuthModal(true);
        } else {
            setChatRecipient(post);
        }
    };

    // Premium payment handlers
    const handleSelectPlan = (plan) => {
        setSelectedPlan(plan);
        setShowPricingModal(false);
        setShowPaymentCheckout(true);
    };

    const handlePaymentSuccess = (result) => {
        setShowPaymentCheckout(false);
        setSelectedPlan(null);
        setShowPremiumUpsellPopup(false);
        setShowRenewalPopup(false);
        setPaymentSuccessful(true);

        // Refresh user profile to get updated premium status from Firestore
        if (userId && db) {
            setTimeout(() => {
                const appId = getFirebaseConfig().appId;
                const userProfileRef = doc(db, `artifacts/${appId}/public/data/user_profiles/${userId}`);
                getDoc(userProfileRef, { source: 'server' }).then(docSnap => {
                    if (docSnap.exists()) {
                        setUserProfile(docSnap.data());
                    }
                }).catch(err => console.error('Error refreshing user profile:', err));
            }, 1000);
        }
    };

    const handlePaymentCancel = () => {
        setShowPaymentCheckout(false);
        setSelectedPlan(null);
    };

    const handlePremiumUpsellClose = () => {
        setShowPremiumUpsellPopup(false);
        dismissUpsellPopup(userId);
    };

    const handleRenewalPopupClose = () => {
        setShowRenewalPopup(false);
        dismissRenewalPopup(userId);
    };

    const handleUpsellSelectPlan = (plan) => {
        setShowPremiumUpsellPopup(false);
        handleSelectPlan(plan);
    };

      const authorOrganization = {
        "@type": "Organization",
        "name": "IndianFlatmates",
        "url": "https://indianflatmates.co.uk"
    };

    const webSiteSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": "https://indianflatmates.co.uk/#website",
        "name": "IndianFlatmates",
        "url": "https://indianflatmates.co.uk",
        "publisher": authorOrganization
    };

    const organizationSchema = {
        "@context": "https://schema.org",
        ...authorOrganization,
        "logo": "https://indianflatmates.co.uk/logo512.png",
        "description": "Rooms, flatmates and community services for Indians in London and the UK.",
        "areaServed": { "@type": "Country", "name": "United Kingdom" },
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+91-97034-91968"
        }
    };

    if (loading) {
        return <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900"><div className="text-lg font-semibold">Loading...</div></div>;
    }

    if (error) {
        return <div className="flex items-center justify-center min-h-screen bg-red-100 dark:bg-red-900"><div className="text-lg font-semibold">Error: {error}</div></div>;
    }

    return (
        <AppContext.Provider value={{
            db, auth, storage, userId, userProfile, setUserProfile, userRole, setUserRole,
            isDarkMode, toggleDarkMode, showAuthModal, setShowAuthModal, navigationTarget, setNavigationTarget,
            totalUnreadCount, showRoleModal, setShowRoleModal, chatRecipient, setChatRecipient,
            pendingChatRecipient, handleStartChat, showPhoneNumberModal, setShowPhoneNumberModal,
            pendingRole, setPendingRole,
            // Premium related
            showPricingModal, setShowPricingModal, showPaymentCheckout, setShowPaymentCheckout,
            selectedPlan, setSelectedPlan, handleSelectPlan, handlePaymentSuccess, handlePaymentCancel,
            pendingPremiumUnlock, setPendingPremiumUnlock
        }}>
            <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-300 flex flex-col">
                <Helmet>
                    <title>{pageMeta.title}</title>
                    <meta name="description" content={pageMeta.description} />
                    <meta name="keywords" content={`Indian flatmates London${pageMeta.keywords ? ', ' + pageMeta.keywords : ''}, Indian roommates London, Telugu roommates London, female Indian flatmates London, South Indian flatmates London, Indian roommates, Indian room share UK, Desi accommodation London, Indian rent room London, flat share for Indians, Tamil flatmates, rooms for Indian girls London, room in East Ham, shared accommodation, Paying guest (PG), Indian Flatmates, female, male, need room, have room`} />
                    <link rel="canonical" href={canonicalUrl} />
                    <meta property="og:title" content={pageMeta.title} />
                    <meta property="og:description" content={pageMeta.description} />
                    <meta property="og:image" content={pageMeta.image} />
                    <meta property="og:url" content={canonicalUrl} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={pageMeta.title} />
                    <meta name="twitter:description" content={pageMeta.description} />
                    <meta name="twitter:image" content={pageMeta.image} />
                    {/* Site-level schema belongs on the homepage only */}
                    {pathname === '/' && <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>}
                    {pathname === '/' && <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>}
                </Helmet>

                <Routes>
                    <Route path="/" element={<AppLayout />}>
                        <Route index element={<HomePage />} />
                        <Route path="/rooms/:location" element={<LocationPage setPageMeta={setPageMeta} />} />
                        <Route path="/room/:slug" element={<PostDetailPage setPageMeta={setPageMeta} />} />
                        <Route path="/roommate/:slug" element={<PostDetailPage setPageMeta={setPageMeta} />} />
                        <Route path="roommates" element={<RoommatesPage setPageMeta={setPageMeta} />} />
                        <Route path="airport-cabs" element={<AirportCabs />} />
                        <Route path="visa-and-immigration-support" element={<VisaImmigration />} />
                        <Route path="money-transfer-to-india" element={<MoneyTransfer />} />
                        <Route path="uk-jobs-for-indians" element={<FindJobs />} />
                        <Route path="cv-and-interview-help" element={<CVHelp />} />
                        <Route path="mortgages-for-indians" element={<IndianMortgages />} />
                        <Route path="uk-tour-trips" element={<UkTourTrips />} />
                        <Route path="indian-events-and-festivals" element={<IndianFestivals />} />
                        <Route path="partner-with-us" element={<PartnerWithUs />} />
                        <Route path="it-courses-and-certifications" element={<ITCourses />} />
                        <Route path="student-admissions-uk" element={<StudentAdmissions />} />
                        <Route path="/indian-areas-in-london" element={<LondonAreasGuide />} />
                        <Route path="/top-london-attractions" element={<LondonAttractions />} />
                        <Route path="uk-essentials-for-indians" element={<UkEssentials />} />
                        <Route path="first-week-in-uk-checklist" element={<FirstWeekUK />} />
                        <Route path="nri-matrimonials-uk" element={<NRIMatrimonials />} />
                        <Route path="indian-matrimony-uk" element={<NRIMatrimonials />} />
                        <Route path="find-indian-partner-uk" element={<NRIMatrimonials />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                </Routes>
                {showRoleModal && <RoleSelectionModal />}
                {showPhoneNumberModal && <PhoneNumberModal />}
                {showAuthModal && <AuthModal />}

                {/* Premium subscription modals */}
                {showPricingModal && (
                    <PricingModal
                        isOpen={showPricingModal}
                        onClose={() => setShowPricingModal(false)}
                        onSelectPlan={handleSelectPlan}
                        userCurrentPlan={userProfile?.subscriptionPlan}
                        subscriptionEndDate={userProfile?.subscriptionEndDate}
                    />
                )}
                {showPaymentCheckout && selectedPlan && (
                    <PaymentCheckout
                        plan={selectedPlan}
                        onSuccess={handlePaymentSuccess}
                        onCancel={handlePaymentCancel}
                        onError={(err) => {
                            setPaymentError(err);
                            handlePaymentCancel();
                        }}
                    />
                )}
                {showPremiumUpsellPopup && (
                    <PremiumUpsellPopup
                        isOpen={showPremiumUpsellPopup}
                        onClose={handlePremiumUpsellClose}
                        onSelectPlan={handleUpsellSelectPlan}
                        variant={premiumUpsellVariant}
                    />
                )}
                {showRenewalPopup && (
                    <PremiumUpsellPopup
                        isOpen={showRenewalPopup}
                        onClose={handleRenewalPopupClose}
                        onSelectPlan={handleSelectPlan}
                        variant="renewal"
                    />
                )}
            </div>
            <InstallPWAButton installPromptEvent={installPromptEvent} setInstallPromptEvent={setInstallPromptEvent} />
            {showIosInstallMessage && <IosInstallPrompt onClose={() => setShowIosInstallMessage(false)} />}
        </AppContext.Provider>
    );
}
// ✨ NEW COMPONENT: PhoneNumberModal
function PhoneNumberModal() {
    const { db, userId, userProfile, setUserProfile, setUserRole, setShowPhoneNumberModal, pendingRole } = useContext(AppContext);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const showToast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!phoneNumber.trim()) {
            showToast('Please enter a valid phone number.', 'error');
            return;
        }
        if (!userId || !db || !pendingRole) {
            showToast('An unexpected error occurred. Please try again.', 'error');
            return;
        }

        setIsSubmitting(true);
        try {
            const appId = getFirebaseConfig().appId;
            const publicProfileRef = doc(db, `artifacts/${appId}/public/data/user_profiles/${userId}`);
            const dataToUpdate = { role: pendingRole, phoneNumber };
            await setDoc(publicProfileRef, dataToUpdate, { merge: true });

            const updatedProfile = { ...userProfile, ...dataToUpdate };
            setUserProfile(updatedProfile);
            setUserRole(pendingRole);
            setShowPhoneNumberModal(false);
            showToast('Profile updated successfully!', 'success');

        } catch (error) {
            console.error("Error saving phone number and role:", error);
            showToast('Failed to save details. Please try again.', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[70]">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md relative p-8">
                <h2 className="text-2xl font-bold mb-4 text-indigo-700 dark:text-indigo-300 text-center">
                    One Last Step
                </h2>
                <p className="text-center text-gray-600 dark:text-gray-400 mb-6">
                    Please provide your phone number to continue. This is required for verification and communication.
                </p>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="phone-modal" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Phone Number</label>
                        <input
                            type="tel"
                            id="phone-modal"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            required
                            placeholder="e.g., +44 7123 456789"
                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full mt-6 py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                    >
                        {isSubmitting ? 'Saving...' : 'Save and Continue'}
                    </button>
                </form>
            </div>
        </div>
    );
}

function Header() {
    const { userProfile, userRole, setUserRole, setNavigationTarget, isDarkMode, toggleDarkMode, auth, totalUnreadCount, userId, setShowAuthModal, setShowPricingModal, setSelectedPlan } = useContext(AppContext);
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogout = async () => {
        await signOut(auth);
        setUserRole(null);
    };

    const handleSwitchRole = () => {
        setUserRole(userRole === 'I Have Room' ? 'I Need Room' : 'I Have Room');
        setMenuOpen(false);
    };

      return (
        <header className="bg-white dark:bg-gray-800 shadow-md px-3 py-2 sm:p-4 flex justify-between items-center gap-2 sticky top-0 z-40">
            <Link to="/" className="flex items-center shrink-0" aria-label="Indian Flatmates home">
                <img
                    // 80px copies of the 1024px logos (~3 KB instead of ~40 KB); shown at 32-40px
                    src={!isDarkMode ? "/logo_white_80.png" : "/logo_black_80.png"}
                    alt="Indian Flatmates Logo"
                    width="40"
                    height="40"
                    className="h-8 sm:h-10 w-auto mr-2 sm:mr-3"
                />
                {/* Not an h1: each page has its own main heading */}
                <span className="hidden min-[360px]:inline text-lg sm:text-2xl font-bold text-indigo-600 dark:text-indigo-400 whitespace-nowrap">Indian Flatmates</span>
            </Link>

            {/* ✨ MIDDLE: Go Premium Button or Premium Badge */}
            {userId && !userProfile?.isPremium && (
                <button
                    onClick={() => {
                        setSelectedPlan('1-month');
                        setShowPricingModal(true);
                    }}
                    className="flex items-center space-x-2 px-3 py-2 sm:px-4 sm:py-2 bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-white font-bold text-sm sm:text-base rounded-lg shadow-md transition duration-200"
                >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                    <span className="hidden sm:inline">Go Premium</span>
                    <span className="sm:hidden">Premium</span>
                </button>
            )}
            {userId && userProfile?.isPremium && (
                <div className="flex items-center space-x-2 px-3 py-2 sm:px-4 sm:py-2 bg-gradient-to-r from-green-400 to-emerald-500 text-white font-bold text-sm sm:text-base rounded-lg">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                    <span className="hidden sm:inline">Premium Member</span>
                    <span className="sm:hidden">Premium</span>
                </div>
            )}

            {/* ✨ MODIFIED: Right-side navigation items */}
            <div className="flex items-center space-x-2 sm:space-x-4">
                <a
                    href="https://wa.me/919703491968?text=Hi!%20I%20have%20a%20query%20from%20the%20IndianFlatmates.co.uk%20website."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-full bg-green-500 hover:bg-green-600 text-white transition duration-200"
                    aria-label="Contact on WhatsApp"
                >
                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.267.651 4.383 1.803 6.166l-1.225 4.469 4.575-1.201zM18.33 14.229c-.301-.15-1.767-.867-2.04-.967-.272-.1-.47-.15-.67.15-.197.299-.771.966-.944 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.299-.018-.462.13-.611.134-.133.297-.347.446-.52.15-.174.199-.299.298-.498.1-.199.05-.374-.025-.524-.075-.15-.67-1.612-.916-2.206-.242-.58-.487-.5-.67-.506-.183-.006-.38-.006-.579-.006-.199 0-.523.074-.797.373-.273.3-.981.957-.981 2.322 0 1.365 1.007 2.699 1.157 2.897.149.199 1.958 3.024 4.793 4.22 2.836 1.196 2.836.797 3.344.746.508-.05 1.767-.717 2.016-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.199-.57-.347z"/></svg>
                </a>
                <button onClick={toggleDarkMode} className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition duration-200" aria-label="Toggle dark mode">
                    {isDarkMode ? '☀️' : '🌙'}
                </button>
                {userRole && (
                    <button onClick={() => setNavigationTarget('messages')} className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition duration-200 relative" aria-label="Messages">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                        {totalUnreadCount > 0 && (
                            <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                                {totalUnreadCount > 9 ? '9+' : totalUnreadCount}
                            </span>
                        )}
                    </button>
                )}
                {!userId && (
                    <button
                        onClick={() => setShowAuthModal(true)}
                        className="px-3 sm:px-4 py-2 text-sm font-semibold rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition duration-200 whitespace-nowrap"
                    >
                        <span className="sm:hidden">Login</span>
                        <span className="hidden sm:inline">Login / Register</span>
                    </button>
                )}
                {userProfile && (
                     <div className="relative">
                        <button onClick={() => setMenuOpen(!menuOpen)} className="w-10 h-10 bg-indigo-500 text-white flex items-center justify-center rounded-full font-bold text-lg hover:bg-indigo-600 transition">
                            {getInitials(userProfile.name)}
                        </button>
                        {menuOpen && (
                            <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-700 rounded-md shadow-lg py-1 z-50 ring-1 ring-black ring-opacity-5">
                                <div className="px-4 py-3 border-b dark:border-gray-600">
                                    <p className="text-sm text-gray-600 dark:text-gray-300">Signed in as</p>
                                    <div className="flex items-center justify-between mt-1">
                                        <p className="font-semibold text-gray-800 dark:text-gray-100 truncate">{userProfile.name}</p>
                                        <div className="flex gap-1 ml-2">
                                            {userProfile?.isAdmin && (
                                                <span className="inline-block bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 px-2 py-1 rounded text-xs font-bold whitespace-nowrap">
                                                    👑 Admin
                                                </span>
                                            )}
                                            {userProfile?.isPremium && (
                                                <span className="inline-block bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 px-2 py-1 rounded text-xs font-bold whitespace-nowrap">
                                                    ⭐ Premium
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="py-1">
                                    {userProfile?.isAdmin && (
                                        <button
                                            onClick={() => {
                                                setNavigationTarget('dashboard');
                                                setMenuOpen(false);
                                            }}
                                            className="w-full text-left flex items-center space-x-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.602-3.751A11.959 11.959 0 0112 2.75c-2.132 0-4.14-.609-5.85-1.655z"></path></svg>
                                            <span>Admin Dashboard</span>
                                        </button>
                                    )}
                                    <button onClick={handleSwitchRole} className="w-full text-left flex items-center space-x-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path></svg>
                                        <span>{userRole === 'I Have Room' ? 'Switch to Finding Room' : 'Switch to Offering Room'}</span>
                                    </button>
                                    <button onClick={handleLogout} className="w-full text-left flex items-center space-x-3 px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-800">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                                        <span>Logout</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
}
// --- Role Selection Component ---
function RoleSelection() {
    const { userId, userProfile, setUserRole, setShowAuthModal, setPendingRole } = useContext(AppContext);

    const handleRoleSelect = (role) => {
        if (!userId || !userProfile?.name || !userProfile?.email) {
            setPendingRole(role);
            setShowAuthModal(true);
        } else {
            setUserRole(role);
        }
    };
    return (
        <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-4">
            <h2 className="text-3xl font-semibold mb-8 text-center text-indigo-700 dark:text-indigo-300">
                Indian Flatmates: Find & Share Flats or Rooms in London, UK
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-10 text-center max-w-xl">
                Are you an Indian student or professional looking for a flat, room, or roommate in London or other UK cities? Or do you have a room to offer? Connect with students and professionals here!
            </p>

            <div className="text-center mb-8">
                <p className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                    WhatsApp us for any help or queries
                </p>
                <a
                    href="https://wa.me/919703491968?text=Hi!%20I%20have%20a%20query%20from%20the%20IndianFlatmates.co.uk%20website."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center mt-2 px-5 py-2 rounded-full bg-green-500 hover:bg-green-600 text-white font-semibold transition duration-200 shadow-md"
                    aria-label="Contact on WhatsApp"
                >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                         <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.267.651 4.383 1.803 6.166l-1.225 4.469 4.575-1.201zM18.33 14.229c-.301-.15-1.767-.867-2.04-.967-.272-.1-.47-.15-.67.15-.197.299-.771.966-.944 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.299-.018-.462.13-.611.134-.133.297-.347.446-.52.15-.174.199-.299.298-.498.1-.199.05-.374-.025-.524-.075-.15-.67-1.612-.916-2.206-.242-.58-.487-.5-.67-.506-.183-.006-.38-.006-.579-.006-.199 0-.523.074-.797.373-.273.3-.981.957-.981 2.322 0 1.365 1.007 2.699 1.157 2.897.149.199 1.958 3.024 4.793 4.22 2.836 1.196 2.836.797 3.344.746.508-.05 1.767-.717 2.016-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.199-.57-.347z"/>
                    </svg>
                    WhatsApp us
                </a>
            </div>

            <div className="flex space-x-6">
                <button
                    onClick={() => handleRoleSelect('I Have Room')}
                    className="flex flex-col items-center p-6 bg-green-500 text-white rounded-xl shadow-lg hover:bg-green-600 transition duration-300 transform hover:scale-105"
                >
                    <svg className="w-12 h-12 mb-3" fill="currentColor" viewBox="0 0 20 20"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                    <span className="text-xl font-bold">I Have Room</span>
                    <span className="text-sm mt-1">Offer a room/flat</span>
                </button>
                <button
                    onClick={() => handleRoleSelect('I Need Room')}
                    className="flex flex-col items-center p-6 bg-blue-500 text-white rounded-xl shadow-lg hover:bg-blue-600 transition duration-300 transform hover:scale-105"
                >
                    <svg className="w-12 h-12 mb-3" fill="currentColor" viewBox="0 0 20 20"><path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"></path></svg>
                    <span className="text-xl font-bold">I Need Room</span>
                    <span className="text-sm mt-1">Search for a room</span>
                </button>
            </div>
            <div className="mt-12 max-w-4xl px-4 text-gray-700 dark:text-gray-300 space-y-8">
                <h2 className="text-3xl font-bold text-center text-indigo-700 dark:text-indigo-300">
                    Your One-Stop Solution for Indian Accommodation in the UK
                </h2>
                <p className="text-lg leading-relaxed text-center">
                    Finding the perfect flatmate or a room to rent in a new country can be challenging, especially when you're looking for someone who shares your culture and lifestyle. At IndianFlatmates, we make this process seamless and stress-free. Whether you're an Indian student starting university in a new city or a professional relocating for a job, our platform connects you with a trusted community of like-minded individuals.
                </p>
                <hr className="border-gray-300 dark:border-gray-600 my-8" />
                <div className="grid md:grid-cols-2 gap-8">
                    <div>
                        <h3 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">For Indian Students & Professionals</h3>
                        <p className="mb-4">
                            Searching for "Indian roommates in London," "room to rent for Indian student in Manchester," or "flat share in Slough for Indian professionals"? You've come to the right place. Our listings are tailored to the needs of the Indian community in the UK, helping you find:
                        </p>
                        <ul className="list-disc list-inside space-y-1 pl-4">
                            <li>Find your ideal room to rent today, including PG accommodations and flatshares with fellow Indians.</li>
                            <li>Ideal for Telugu, Tamil, and other South & north Indian communities.</li>
                            <li>Accommodation near East London and other universities </li>
                            <li>Flats with amenities like a washing machine, and bills included.</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">For Those with a Room to Offer</h3>
                        <p className="mb-4">
                            If you have a spare room and want to find a responsible Indian flatmate, such as a female professional or a Telugu student, our platform is for you. Create a free listing to connect with thousands of potential roommates searching for:
                        </p>
                        <ul className="list-disc list-inside space-y-1 pl-4">
                            <li>Long-term or short-term tenants.</li>
                            <li>Students or young professionals.</li>
                            <li>Flatmates who share similar values and habits.</li>
                            <li>Someone from a specific city or region in India (e.g., Andhra Pradesh, Telangana, Hyderabad, Punjab, Mumbai, Delhi).</li>
                        </ul>
                    </div>
                </div>
                <hr className="border-gray-300 dark:border-gray-600 my-8" />
                <div className="text-center">
                    <p className="font-semibold text-xl mb-4">
                        Join our trusted community and make your move to the UK easier.
                    </p>
                    <p className="text-sm">
                        Connect, chat, and find your next home with IndianFlatmates.
                    </p>
                </div>
            </div>
        </div>
    );
}

function AuthModal() {
    const { db, auth, setUserProfile, setShowAuthModal } = useContext(AppContext);
    const [isLogin, setIsLogin] = useState(true);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const appId = getFirebaseConfig().appId;

    const handleClose = () => {
        setShowAuthModal(false);
    };
    const showToast = useToast();
    const handleAuthAction = async (e) => {
        e.preventDefault();
        setMessage('');
        setLoading(true);

        try {
            let userCredential;
            if (isLogin) {
                userCredential = await signInWithEmailAndPassword(auth, email, password);
            } else {
                userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const newUserId = userCredential.user.uid;
                const profileData = {
                    name,
                    email,
                    phoneNumber,
                    createdAt: serverTimestamp(),
                    userId: newUserId,
                    isAdmin: false,
                    isPremium: false,
                };
                const publicProfileRef = doc(db, `artifacts/${appId}/public/data/user_profiles/${newUserId}`);
                await setDoc(publicProfileRef, profileData);

                setUserProfile(profileData);
            }
            setShowAuthModal(false);
        } catch (error) {
            console.error("Auth error:", error);
            const userMessage = getAuthErrorMessage(error.code);
            setMessage(userMessage);
            showToast(userMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSignIn = async () => {
        setMessage('');
        setLoading(true);
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const newUserId = user.uid;

            const publicProfileRef = doc(db, `artifacts/${appId}/public/data/user_profiles/${newUserId}`);
            const docSnap = await getDoc(publicProfileRef);

            if (!docSnap.exists()) {
                const profileData = {
                    name: user.displayName || '',
                    email: user.email || '',
                    phoneNumber: user.phoneNumber || '',
                    createdAt: serverTimestamp(),
                    userId: newUserId,
                    isAdmin: false,
                    isPremium: false,
                };
                await setDoc(publicProfileRef, profileData);
                setUserProfile(profileData);
            } else {
                setUserProfile(docSnap.data());
            }
            setShowAuthModal(false);
        } catch (error) {
        console.error("Google Sign-In error:", error);
        const userMessage = getAuthErrorMessage(error.code);
        setMessage(userMessage);
        showToast(userMessage, 'error'); // Error toast
        } finally {
            setLoading(false);
        }
    };

    if (showForgotPassword) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md relative p-6">
                    <button
                        onClick={() => setShowForgotPassword(false)}
                        className="absolute top-3 right-3 p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                        aria-label="Close"
                    >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    </button>
                    <h2 className="text-2xl font-bold mb-2 text-indigo-700 dark:text-indigo-300 text-center">
                        Reset Password
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 text-center mb-6 text-sm">
                        Enter your email and we'll send you a reset link
                    </p>

                    <div className="space-y-4">
                        <div>
                            <label htmlFor="reset-email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email Address</label>
                            <input
                                type="email"
                                id="reset-email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="you@example.com"
                                className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            />
                        </div>
                        <button
                            onClick={async () => {
                                setMessage('');
                                setLoading(true);
                                try {
                                    const { sendPasswordResetEmail } = await import('firebase/auth');
                                    await sendPasswordResetEmail(auth, email);
                                    setMessage('✓ Reset link sent! Check your email.');
                                    setEmail('');
                                    setTimeout(() => setShowForgotPassword(false), 2000);
                                } catch (error) {
                                    let errorMessage = 'Error sending reset email';
                                    if (error.code === 'auth/user-not-found') {
                                        errorMessage = 'No account found with this email';
                                    } else if (error.code === 'auth/invalid-email') {
                                        errorMessage = 'Please enter a valid email';
                                    }
                                    setMessage(errorMessage);
                                } finally {
                                    setLoading(false);
                                }
                            }}
                            disabled={loading || !email}
                            className="w-full py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                        {message && (
                            <div className={`p-3 rounded-md text-sm ${
                                message.includes('✓')
                                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                                    : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                            }`}>
                                {message}
                            </div>
                        )}
                        <button
                            type="button"
                            onClick={() => setShowForgotPassword(false)}
                            className="w-full text-indigo-600 dark:text-indigo-400 hover:underline text-sm"
                        >
                            Back to Login
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md relative p-6">
                <button
                    onClick={handleClose}
                    className="absolute top-3 right-3 p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                </button>
                <h2 className="text-2xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">
                    {isLogin ? 'Log In' : 'Register'}
                </h2>
                {message && (
                    <div className={`p-3 mb-4 rounded-md ${message.includes('successful') ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'}`}>
                        {message}
                    </div>
                )}
                <form onSubmit={handleAuthAction} className="space-y-4">
                    {!isLogin && (
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Name</label>
                            <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} required={!isLogin} className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
                        </div>
                    )}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
                        <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
                    </div>
                    <div>
                        <div className="flex justify-between items-center">
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Password</label>
                            {isLogin && (
                                <button
                                    type="button"
                                    onClick={() => setShowForgotPassword(true)}
                                    className="text-xs text-indigo-600 dark:text-indigo-400 hover:underline"
                                >
                                    Forgot?
                                </button>
                            )}
                        </div>
                        <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
                    </div>
                    {!isLogin && (
 <div>
                            {/* ✨ MODIFICATION START: Make phone number required */}
                            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Phone Number</label>
                            <input
                               type="tel"
                               id="phoneNumber"
                               value={phoneNumber}
                               onChange={(e) => setPhoneNumber(e.target.value)}
                               required // This makes the field mandatory
                               className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                           />
                           {/* ✨ MODIFICATION END */}
                        </div>
                    )}
                    <button type="submit" disabled={loading} className="w-full py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                        {loading ? 'Processing...' : (isLogin ? 'Log In' : 'Register')}
                    </button>
                </form>
                <div className="mt-4 text-center">
                    <button onClick={() => setIsLogin(!isLogin)} className="text-indigo-600 dark:text-indigo-400 hover:underline text-sm">
                        {isLogin ? 'Need an account? Register' : 'Already have an account? Log In'}
                    </button>
                </div>
                <div className="mt-6 flex flex-col space-y-3">
                    <button onClick={handleGoogleSignIn} disabled={loading} className="w-full py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 transition duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed">
                        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5 mr-2" />
                        {loading ? '...' : 'Sign in with Google'}
                    </button>
                </div>
            </div>
        </div>
    );
}
// In App.js
function MainContent({ locationFilter, pendingChatRecipient }) { // Now receives pendingChatRecipient
    // ✨ 1. CALL ALL HOOKS UNCONDITIONALLY AT THE TOP
    const { db, userRole, userId, setUserRole, navigationTarget, setNavigationTarget, userProfile  } = useContext(AppContext);
    const showToast = useToast();
    const [view, setView] = useState(() => {
        if (userProfile?.isAdmin) {
            return 'dashboard';
        }
        return userRole === 'I Have Room' ? 'browse-roommates' : 'browse-rooms';
    });

    const [postCount, setPostCount] = useState(0);
    const [checkingPostLimit, setCheckingPostLimit] = useState(true);
    const [transientMessage, setTransientMessage] = useState(null);
    const [showWelcome, setShowWelcome] = useState(false);
    const [showFillNudge, setShowFillNudge] = useState(false);
    const [newListingUrl, setNewListingUrl] = useState(null);

    const handleSuccess = (message, details) => {
        setTransientMessage({ text: message, type: 'success' });
        if (userRole === 'I Have Room' && typeof message === 'string' && message.toLowerCase().includes('listing created')) {
            setNewListingUrl(details?.listingUrl || null);
            setShowFillNudge(true);
        }
              if (pendingChatRecipient) {
            // The main App component's useEffect will handle opening the chat.
            // We just need to avoid overriding the view.
            return;
        }
        if (userRole === 'I Have Room') {
            setView('my-listings');
        } else if (userRole === 'I Need Room') {
            setView('browse-rooms');
        }
        setTimeout(() => setTransientMessage(null), 5000);
    };

    // ✨ FIX: Replaced two conflicting useEffects with a single, robust one.
    useEffect(() => {
         if (pendingChatRecipient) {
            return;
        }
        if (!db || !userId || !userRole || userProfile?.isAdmin) {
            if (userProfile?.isAdmin) setView('dashboard');
            return;
        }

        const performInitialCheckAndSetView = async () => {
            const appId = getFirebaseConfig().appId;
            let isNewUser = false;
            let shouldShowWelcomeMessage = false;

            try {
                if (userRole === 'I Need Room') {
                    const roommateRequestRef = doc(db, `artifacts/${appId}/public/data/roommate_requests/${userId}`);
                    const docSnap = await getDoc(roommateRequestRef);
                    if (!docSnap.exists()) {
                        isNewUser = true;
                        setView('my-profile'); // Redirect to profile form
                        if (!sessionStorage.getItem('welcome_I Need Room')) {
                            shouldShowWelcomeMessage = true;
                            sessionStorage.setItem('welcome_I Need Room', 'true');
                        }
                    }
                } else if (userRole === 'I Have Room') {
                    const listingsQuery = query(
                        collection(db, `artifacts/${appId}/public/data/room_listings`),
                        where('userId', '==', userId),
                        limit(1)
                    );
                    const querySnapshot = await getDocs(listingsQuery);
                    if (querySnapshot.empty) {
                        isNewUser = true;
                        setView('create-listing'); // Redirect to listing form
                        if (!sessionStorage.getItem('welcome_I Have Room')) {
                            shouldShowWelcomeMessage = true;
                            sessionStorage.setItem('welcome_I Have Room', 'true');
                        }
                    }
                }

                // If the user is NOT new, set the default view for their role.
                if (!isNewUser) {
                    setView(userRole === 'I Have Room' ? 'browse-roommates' : 'browse-rooms');
                }

                if (shouldShowWelcomeMessage) {
const message = userRole === 'I Need Room'
  ? "Complete your profile to help property owners connect with you easily. Detailed profiles get faster responses and better accommodation options!"
  : "Create your room listing to attract genuine tenants quickly. Clear descriptions, good photos, and accurate details help you find the right tenant faster!";
                    //setShowWelcome(true);
                    showToast(message, 'success');
                }

            } catch (error) {
                console.error("Error during initial user data check:", error);
            }
        };

        performInitialCheckAndSetView();

    }, [db, userId, userRole, userProfile?.isAdmin, pendingChatRecipient]);


    useEffect(() => {
        if (navigationTarget) {
            if (navigationTarget === 'browseListings') {
                setUserRole('I Need Room');
            } else if (navigationTarget === 'createPost') {
                setUserRole('I Have Room');
            } else if (navigationTarget === 'messages') {
                setView('messages');
            } else if (navigationTarget === 'dashboard') {
                setView('dashboard');
            }
            setNavigationTarget(null);
        }
    }, [navigationTarget, setNavigationTarget, setUserRole]);

     const handleCloseMessages = () => {
        // Set the view back to the default based on the user's role
        const defaultView = userRole === 'I Have Room' ? 'browse-roommates' : 'browse-rooms';
        setView(defaultView);
    };

    useEffect(() => {
        if (!db || !userId || userRole !== 'I Have Room') {
            setPostCount(0);
            setCheckingPostLimit(false);
            return;
        }
        setCheckingPostLimit(true);
        const roomListingsRef = collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/room_listings`);
        const q = query(roomListingsRef, where('userId', '==', userId));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setPostCount(snapshot.size);
            setCheckingPostLimit(false);
        }, (err) => {
            console.error("Error fetching user's post count:", err);
            setCheckingPostLimit(false);
        });

        return () => unsubscribe();
    }, [db, userId, userRole]);

    const activeTabClass = "border-indigo-500 text-indigo-600 dark:text-indigo-400";
    const inactiveTabClass = "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:border-gray-300 dark:hover:text-gray-200";

    return (
        <div className="container mx-auto p-4">
            {showWelcome && <WelcomeMessage userRole={userRole} onClose={() => setShowWelcome(false)} />}

            <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
                <nav className="-mb-px flex overflow-x-auto whitespace-nowrap justify-start sm:justify-center space-x-4 sm:space-x-8 scrollbar-hide" aria-label="Tabs">
                    {userProfile?.isAdmin && (
                        <button onClick={() => setView('dashboard')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'dashboard' ? activeTabClass : inactiveTabClass}`}>
                            <span className="sm:hidden">👑 Admin</span>
                            <span className="hidden sm:inline">👑 Admin Dashboard</span>
                        </button>
                    )}
                    {userRole === 'I Have Room' ? (
                        <>
                            <button onClick={() => setView('browse-roommates')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'browse-roommates' ? activeTabClass : inactiveTabClass}`}>
                                <span className="sm:hidden">Browse</span>
                                <span className="hidden sm:inline">Browse Roommates</span>
                            </button>
                            <button onClick={() => setView('my-listings')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'my-listings' ? activeTabClass : inactiveTabClass}`}>
                                <span className="sm:hidden">Listings</span>
                                <span className="hidden sm:inline">My Listings</span>
                            </button>
                            <button onClick={() => setView('create-listing')} disabled={postCount >= 4 || checkingPostLimit} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'create-listing' ? activeTabClass : inactiveTabClass} disabled:opacity-50 disabled:cursor-not-allowed`}>
                                <span className="sm:hidden">+ Create</span>
                                <span className="hidden sm:inline">Create Listing</span>
                                {checkingPostLimit ? ' ...' : postCount >= 4 ? ' (4/4)' : ''}
                            </button>
                            <button onClick={() => setView('fill-my-room')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'fill-my-room' ? activeTabClass : inactiveTabClass}`}>
                                <span className="sm:hidden">🙌 Fill</span>
                                <span className="hidden sm:inline">🙌 Fill For Me</span>
                            </button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setView('browse-rooms')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'browse-rooms' ? activeTabClass : inactiveTabClass}`}>
                                Browse Rooms
                            </button>
                            <button onClick={() => setView('my-profile')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'my-profile' ? activeTabClass : inactiveTabClass}`}>
                                My Profile
                            </button>
                        </>
                    )}
                </nav>
            </div>

            {view === 'browse-rooms' && userRole === 'I Need Room' && <BrowsePosts transientMessage={transientMessage} locationFilter={locationFilter} />}
            {view === 'my-profile' && userRole === 'I Need Room' && <ProfileUpdateForm onSuccess={handleSuccess} />}
            {view === 'browse-roommates' && userRole === 'I Have Room' && <BrowsePosts transientMessage={transientMessage} locationFilter={locationFilter} />}
            {view === 'my-listings' && userRole === 'I Have Room' && <MyPosts onSuccess={handleSuccess} />}
            {view === 'create-listing' && userRole === 'I Have Room' && postCount < 4 && <RoomPostForm onSuccess={handleSuccess} />}
            {view === 'fill-my-room' && userRole === 'I Have Room' && <FillMyRoomView onBack={() => setView('browse-roommates')} />}
            {view === 'messages' && <ChatList onClose={handleCloseMessages} />}
            {view === 'dashboard' && userProfile?.isAdmin && <Dashboard />}

            {view === 'create-listing' && userRole === 'I Have Room' && postCount >= 4 && (
                <div className="text-center py-8 bg-red-100 dark:bg-red-900 rounded-lg text-red-800 dark:text-red-200 max-w-lg mx-auto shadow-md">
                    <h3 className="text-xl font-semibold mb-2">Post Limit Reached</h3>
                    <p>You can have a maximum of 4 active listings at a time. Please delete an existing listing to create a new one.</p>
                </div>
            )}

            {showFillNudge && <FillMyRoomSuccessNudge listingUrl={newListingUrl} onDismiss={() => setShowFillNudge(false)} />}
        </div>
    );
}

// --- Form Section Wrapper ---
const FormSection = ({ title, children }) => (
    <fieldset className="border-t border-gray-200 dark:border-gray-700 pt-5 mt-5 first:mt-0 first:border-t-0 first:pt-0">
        <legend className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">{title}</legend>
        <div className="space-y-6">
            {children}
        </div>
    </fieldset>
);

// ✨ --- NEW: Admin Dashboard Component ---
const StatCard = ({ title, count, isLoading }) => (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">{title}</h3>
        <p className="mt-1 text-3xl font-semibold text-gray-900 dark:text-gray-100">
            {isLoading ? '...' : count}
        </p>
    </div>
);

const AdminTools = () => {
    const { db } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const showToast = useToast();

    const handleSyncProfiles = async () => {
        if (!window.confirm("Are you sure you want to sync all private user profiles to the public collection? This may overwrite existing public profiles.")) {
            return;
        }

        setIsLoading(true);
        setMessage('');
        const appId = getFirebaseConfig().appId;

        try {
            // ✨ FIX: Correctly reference the top-level 'users' collection
            const privateUsersRef = collection(db, `artifacts/${appId}/users`);
            const privateUsersSnapshot = await getDocs(privateUsersRef);

            if (privateUsersSnapshot.empty) {
                showToast("No private user profiles found to sync.", "info");
                setIsLoading(false);
                return;
            }

            const batch = writeBatch(db);
            let profilesSynced = 0;

            for (const userDoc of privateUsersSnapshot.docs) {
                const userId = userDoc.id;
                // ✨ FIX: Corrected path for the private profile subcollection document
                const privateProfileRef = doc(db, `artifacts/${appId}/users/${userId}/user_profile/data`);
                const privateProfileSnap = await getDoc(privateProfileRef);

                if (privateProfileSnap.exists()) {
                    const privateData = privateProfileSnap.data();

                    const publicData = {
                        name: privateData.name || 'Unknown',
                        email: privateData.email || 'No email',
                        userId: userId,
                        createdAt: privateData.createdAt || serverTimestamp(),
                        role: privateData.role || null,
                        isAdmin: privateData.isAdmin || false,
                        isPremium: privateData.isPremium || false,
                    };

                    const publicProfileRef = doc(db, `artifacts/${appId}/public/data/user_profiles`, userId);
                    batch.set(publicProfileRef, publicData, { merge: true });
                    profilesSynced++;
                }
            }

            if (profilesSynced > 0) {
                await batch.commit();
                setMessage(`${profilesSynced} user profiles have been successfully synced.`);
                showToast(`Synced ${profilesSynced} profiles!`, 'success');
            } else {
                setMessage("No valid profiles were found in the private collection to sync.");
                showToast("No profiles to sync.", "info");
            }

        } catch (error) {
            console.error("Error syncing user profiles:", error);
            setMessage("An error occurred during sync. Check the console for details.");
            showToast("Sync failed!", "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4">Admin Tools</h2>
            <div className="flex items-center space-x-4">
                <button
                    onClick={handleSyncProfiles}
                    disabled={isLoading}
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
                >
                    {isLoading ? 'Syncing...' : 'Sync Private to Public Profiles'}
                </button>
                <a href="https://console.firebase.google.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-indigo-600 hover:underline">
                    View Firebase Console
                </a>
            </div>
            {message && <p className="text-sm text-gray-500 mt-3">{message}</p>}
        </div>
    );
};

// ✨ NEW: Component to display user details in a modal
function UserDetailModal({ user, onClose }) {
    if (!user) return null;

    // Helper component for displaying each detail item
    const DetailItem = ({ label, value }) => {
        // Don't render the row if the value is missing (but do render for boolean false)
        if (!value && typeof value !== 'boolean' && value !== 0) return null;

        return (
            <div className="py-3 sm:grid sm:grid-cols-3 sm:gap-4">
                <dt className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</dt>
                <dd className="mt-1 text-sm text-gray-900 dark:text-gray-100 sm:mt-0 sm:col-span-2 break-words">{String(value)}</dd>
            </div>
        );
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[100]">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg relative">
                <div className="p-4 sm:p-6 border-b dark:border-gray-700 flex justify-between items-center">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">
                        User Information
                    </h3>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    </button>
                </div>
                <div className="p-4 sm:p-6 max-h-[70vh] overflow-y-auto">
                    <dl className="divide-y divide-gray-200 dark:divide-gray-700">
                        <DetailItem label="Name" value={user.name} />
                        <DetailItem label="Email" value={user.email} />
                        <DetailItem label="Phone Number" value={user.phoneNumber} />
                        <DetailItem label="User ID" value={user.userId} />
                        <DetailItem label="Role" value={user.role} />
                        <DetailItem label="Joined" value={user.createdAt?.toDate().toLocaleString('en-GB')} />
                        <DetailItem label="Admin" value={user.isAdmin ? 'Yes' : 'No'} />
                        <DetailItem label="Premium" value={user.isPremium ? 'Yes' : 'No'} />
                    </dl>
                </div>
            </div>
        </div>
    );
}

// ✨ Admin view for all chats
function AdminAllChatsView({ onSelectChat }) {
    const { db } = useContext(AppContext);
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const appId = getFirebaseConfig().appId;

    useEffect(() => {
        if (!db) return;

        const conversationsRef = collection(db, `artifacts/${appId}/public/data/conversations`);
        const unsubscribe = onSnapshot(conversationsRef, async (snapshot) => {
            try {
                const conversationData = [];

                for (const docSnap of snapshot.docs) {
                    const data = docSnap.data();
                    const participants = data.participants || [];

                    // Fetch user details for each participant
                    const userDetails = {};
                    for (const userId of participants) {
                        const userRef = doc(db, `artifacts/${appId}/public/data/user_profiles/${userId}`);
                        const userSnap = await getDoc(userRef);
                        if (userSnap.exists()) {
                            userDetails[userId] = userSnap.data();
                        }
                    }

                    // Fetch the last message from messages subcollection
                    let lastMessageText = 'No messages yet';
                    let lastMessageTime = null;
                    let lastMessageTimestamp = 0;

                    try {
                        const messagesRef = collection(db, `artifacts/${appId}/public/data/conversations/${docSnap.id}/messages`);
                        const messagesQuery = query(messagesRef, orderBy('timestamp', 'desc'), limit(1));
                        const messagesSnap = await getDocs(messagesQuery);

                        if (messagesSnap.docs.length > 0) {
                            const lastMsg = messagesSnap.docs[0].data();
                            lastMessageText = lastMsg.text || '[Image/File]';
                            if (lastMsg.timestamp) {
                                lastMessageTimestamp = lastMsg.timestamp.seconds ? lastMsg.timestamp.seconds * 1000 : lastMsg.timestamp;
                                lastMessageTime = new Date(lastMessageTimestamp).toLocaleString();
                            }
                        }
                    } catch (error) {
                        console.error("Error fetching messages for conversation:", error);
                    }

                    conversationData.push({
                        id: docSnap.id,
                        ...data,
                        userDetails,
                        lastMessageText,
                        lastMessageTime,
                        lastMessageTimestamp,
                    });
                }

                // Sort by last message timestamp descending (newest first)
                conversationData.sort((a, b) => b.lastMessageTimestamp - a.lastMessageTimestamp);
                setConversations(conversationData);
            } catch (error) {
                console.error("Error loading conversations:", error);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [db]);

    const filteredConversations = conversations.filter(conv => {
        const participants = Object.values(conv.userDetails || {})
            .map(u => u.name || 'Unknown')
            .join(' ');
        return !searchTerm || participants.toLowerCase().includes(searchTerm.toLowerCase());
    });

    if (loading) return <div className="text-center py-8">Loading conversations...</div>;

    return (
        <div>
            <input
                type="text"
                placeholder="Search conversations..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-2 mb-4 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
            />

            <div className="space-y-2">
                {filteredConversations.length === 0 ? (
                    <p className="text-gray-500 text-center py-8">No conversations found</p>
                ) : (
                    filteredConversations.map(conv => {
                        const participantNames = Object.values(conv.userDetails || {})
                            .map(u => u.name || 'Unknown')
                            .join(' ↔ ');

                        return (
                            <div
                                key={conv.id}
                                onClick={() => onSelectChat(conv)}
                                className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-blue-50 dark:hover:bg-gray-700 cursor-pointer transition"
                            >
                                <div className="flex justify-between items-start gap-3">
                                    <div className="flex-1 min-w-0">
                                        <p className="font-semibold text-gray-800 dark:text-white truncate">{participantNames}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400 truncate max-w-md">{conv.lastMessageText}</p>
                                    </div>
                                    <p className="text-xs text-gray-500 dark:text-gray-500 whitespace-nowrap font-mono flex-shrink-0">
                                        {conv.lastMessageTime || 'N/A'}
                                    </p>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}

function Dashboard() {
    const { db, storage } = useContext(AppContext);

    const [stats, setStats] = useState({ newUsersCount: 0, newRoomsCount: 0, newRequestsCount: 0, activeChatsCount: 0 });
    const [rooms, setRooms] = useState([]);
    const [requests, setRequests] = useState([]);
    const [users, setUsers] = useState([]); // This will now hold ALL loaded users
    const [conversations, setConversations] = useState([]);
    const [lastVisible, setLastVisible] = useState({ rooms: null, requests: null, users: null, conversations: null });
    const [hasMore, setHasMore] = useState({ rooms: true, requests: true, users: true, conversations: true });
    const [loadingMore, setLoadingMore] = useState({ rooms: false, requests: false, users: false, conversations: false });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [editingPost, setEditingPost] = useState(null);
    const [viewingChat, setViewingChat] = useState(null);
    const [userTimeFilter, setUserTimeFilter] = useState('all');
    const [currentView, setCurrentView] = useState('overview');
    const [viewingUser, setViewingUser] = useState(null);
    const [userPostCounts, setUserPostCounts] = useState({}); // Track post counts per user
    const [viewingUserPosts, setViewingUserPosts] = useState(null); // For viewing user's posts

    const PAGE_SIZE = 10;

    const fetchPage = async (db, collectionName, orderByField, cursor, isComplex = false) => {
        const collectionRef = collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/${collectionName}`);
        let q;

        if (isComplex) { // For posts
            q = query(collectionRef, orderBy('status', 'asc'), orderBy(orderByField, 'desc'));
        } else { // For users and conversations
            q = query(collectionRef, orderBy(orderByField, 'desc'));
        }

        if (cursor) {
            q = query(q, startAfter(cursor), limit(PAGE_SIZE));
        } else {
            q = query(q, limit(PAGE_SIZE));
        }

        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const lastDoc = snapshot.docs[snapshot.docs.length - 1];
        const moreToLoad = snapshot.docs.length === PAGE_SIZE;

        return { data, lastDoc, moreToLoad };
    };

    useEffect(() => {
        if (!db) return;

        const fetchInitialData = async () => {
            setLoading(true);
            try {
                const [roomsResult, requestsResult, usersResult, conversationsResult] = await Promise.all([
                    fetchPage(db, 'room_listings', 'lastActivity', null, true),
                    fetchPage(db, 'roommate_requests', 'lastActivity', null, true),
                    fetchPage(db, 'user_profiles', 'createdAt', null),
                    fetchPage(db, 'conversations', 'lastMessageTimestamp', null)
                ]);

                setRooms(roomsResult.data);
                setLastVisible(prev => ({ ...prev, rooms: roomsResult.lastDoc }));
                setHasMore(prev => ({ ...prev, rooms: roomsResult.moreToLoad }));

                setRequests(requestsResult.data);
                setLastVisible(prev => ({ ...prev, requests: requestsResult.lastDoc }));
                setHasMore(prev => ({ ...prev, requests: requestsResult.moreToLoad }));

                setUsers(usersResult.data);
                setLastVisible(prev => ({ ...prev, users: usersResult.lastDoc }));
                setHasMore(prev => ({ ...prev, users: usersResult.moreToLoad }));

                setConversations(conversationsResult.data);
                setLastVisible(prev => ({ ...prev, conversations: conversationsResult.lastDoc }));
                setHasMore(prev => ({ ...prev, conversations: conversationsResult.moreToLoad }));

            } catch (error) {
                console.error("Error fetching initial dashboard data:", error);
            } finally {
                setLoading(false);
            }
        };

        // Fetch post counts for all users
        const fetchAllPostCounts = async (usersList) => {
            const counts = {};
            for (const user of usersList) {
                counts[user.id] = await fetchUserPostCount(user.id);
            }
            setUserPostCounts(counts);
        };
        const fetchStats = async () => {
            const startOfToday = new Date();
            startOfToday.setHours(0, 0, 0, 0);

            const getCount = async (db, collName, dateField) => {
                const q = query(collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/${collName}`), where(dateField, '>=', startOfToday));
                const snapshot = await getDocs(q);
                return snapshot.size;
            };

            const [newUsers, newRooms, newRequests, activeChats] = await Promise.all([
                getCount(db, 'user_profiles', 'createdAt'),
                getCount(db, 'room_listings', 'lastActivity'),
                getCount(db, 'roommate_requests', 'lastActivity'),
                getCount(db, 'conversations', 'lastMessageTimestamp')
            ]);

            setStats({ newUsersCount: newUsers, newRoomsCount: newRooms, newRequestsCount: newRequests, activeChatsCount: activeChats });
        };

        const initializeData = async () => {
            await fetchInitialData();
            fetchStats();
        };
        initializeData();
    }, [db]);

      const handleLoadMore = async (type) => {
        if (!db || loadingMore[type] || !hasMore[type]) return;

        setLoadingMore(prev => ({ ...prev, [type]: true }));
        try {
            const isComplex = type === 'rooms' || type === 'requests';
            let collectionName, orderByField;

            switch(type) {
                case 'users':
                    collectionName = 'user_profiles';
                    orderByField = 'createdAt';
                    break;
                case 'rooms':
                    collectionName = 'room_listings';
                    orderByField = 'lastActivity';
                    break;
                case 'requests':
                    collectionName = 'roommate_requests';
                    orderByField = 'lastActivity';
                    break;
                case 'conversations':
                    collectionName = 'conversations';
                    orderByField = 'lastMessageTimestamp';
                    break;
                default:
                    return;
            }

            const result = await fetchPage(db, collectionName, orderByField, lastVisible[type], isComplex);

            if (result.data.length > 0) {
                if (type === 'rooms') setRooms(prev => [...prev, ...result.data]);
                if (type === 'requests') setRequests(prev => [...prev, ...result.data]);
                if (type === 'users') setUsers(prev => [...prev, ...result.data]);
                if (type === 'conversations') setConversations(prev => [...prev, ...result.data]);

                setLastVisible(prev => ({ ...prev, [type]: result.lastDoc }));
            }

            setHasMore(prev => ({ ...prev, [type]: result.moreToLoad }));

        } catch (error) {
            console.error(`Error loading more ${type}:`, error);
        } finally {
            setLoadingMore(prev => ({ ...prev, [type]: false }));
        }
    };

    // Fetch post count for a user
    const fetchUserPostCount = async (userId) => {
        if (userPostCounts[userId] !== undefined) return userPostCounts[userId];

        try {
            const appId = getFirebaseConfig().appId;
            const roomsRef = collection(db, `artifacts/${appId}/public/data/room_listings`);
            const requestsRef = collection(db, `artifacts/${appId}/public/data/roommate_requests`);

            const roomsQ = query(roomsRef, where('userId', '==', userId));
            const requestsQ = query(requestsRef, where('userId', '==', userId));

            const roomsSnap = await getDocs(roomsQ);
            const requestsSnap = await getDocs(requestsQ);

            const count = roomsSnap.docs.length + requestsSnap.docs.length;
            setUserPostCounts(prev => ({ ...prev, [userId]: count }));
            return count;
        } catch (error) {
            console.error("Error fetching post count:", error);
            return 0;
        }
    };

    // Fetch post counts for all users once they load
    useEffect(() => {
        if (users.length > 0) {
            const fetchAllCounts = async () => {
                const counts = {};
                for (const user of users) {
                    counts[user.id] = await fetchUserPostCount(user.id);
                }
                setUserPostCounts(counts);
            };
            fetchAllCounts();
        }
    }, [users]);

    // View posts by a specific user
    const handleViewUserPosts = async (user) => {
        try {
            const appId = getFirebaseConfig().appId;
            const roomsRef = collection(db, `artifacts/${appId}/public/data/room_listings`);
            const requestsRef = collection(db, `artifacts/${appId}/public/data/roommate_requests`);

            const roomsQ = query(roomsRef, where('userId', '==', user.id));
            const requestsQ = query(requestsRef, where('userId', '==', user.id));

            const [roomsSnap, requestsSnap] = await Promise.all([getDocs(roomsQ), getDocs(requestsQ)]);

            const userPosts = [
                ...roomsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id, type: 'room' })),
                ...requestsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id, type: 'roommate' }))
            ];

            setViewingUserPosts({ user, posts: userPosts });
        } catch (error) {
            console.error("Error fetching user posts:", error);
            alert('Failed to fetch user posts');
        }
    };

    const handleSetPremiumStatus = async (user, newStatus) => {
    if (!db || !window.confirm(`This will ${newStatus ? 'grant' : 'revoke'} premium status for ${user.name}. Continue?`)) return;

    const appId = getFirebaseConfig().appId;
    const publicUserRef = doc(db, `artifacts/${appId}/public/data/user_profiles`, user.id);

    try {
        await updateDoc(publicUserRef, { isPremium: newStatus });
        setUsers(prevUsers => prevUsers.map(u => u.id === user.id ? { ...u, isPremium: newStatus } : u));
        alert(`User ${user.name}'s premium status has been updated.`);
    } catch (error) {
        console.error("Error updating premium status:", error);
        alert("Failed to update premium status. Check console for details.");
    }
};

    const handleSetRole = async (user, newRole) => {
        if (!db) return;
        const appId = getFirebaseConfig().appId;
        const publicUserRef = doc(db, `artifacts/${appId}/public/data/user_profiles`, user.id);
        try {
            await updateDoc(publicUserRef, { role: newRole });
            setUsers(prevUsers => prevUsers.map(u => u.id === user.id ? { ...u, role: newRole } : u));
        } catch (error) {
            console.error('Error updating role:', error);
            alert('Failed to update role. Check console for details.');
        }
    };

    // ... (rest of the handler functions are correct and remain unchanged) ...
    const handleEdit = (post, isRoomListing) => setEditingPost({ data: post, isRoomListing });
    const handleUpdatePost = async (updatedPostData) => {
        if (!db || !editingPost) return;
        const { data, isRoomListing } = editingPost;
        const collectionName = isRoomListing ? 'room_listings' : 'roommate_requests';
        const collectionPath = `artifacts/${getFirebaseConfig().appId}/public/data/${collectionName}`;
        const docRef = doc(db, collectionPath, data.id);
        try {
            const dataToUpdateForFirestore = { ...updatedPostData, lastActivity: serverTimestamp() };
            await updateDoc(docRef, dataToUpdateForFirestore);
            const listKey = isRoomListing ? 'rooms' : 'requests';
            const setter = listKey === 'rooms' ? setRooms : setRequests;
            const dataToUpdateForState = { ...updatedPostData, lastActivity: Timestamp.now() };
            setter(prevData => {
                const updatedList = prevData.map(item =>
                    item.id === data.id ? { ...item, ...dataToUpdateForState } : item
                );
                updatedList.sort((a, b) => (b.lastActivity?.toMillis() || 0) - (a.lastActivity?.toMillis() || 0));
                return updatedList;
            });
            setEditingPost(null);
            alert("Post updated successfully.");
        } catch (error) {
            console.error("Error updating post:", error);
            alert("Failed to update post.");
        }
    };
    const handleDeletePost = async (postId, postImages, collectionName) => {
        if (!db || !window.confirm("Are you sure you want to permanently delete this post?")) return;
        try {
            if (postImages && postImages.length > 0) {
                await Promise.all(postImages.map(url => {
                    const imageRef = ref(storage, url);
                    return deleteObject(imageRef).catch(err => {
                        if (err.code !== 'storage/object-not-found') console.error("Error deleting image:", err);
                    });
                }));
            }
            const collectionPath = `artifacts/${getFirebaseConfig().appId}/public/data/${collectionName}`;
            await deleteDoc(doc(db, collectionPath, postId));

            const setter = collectionName === 'room_listings' ? setRooms : setRequests;
            setter(prev => prev.filter(p => p.id !== postId));
            alert("Post deleted successfully.");
        } catch (e) {
            console.error("Error deleting post:", e);
            alert("Failed to delete post.");
        }
    };
    const renderTimestampInfo = (post, collectionName) => {
        const timestamp = post.lastActivity || post.createdAt;
        if (!timestamp) return "No date available";
        const isUpdated = post.lastActivity && post.createdAt && (post.lastActivity.toMillis() - post.createdAt.toMillis() > 5000);
        const label = isUpdated ? 'Updated' : (collectionName === 'room_listings' ? 'Posted' : 'Joined');
        const dateStr = timestamp.toDate().toLocaleDateString('en-GB');
        return `${label} on ${dateStr}`;
    };
    const handleSetAdminStatus = async (user, newStatus) => {
        if (!db || !window.confirm(`Are you sure you want to ${newStatus ? 'grant admin to' : 'revoke admin from'} ${user.name}?`)) return;

        const appId = getFirebaseConfig().appId;
        const userRef = doc(db, `artifacts/${appId}/public/data/user_profiles`, user.id);
        try {
            await updateDoc(userRef, { isAdmin: newStatus });
            setUsers(prevData => (prevData.map(u => u.id === user.id ? { ...u, isAdmin: newStatus } : u)));
            alert(`User ${user.name} admin status has been updated.`);
        } catch (error) {
            console.error("Error updating admin status:", error);
            alert("Failed to update admin status.");
        }
    };
      const filteredUsers = users.filter(user => {
        const aWeekAgo = new Date();
        aWeekAgo.setDate(aWeekAgo.getDate() - 7);

        const matchesTimeFilter = userTimeFilter === 'all' || (user.createdAt?.toDate() >= aWeekAgo);
        const matchesSearchTerm = !searchTerm ||
                                  user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                  user.email?.toLowerCase().includes(searchTerm.toLowerCase());

        return matchesTimeFilter && matchesSearchTerm;
    });

    const LoadMoreButton = ({ type, loadingFlag, moreFlag }) => {
        if (!moreFlag) return null;
        return (
            <div className="text-center mt-4">
                <button
                    onClick={() => handleLoadMore(type)}
                    disabled={loadingFlag}
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-600 text-sm rounded-md hover:bg-gray-300 dark:hover:bg-gray-500 disabled:opacity-50"
                >
                    {loadingFlag ? 'Loading...' : `Load More ${type.charAt(0).toUpperCase() + type.slice(1)}`}
                </button>
            </div>
        );
    };

    const activeTabClass = "border-b-2 border-indigo-500 text-indigo-600 dark:text-indigo-300";
    const inactiveTabClass = "border-b-2 border-transparent text-gray-500 dark:text-gray-400 hover:text-indigo-600";

    const adminTabs = [
        {
            id: 'overview',
            label: '📊 Overview',
            icon: '📈',
            description: 'Dashboard statistics and insights',
        },
        {
            id: 'users',
            label: '👥 User Management',
            icon: '👤',
            description: 'Manage user accounts and roles',
        },
        {
            id: 'chats',
            label: '💬 All Chats',
            icon: '💬',
            description: 'View all conversations',
        },
        {
            id: 'essentials',
            label: '📖 UK Essentials',
            icon: '📚',
            description: 'Edit essentials content',
        },
        {
            id: 'premium',
            label: '💳 Premium Subscriptions',
            icon: '⭐',
            description: 'Manage premium features',
        },
    ];

    return (
        <div className="p-4 md:p-6 lg:p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-8 rounded-lg mb-6">
                <h1 className="text-4xl font-bold mb-2">Admin Dashboard</h1>
                <p className="text-blue-100">Manage users, content, and premium features</p>
            </div>

            {/* Tabs */}
            <div className="flex flex-wrap gap-2 mb-6">
                {adminTabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setCurrentView(tab.id)}
                        className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition ${
                            currentView === tab.id
                                ? "bg-blue-600 text-white shadow-lg"
                                : "bg-white dark:bg-gray-700 text-gray-800 dark:text-white border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
                        }`}
                    >
                        <span className="text-xl">{tab.icon}</span>
                        <span>{tab.label}</span>
                    </button>
                ))}
            </div>

            {/* ======== OVERVIEW PANE ======== */}
            {currentView === 'overview' && (
                <div className="space-y-8">
                    {/* Stats Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <StatCard title="👤 New Users" count={stats.newUsersCount} isLoading={loading} icon="👤" color="from-blue-400 to-blue-600" />
                        <StatCard title="🏠 New Rooms" count={stats.newRoomsCount} isLoading={loading} icon="🏠" color="from-green-400 to-green-600" />
                        <StatCard title="📝 New Requests" count={stats.newRequestsCount} isLoading={loading} icon="📝" color="from-orange-400 to-orange-600" />
                        <StatCard title="💬 Active Chats" count={stats.activeChatsCount} isLoading={loading} icon="💬" color="from-purple-400 to-purple-600" />
                    </div>

                    {/* Quick Actions */}
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg border-l-4 border-blue-600">
                        <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
                            <span>⚙️</span> Quick Actions
                        </h3>
                        <div className="flex flex-wrap gap-3">
                            <a href="https://console.firebase.google.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition shadow-md">
                                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M3 13h2v8H3zm4-8h2v16H7zm4-2h2v18h-2zm4-2h2v20h-2zm4 4h2v16h-2zm4 8h2v8h-2z"/></svg>
                                Firebase Console
                            </a>
                        </div>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
                        <h2 className="text-xl font-semibold mb-4">All Posts</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
                            <div>
                                <h3 className="font-bold border-b pb-2 dark:border-gray-700">All Room Listings ({rooms.length})</h3>
                                <div className="max-h-96 overflow-y-auto pr-2 divide-y dark:divide-gray-700">
                                                                {loading ? <p className="p-2">Loading...</p> : rooms.length > 0 ? rooms.map(post => (
                                <div key={post.id} className="py-3 border-b dark:border-gray-700 last:border-0">
                                    <div className="flex justify-between items-start">
                                        <button onClick={() => setSelectedItem({type: 'room', data: post})} className="flex-1 text-left min-w-0 pr-2">
                                            <p className="font-medium text-indigo-600 dark:text-indigo-400 hover:underline truncate">{post.title}</p>
                                            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">by {post.userName} - {renderTimestampInfo(post, 'room_listings')}</p>
                                        </button>
                                        <div className="flex items-center space-x-2 ml-auto flex-shrink-0">
                                            <button onClick={() => handleEdit(post, true)} className="text-blue-500 hover:text-blue-700 text-xs font-semibold">Edit</button>
                                            <button onClick={() => handleDeletePost(post.id, post.images, 'room_listings')} className="text-red-500 hover:text-red-700 text-xs font-semibold">Delete</button>
                                        </div>
                                    </div>
                                    {post.phoneNumber && (
                                        <ContactButtons
                                            phoneNumber={post.phoneNumber}
                                            waMessage={`Hi ${post.userName}, I'm from the IndianFlatmates.co.uk team. I'm reaching out about your room listing "${post.title}". We have tenants interested in your area. Can we connect you?`}
                                            size="small"
                                            className="mt-1.5"
                                        />
                                    )}
                                </div>
                            )) : <p className="text-sm text-gray-500 mt-2 p-2">No room listings.</p>}
                                </div>
                                <LoadMoreButton type="rooms" loadingFlag={loadingMore.rooms} moreFlag={hasMore.rooms} />
                            </div>
                            <div>
                                <h3 className="font-bold border-b pb-2 dark:border-gray-700">All Roommate Requests ({requests.length})</h3>
                                <div className="max-h-96 overflow-y-auto pr-2 divide-y dark:divide-gray-700">
                            {loading ? <p className="p-2">Loading...</p> : requests.length > 0 ? requests.map(post => (
                                <div key={post.id} className="py-3 border-b dark:border-gray-700 last:border-0">
                                    <div className="flex justify-between items-start">
                                        <button onClick={() => setSelectedItem({type: 'request', data: post})} className="flex-1 text-left min-w-0 pr-2">
                                            <p className="font-medium text-indigo-600 dark:text-indigo-400 hover:underline truncate">{post.userName}</p>
                                            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">Seeking in {post.preferredLocations} - {renderTimestampInfo(post, 'roommate_requests')}</p>
                                        </button>
                                        <div className="flex items-center space-x-2 ml-auto flex-shrink-0">
                                            <button onClick={() => handleEdit(post, false)} className="text-blue-500 hover:text-blue-700 text-xs font-semibold">Edit</button>
                                            <button onClick={() => handleDeletePost(post.id, null, 'roommate_requests')} className="text-red-500 hover:text-red-700 text-xs font-semibold">Delete</button>
                                        </div>
                                    </div>
                                    {post.phoneNumber && (
                                        <ContactButtons
                                            phoneNumber={post.phoneNumber}
                                            waMessage={`Hi ${post.userName}, I'm from the IndianFlatmates.co.uk team. I see you're looking for a room. We have new listings that might suit you. Would you like to know more?`}
                                            size="small"
                                            className="mt-1.5"
                                        />
                                    )}
                                </div>
                            )) : <p className="text-sm text-gray-500 mt-2 p-2">No roommate requests.</p>}
                                </div>
                                <LoadMoreButton type="requests" loadingFlag={loadingMore.requests} moreFlag={hasMore.requests} />
                            </div>
                        </div>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
                        <h2 className="text-xl font-semibold border-b pb-2 mb-2 dark:border-gray-700">All Conversations ({conversations.length})</h2>
                        <div className="max-h-96 overflow-y-auto">
                    {loading ? <p className="p-2">Loading...</p> : conversations.length > 0 ? conversations.map(chat => (
                        <button key={chat.id} onClick={() => setViewingChat(chat)} className="w-full text-left p-2 border-b dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors">
                            <p className="font-medium">{Object.values(chat.participantNames || {}).join(' & ')}</p>
                            <p className="text-sm text-gray-600 dark:text-gray-400 truncate">Last: "{chat.lastMessage}"</p>
                            <p className="text-xs text-gray-500">{formatTimestamp(chat.lastMessageTimestamp)}</p>
                        </button>
                    )) : <p className="text-sm text-gray-500 mt-2 p-2">No conversations found.</p>}
                        </div>
                        <LoadMoreButton type="conversations" loadingFlag={loadingMore.conversations} moreFlag={hasMore.conversations} />
                    </div>
                </div>
            )}

             {/* ======== USER MANAGEMENT PANE ======== */}
           {currentView === 'users' && (
                <div>
                    {/* Header */}
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg mb-6">
                        <div className="flex justify-between items-start mb-6">
                            <div>
                                <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-1">User Management</h2>
                                <p className="text-gray-600 dark:text-gray-400">Total users: <span className="font-bold text-lg text-blue-600">{users.length}</span></p>
                            </div>
                            <div className="flex gap-2">
                                <button onClick={() => setUserTimeFilter('all')} className={`px-4 py-2 rounded-lg font-semibold transition ${userTimeFilter === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white'}`}>All Users</button>
                                <button onClick={() => setUserTimeFilter('week')} className={`px-4 py-2 rounded-lg font-semibold transition ${userTimeFilter === 'week' ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white'}`}>Last Week</button>
                            </div>
                        </div>
                        <input type="text" placeholder="🔍 Search users by name or email..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-600 outline-none transition"/>
                    </div>

                    {/* Users Content */}
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
{/* ── I Need Room (Room Seekers) ── */}
                    {(() => {
                        const seekers = filteredUsers.filter(u => u.role === 'I Need Room');
                        return seekers.length > 0 ? (
                            <div className="mb-8">
                                <h3 className="text-base font-semibold text-indigo-700 dark:text-indigo-300 mb-2 flex items-center gap-2">
                                    <span className="bg-indigo-100 dark:bg-indigo-900 text-indigo-700 dark:text-indigo-300 px-2 py-0.5 rounded-full text-xs">I Need Room</span>
                                    Room Seekers ({seekers.length})
                                </h3>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                        <thead className="bg-gray-50 dark:bg-gray-700">
                                            <tr>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Name</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Contact</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Posts</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Joined</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                            {seekers.map(user => (
                                                <tr key={user.id}>
                                                    <td className="px-4 py-3">
                                                        <button onClick={() => setViewingUser(user)} className="text-left">
                                                            <div className="font-medium text-indigo-600 dark:text-indigo-400 hover:underline">{user.name}</div>
                                                            <div className="text-xs text-gray-500 dark:text-gray-400">{user.email}</div>
                                                        </button>
                                                        {user.isPremium && <span className="ml-0 mt-0.5 inline-block bg-yellow-100 text-yellow-800 text-xs px-1.5 py-0.5 rounded-full">Premium</span>}
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        {user.phoneNumber ? (
                                                            <ContactButtons
                                                                phoneNumber={user.phoneNumber}
                                                                waMessage={`Hi ${user.name}, I'm from IndianFlatmates.co.uk. I see you're looking for a room. We have new listings that might suit you. Would you like to know more?`}
                                                                size="small"
                                                            />
                                                        ) : <span className="text-xs text-gray-400">No phone</span>}
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <button onClick={() => handleViewUserPosts(user)} className="text-blue-600 dark:text-blue-400 hover:underline text-sm font-medium">
                                                            {userPostCounts[user.id] || 0}
                                                        </button>
                                                    </td>
                                                    <td className="px-4 py-3 text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                                        {user.createdAt?.toDate().toLocaleDateString('en-GB')}
                                                    </td>
                                                    <td className="px-4 py-3 whitespace-nowrap space-x-1">
                                                        <button onClick={() => handleSetAdminStatus(user, !user.isAdmin)} className={`px-2 py-0.5 rounded-full text-white text-xs ${user.isAdmin ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'}`}>
                                                            {user.isAdmin ? 'Revoke Admin' : 'Make Admin'}
                                                        </button>
                                                        <button onClick={() => handleSetPremiumStatus(user, !user.isPremium)} className={`px-2 py-0.5 rounded-full text-white text-xs ${user.isPremium ? 'bg-gray-500 hover:bg-gray-600' : 'bg-yellow-500 hover:bg-yellow-600'}`}>
                                                            {user.isPremium ? 'Revoke Premium' : 'Make Premium'}
                                                        </button>
                                                        <button onClick={() => handleSetRole(user, 'I Need Room')} className="px-2 py-0.5 rounded-full text-white text-xs bg-indigo-500 hover:bg-indigo-600">
                                                            Set: Need Room
                                                        </button>
                                                        <button onClick={() => handleSetRole(user, 'I Have Room')} className="px-2 py-0.5 rounded-full text-white text-xs bg-emerald-500 hover:bg-emerald-600">
                                                            Set: Have Room
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null;
                    })()}
                    {/* ── I Have Room (Room Providers) ── */}
                    {(() => {
                        const providers = filteredUsers.filter(u => u.role === 'I Have Room');
                        return providers.length > 0 ? (
                            <div className="mb-4">
                                <h3 className="text-base font-semibold text-emerald-700 dark:text-emerald-300 mb-2 flex items-center gap-2">
                                    <span className="bg-emerald-100 dark:bg-emerald-900 text-emerald-700 dark:text-emerald-300 px-2 py-0.5 rounded-full text-xs">I Have Room</span>
                                    Room Providers ({providers.length})
                                </h3>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                        <thead className="bg-gray-50 dark:bg-gray-700">
                                            <tr>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Name</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Contact</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Posts</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Joined</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                            {providers.map(user => (
                                                <tr key={user.id}>
                                                    <td className="px-4 py-3">
                                                        <button onClick={() => setViewingUser(user)} className="text-left">
                                                            <div className="font-medium text-indigo-600 dark:text-indigo-400 hover:underline">{user.name}</div>
                                                            <div className="text-xs text-gray-500 dark:text-gray-400">{user.email}</div>
                                                        </button>
                                                        {user.isPremium && <span className="ml-0 mt-0.5 inline-block bg-yellow-100 text-yellow-800 text-xs px-1.5 py-0.5 rounded-full">Premium</span>}
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        {user.phoneNumber ? (
                                                            <ContactButtons
                                                                phoneNumber={user.phoneNumber}
                                                                waMessage={`Hi ${user.name}, I'm from IndianFlatmates.co.uk. I see you have rooms available. We have many people looking for rooms in your area. Would you like us to help fill your rooms faster?`}
                                                                size="small"
                                                            />
                                                        ) : <span className="text-xs text-gray-400">No phone</span>}
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <button onClick={() => handleViewUserPosts(user)} className="text-blue-600 dark:text-blue-400 hover:underline text-sm font-medium">
                                                            {userPostCounts[user.id] || 0}
                                                        </button>
                                                    </td>
                                                    <td className="px-4 py-3 text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                                        {user.createdAt?.toDate().toLocaleDateString('en-GB')}
                                                    </td>
                                                    <td className="px-4 py-3 whitespace-nowrap space-x-1">
                                                        <button onClick={() => handleSetAdminStatus(user, !user.isAdmin)} className={`px-2 py-0.5 rounded-full text-white text-xs ${user.isAdmin ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'}`}>
                                                            {user.isAdmin ? 'Revoke Admin' : 'Make Admin'}
                                                        </button>
                                                        <button onClick={() => handleSetPremiumStatus(user, !user.isPremium)} className={`px-2 py-0.5 rounded-full text-white text-xs ${user.isPremium ? 'bg-gray-500 hover:bg-gray-600' : 'bg-yellow-500 hover:bg-yellow-600'}`}>
                                                            {user.isPremium ? 'Revoke Premium' : 'Make Premium'}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null;
                    })()}
                    {/* Users with no role yet */}
                    {(() => {
                        const noRole = filteredUsers.filter(u => !u.role);
                        return noRole.length > 0 ? (
                            <div className="mb-4">
                                <h3 className="text-base font-semibold text-gray-500 dark:text-gray-400 mb-2">No Role Yet ({noRole.length})</h3>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                        <thead className="bg-gray-50 dark:bg-gray-700">
                                            <tr>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Name</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Contact</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Joined</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                            {noRole.map(user => (
                                                <tr key={user.id}>
                                                    <td className="px-4 py-3">
                                                        <button onClick={() => setViewingUser(user)} className="text-left">
                                                            <div className="font-medium text-indigo-600 dark:text-indigo-400 hover:underline">{user.name}</div>
                                                            <div className="text-xs text-gray-500 dark:text-gray-400">{user.email}</div>
                                                        </button>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        {user.phoneNumber ? (
                                                            <ContactButtons
                                                                phoneNumber={user.phoneNumber}
                                                                waMessage={`Hi ${user.name}, I'm from IndianFlatmates.co.uk. Just checking if you need any help finding or filling a room. We're happy to assist!`}
                                                                size="small"
                                                            />
                                                        ) : <span className="text-xs text-gray-400">No phone</span>}
                                                    </td>
                                                    <td className="px-4 py-3 text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                                        {user.createdAt?.toDate().toLocaleDateString('en-GB')}
                                                    </td>
                                                    <td className="px-4 py-3 whitespace-nowrap space-x-1">
                                                        <button onClick={() => handleSetAdminStatus(user, !user.isAdmin)} className={`px-2 py-0.5 rounded-full text-white text-xs ${user.isAdmin ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'}`}>
                                                            {user.isAdmin ? 'Revoke Admin' : 'Make Admin'}
                                                        </button>
                                                        <button onClick={() => handleSetPremiumStatus(user, !user.isPremium)} className={`px-2 py-0.5 rounded-full text-white text-xs ${user.isPremium ? 'bg-gray-500 hover:bg-gray-600' : 'bg-yellow-500 hover:bg-yellow-600'}`}>
                                                            {user.isPremium ? 'Revoke Premium' : 'Make Premium'}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null;
                    })()}
                                {!searchTerm && userTimeFilter === 'all' && (
                        <LoadMoreButton type="users" loadingFlag={loadingMore.users} moreFlag={hasMore.users} />
                    )}
                    </div>
                </div>
            )}


            {/* ======== ALL CHATS PANE ======== */}
            {currentView === 'chats' && (
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
                    <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-white">All Conversations</h2>
                    <AdminAllChatsView onSelectChat={setViewingChat} />
                </div>
            )}

            {/* ======== UK ESSENTIALS PANE ======== */}
            {currentView === 'essentials' && <EssentialsAdmin />}

            {/* ======== PREMIUM SUBSCRIPTIONS PANE ======== */}
            {currentView === 'premium' && <AdminSubscriptionPanel />}

            {/* Modals */}
            {viewingChat && <AdminChatViewerModal conversation={viewingChat} onClose={() => setViewingChat(null)} />}
            {editingPost && <EditPostModal post={editingPost.data} onClose={() => setEditingPost(null)} onSave={handleUpdatePost} isRoomListing={editingPost.isRoomListing} />}
            {selectedItem && <PostDetailModal post={selectedItem.data} onClose={() => setSelectedItem(null)} isRoomListing={selectedItem.type === 'room'} onStartChat={() => alert("Admin cannot initiate chat from dashboard.")} />}
                            {viewingUser && <UserDetailModal user={viewingUser} onClose={() => setViewingUser(null)} />}
                            {viewingUserPosts && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[90]">
                                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto relative">
                                        <div className="sticky top-0 p-6 border-b dark:border-gray-700 bg-white dark:bg-gray-800 flex justify-between items-center">
                                            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                                                Posts by {viewingUserPosts.user.name} ({viewingUserPosts.posts.length})
                                            </h3>
                                            <button onClick={() => setViewingUserPosts(null)} className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                            </button>
                                        </div>
                                        <div className="p-6">
                                            {viewingUserPosts.posts.length === 0 ? (
                                                <p className="text-gray-500 text-center py-8">No posts found for this user</p>
                                            ) : (
                                                <div className="space-y-4">
                                                    {viewingUserPosts.posts.map(post => (
                                                        <div key={post.id} className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                                                            <div className="flex justify-between items-start mb-2">
                                                                <div className="flex-1">
                                                                    <h4 className="font-bold text-gray-900 dark:text-white">
                                                                        {post.type === 'room' ? maskPhoneNumbers(post.title) : maskPhoneNumbers(post.requirements)}
                                                                    </h4>
                                                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                                                        {post.type === 'room' ? `£${post.rent}/month` : `Budget: £${post.budget}`}
                                                                    </p>
                                                                </div>
                                                                <div className="flex gap-2 items-center">
                                                                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${post.type === 'room' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' : 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'}`}>
                                                                        {post.type === 'room' ? 'Room' : 'Roommate Req.'}
                                                                    </span>
                                                                    <button onClick={() => setEditingPost({ data: post, isRoomListing: post.type === 'room' })} className="px-3 py-1 bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-medium rounded-lg">
                                                                        Edit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
                                                                {post.type === 'room' ? maskPhoneNumbers(post.address) : maskPhoneNumbers(post.aboutMe)}
                                                            </p>
                                                            <div className="flex gap-2 text-xs text-gray-500 dark:text-gray-400">
                                                                <span>Status: {post.status || 'active'}</span>
                                                                <span>•</span>
                                                                <span>Created: {post.createdAt?.toDate?.().toLocaleDateString('en-GB') || 'N/A'}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

        </div>
    );
}
// ✨ NEW: Component for Admins to view conversation history
function AdminChatViewerModal({ conversation, onClose }) {
    const { db } = useContext(AppContext);
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const messagesEndRef = React.useRef(null);

    useEffect(() => {
        if (!db || !conversation?.id) return;
        const messagesRef = collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/conversations/${conversation.id}/messages`);
        const q = query(messagesRef, orderBy("timestamp", "asc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setMessages(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        }, (error) => {
            console.error("Error fetching chat messages:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [db, conversation?.id]);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg h-[80vh] flex flex-col">
                <div className="p-4 border-b dark:border-gray-700 flex justify-between items-center">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100">
                        Chat: {Object.values(conversation.participantNames || {}).join(' & ')}
                    </h3>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    </button>
                </div>
                <div className="flex-1 p-4 overflow-y-auto space-y-4 bg-gray-50 dark:bg-gray-900">
                    {loading && <p>Loading messages...</p>}
                    {!loading && messages.map(msg => (
                        <div key={msg.id} className={`flex flex-col ${msg.senderId === Object.keys(conversation.participantNames)[0] ? 'items-start' : 'items-end'}`}>
                            <div className={`py-2 px-3 rounded-xl max-w-sm flex flex-col ${msg.senderId === Object.keys(conversation.participantNames)[0] ? 'bg-gray-200 dark:bg-gray-700' : 'bg-indigo-500 text-white'}`}>
                                <p className="text-sm break-words">{msg.text}</p>
                                <span className="text-xs self-end opacity-70 ml-2 mt-1">
                                    {formatTimestamp(msg.timestamp)}
                                </span>
                            </div>
                            <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                {conversation.participantNames[msg.senderId] || 'Unknown'}
                            </span>
                        </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>
            </div>
        </div>
    );
}

// --- RoomPostForm Component (MODIFIED) ---
// 🚀 NEW: Accepts `onSuccess` prop for redirection
function RoomPostForm({ onSuccess }) {
    const { db, storage, userId, userProfile } = useContext(AppContext);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        address: '',
        postcode: 'London, UK',
        rent: '',
        deposit: '',
        roomType: [],
        preferredTenants: [],
        availableFrom: '',
        amenities: [],
        contactMethod: 'chat',
        images: [],
        status: 'active',
        userId: userId,
        createdAt: serverTimestamp(),
        userName: userProfile?.name || '',
        phoneNumber: userProfile?.phoneNumber || '',
    });
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [imageFiles, setImageFiles] = useState([]);
    const [isVerified, setIsVerified] = useState(false);
    const recaptchaRef = useRef();

    // ... (rest of the component's state and helper functions remain the same) ...
   const roomTypes = ['Single', 'Double', 'En-suite', 'Studio', 'Shared'];
    const tenantPreferences = ['Male', 'Female', 'Student', 'Professional', 'Any'];
    const allAmenities = ['WiFi', 'Parking', 'Bills included', 'Furnished', 'Washing Machine', 'Gym access', 'Balcony'];

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData(prev => ({
                ...prev,
                [name]: checked
                    ? [...(prev[name] || []), value]
                    : (prev[name] || []).filter(item => item !== value)
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + imageFiles.length > 10) {
            setMessage('You can upload a maximum of 10 images.');
            return;
        }
        setMessage('');
        setImageFiles(prev => [...prev, ...files]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'copy';
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = Array.from(e.dataTransfer.files);
        if (files.length + imageFiles.length > 10) {
            setMessage('You can upload a maximum of 10 images.');
            return;
        }
        setMessage('');
        setImageFiles(prev => [...prev, ...files.filter(f => f.type.startsWith('image/'))]);
    };

    const removeImage = (indexToRemove) => {
        const newImageFiles = imageFiles.filter((_, index) => index !== indexToRemove);
        setImageFiles(newImageFiles);
    };

const showToast = useToast()
    const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isVerified) {
     setMessage("Please verify that you are not a robot.");
     showToast('Please verify that you are not a robot.', 'error');
        return;
    }
    if (!db || !userId || !storage) {
        setMessage('Error: Authentication or database not ready.');
        return;
    }

    setIsSubmitting(true);
    setMessage('Uploading images...');
    try {
        const uploadedImageUrls = [];
       for (const file of imageFiles) {
            const compressedFile = await compressImage(file);

            const imageName = `${userId}-${Date.now()}-${compressedFile.name}`;
            const imageRef = ref(storage, `artifacts/${getFirebaseConfig().appId}/room_listings/${imageName}`);
            const snapshot = await uploadBytes(imageRef, compressedFile);
            const downloadURL = await getDownloadURL(snapshot.ref);
            uploadedImageUrls.push(downloadURL);
        }

        setMessage('Creating listing...');
        const appId = getFirebaseConfig().appId;
        const roomListingsRef = collection(db, `artifacts/${appId}/public/data/room_listings`);
        const newListing = await addDoc(roomListingsRef, {
            ...formData,
            images: uploadedImageUrls,
            lastActivity: serverTimestamp(),
        });

        onSuccess('Room listing created successfully!', {
            listingUrl: `https://indianflatmates.co.uk/room/${slugify(formData.title)}-id-${newListing.id}`,
        });
        showToast('Listing created successfully!', 'success');

    } catch (e) {
        console.error("Error adding document or uploading images: ", e);
             showToast('Failed to create room listing. Please try again.', 'error');
    } finally {
        setIsSubmitting(false);
    }
};


    // ... (The JSX part of the component remains the same) ...
   return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md max-w-3xl mx-auto my-6">
            <h2 className="text-3xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">Create Room Listing 🏡</h2>
            <FillMyRoomBanner />
            {message && (
                <div className={`p-3 mb-4 rounded-md ${message.includes('successfully') ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'}`}>
                    {message}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <FormSection title="Lister & Contact Details">
   <div>
                        <label htmlFor="userName" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Your Name</label>
                        <input
                            type="text"
                            id="userName"
                            name="userName"
                            value={formData.userName}
                            onChange={handleChange} // ✨ ADD THIS LINE
                            required // ✨ ADD THIS LINE
                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100" // ✨ REMOVED 'readOnly' and 'cursor-not-allowed' related classes and attributes
                        />
                    </div>
                    <div>
                        <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Contact Number</label>
                        <input
                            type="tel"
                            id="phoneNumber"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            required
                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        />
                    </div>

                </FormSection>

                <FormSection title="Property & Listing Details">
                    <div>
                        <label htmlFor="title" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Title</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                            placeholder="e.g., Double room in a shared flat"
                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        />
                    </div>
                    <div>
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Description</label>
                        <textarea
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                            required
                            placeholder="Describe the property, room, current flatmates, and neighborhood."
                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        ></textarea>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="address" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Area/Locality</label>
                            <input
                                type="text"
                                id="address"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                required
                                placeholder="e.g., Wembley, Southall"
                                className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            />
                        </div>
                        <div>
                            <label htmlFor="postcode" className="block text-sm font-medium text-gray-700 dark:text-gray-300">City</label>
                            <input
                                type="text"
                                id="postcode"
                                name="postcode"
                                value={formData.postcode}
                                onChange={handleChange}
                                required
                                placeholder="e.g., London, UK"
                                className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            />
                        </div>
                    </div>
                </FormSection>

                <FormSection title="Rental Terms">
                       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="rent" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Rent (£ per month)</label>
                            <input
                                type="number"
                                id="rent"
                                name="rent"
                                value={formData.rent}
                                onChange={handleChange}
                                required
                                min="0"
                                className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            />
                        </div>
                        <div>
                            <label htmlFor="deposit" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Deposit (£)</label>
                            <input
                                type="number"
                                id="deposit"
                                name="deposit"
                                value={formData.deposit}
                                onChange={handleChange}
                                required
                                min="0"
                                className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="availableFrom" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Available From</label>
                        <input
                            type="date"
                            id="availableFrom"
                            name="availableFrom"
                            value={formData.availableFrom}
                            onChange={handleChange}
                            required
                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                        />
                    </div>
                </FormSection>

                <FormSection title="Room & Tenant Specifics">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Room Type</label>
                        <div className="flex flex-wrap gap-4">
                            {roomTypes.map(type => (
                                <label key={type} className="inline-flex items-center">
                                    <input
                                        type="checkbox"
                                        name="roomType"
                                        value={type}
                                        checked={formData.roomType.includes(type)}
                                        onChange={handleChange}
                                        className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700"
                                    />
                                    <span className="ml-2 text-gray-700 dark:text-gray-300">{type}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Preferred Tenants</label>
                        <div className="flex flex-wrap gap-4">
                            {tenantPreferences.map(pref => (
                                <label key={pref} className="inline-flex items-center">
                                    <input
                                        type="checkbox"
                                        name="preferredTenants"
                                        value={pref}
                                        checked={formData.preferredTenants.includes(pref)}
                                        onChange={handleChange}
                                        className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700"
                                    />
                                    <span className="ml-2 text-gray-700 dark:text-gray-300">{pref}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Amenities</label>
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                            {allAmenities.map(amenity => (
                                <label key={amenity} className="inline-flex items-center">
                                    <input
                                        type="checkbox"
                                        name="amenities"
                                        value={amenity}
                                        checked={formData.amenities.includes(amenity)}
                                        onChange={handleChange}
                                        className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700"
                                    />
                                    <span className="ml-2 text-gray-700 dark:text-gray-300">{amenity}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </FormSection>

                <FormSection title="Upload Images">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Images (max 10)</label>
                    <div
                        className="mt-1 flex justify-center items-center px-6 pt-5 pb-6 border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer"
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onClick={() => document.getElementById('image-upload').click()}
                    >
                        <div className="space-y-1 text-center">
                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L40 32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className="flex text-sm text-gray-600 dark:text-gray-400">
                                <p className="pl-1">Drag and drop or click to upload</p>
                            </div>
                            <p className="text-xs text-gray-500 dark:text-gray-400">PNG, JPG, GIF up to 10MB</p>
                        </div>
                        <input id="image-upload" name="images" type="file" className="sr-only" multiple accept="image/*" onChange={handleImageUpload} />
                    </div>
                    {imageFiles.length > 0 && (
                        <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            {imageFiles.map((file, index) => (
                                <div key={index} className="relative group rounded-lg overflow-hidden shadow-sm">
                                    <img src={URL.createObjectURL(file)} alt={`Room ${index + 1}`} className="w-full h-32 object-cover" />
                                    <button
                                        type="button"
                                        onClick={() => removeImage(index)}
                                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                        aria-label="Remove image"
                                    >
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </FormSection>

                <div className="mt-8 pt-5">
                    <div className="flex justify-center mb-4">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6Les14IrAAAAAObedQkVjoBfEFvmjneX3Wc94tt4" // <-- PASTE YOUR SITE KEY HERE
                            onChange={() => setIsVerified(true)}
                            onExpired={() => setIsVerified(false)}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSubmitting ? 'Processing...' : 'Create Listing'}
                    </button>
                </div>
            </form>
        </div>
    );
}


function ProfileUpdateForm({ onSuccess }) {
    const { db, storage, userId, userProfile } = useContext(AppContext);
    const [formData, setFormData] = useState({
        userName: userProfile?.userName || userProfile?.name || '',
        aboutMe: userProfile?.aboutMe || '',
        age: userProfile?.age || '',
        gender: userProfile?.gender || '',
        phoneNumber: userProfile?.phoneNumber || '',
        budget: userProfile?.budget || '',
        preferredLocations: userProfile?.preferredLocations || '',
        moveInDate: userProfile?.moveInDate || '',
        profession: userProfile?.profession || '',
        organization: userProfile?.organization || '',
        preferredRoommates: userProfile?.preferredRoommates || [],
        requirements: userProfile?.requirements || '',
        furnished: userProfile?.furnished || '',
        preferredStay: userProfile?.preferredStay || '',
        profilePicture: userProfile?.profilePicture || null,
        verificationId: userProfile?.verificationId || null,
        status: userProfile?.status || 'active',
        userId: userId,
        createdAt: userProfile?.createdAt || serverTimestamp(),
    });
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [uploading, setUploading] = useState(false);

    const roommatePreferences = ['Student', 'Professional', 'Male', 'Female', 'Vegetarian', 'Non-Vegetarian', 'Non-Smoker', 'Any'];
    const genderOptions = ['Male', 'Female', 'Other'];
    const furnishedOptions = ['Furnished', 'Unfurnished', 'Either'];
    const stayOptions = ['Short-term', 'Long-term', '6 months', '12 months', 'Other'];
const showToast = useToast();
    useEffect(() => {
        if (!formData.userName && (userProfile?.userName || userProfile?.name)) {
            setFormData(prev => ({
                ...prev,
                userName: userProfile?.userName || userProfile?.name || ''
            }));
        }
    }, [userProfile, formData.userName]);

    useEffect(() => {
        async function fetchRoommateProfile() {
            if (!db || !userId) return;
            const appId = getFirebaseConfig().appId;
            const docRef = doc(db, `artifacts/${appId}/public/data/roommate_requests/${userId}`);
            const snap = await getDoc(docRef);
            if (snap.exists()) {
                setFormData(prev => ({
                    ...prev,
                    ...snap.data(),
                }));
            }
        }
        fetchRoommateProfile();
    }, [db, userId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData(prev => ({
                ...prev,
                preferredRoommates: checked
                    ? [...prev.preferredRoommates, value]
                    : prev.preferredRoommates.filter(item => item !== value)
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleProfilePictureUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !storage || !userId) return;
        setUploading(true);
        setMessage('Uploading profile picture...');
        try {
            const compressedFile = await compressImage(file, { maxWidthOrHeight: 500 });

            const imageRef = ref(storage, `artifacts/${getFirebaseConfig().appId}/user_profiles/${userId}/profile_picture.jpg`);
            await uploadBytes(imageRef, compressedFile);
            const downloadURL = await getDownloadURL(imageRef);
            setFormData(prev => ({ ...prev, profilePicture: downloadURL }));
            setMessage('Profile picture uploaded successfully!');
        } catch (e) {
            console.error("Error uploading profile picture:", e);
            setMessage('Failed to upload profile picture. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    if (!db || !userId) {
        setMessage('Error: Database or user not ready.');
        return;
    }
    setIsSubmitting(true);
    setMessage('');
    const userNameToSave = formData.userName?.trim() || userProfile?.name || '';
    try {
        const appId = getFirebaseConfig().appId;
        const docRef = doc(db, `artifacts/${appId}/public/data/roommate_requests/${userId}`);
        await setDoc(docRef, {
            ...formData,
            userName: userNameToSave,
            userId,
            lastActivity: serverTimestamp(),
            status: formData.status || 'active',
        }, { merge: true });

        onSuccess('Profile updated successfully!');
        showToast('Profile updated successfully!', 'success');
    } catch (e) {
        setMessage('Failed to update profile. Please try again.');
        console.error("Error updating profile: ", e);
    } finally {
        setIsSubmitting(false);
    }
};

    const handleStatusToggle = async () => {
        if (!db || !userId) return;
        setIsSubmitting(true);
        const newStatus = formData.status === 'active' ? 'found' : 'active';
        try {
            const appId = getFirebaseConfig().appId;
            const docRef = doc(db, `artifacts/${appId}/public/data/roommate_requests/${userId}`);
            await updateDoc(docRef, { status: newStatus });
            setFormData(prev => ({ ...prev, status: newStatus }));
            setMessage({ type: 'success', text: `Profile status updated to '${newStatus}'.`});
        } catch (e) {
            setMessage({ type: 'error', text: 'Failed to update status. Please try again.'});
            console.error("Error updating status: ", e);
        } finally {
            setIsSubmitting(false);
        }
    };

      const formFieldClasses = "mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100 dark:placeholder-gray-400";
    const labelClasses = "block text-sm font-medium text-gray-700 dark:text-gray-300";

    return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md max-w-3xl mx-auto my-6">
            <h2 className="text-3xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">Update Your Roommate Profile 🧑‍🤝‍🧑</h2>
            {message && (
                <div className={`p-3 mb-4 rounded-md ${message.type === 'success' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'}`}>
                    {message.text}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <FormSection title="Personal & Contact Information">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className={labelClasses}>Full Name</label>
                            <input type="text" name="userName" value={formData.userName} onChange={handleChange} required className={formFieldClasses} />
                        </div>
                        <div>
                            <label className={labelClasses}>Contact Number</label>
                            <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required className={formFieldClasses} />
                        </div>
                        <div>
                            <label className={labelClasses}>Age</label>
                            <input type="number" name="age" value={formData.age} onChange={handleChange} required min="17" max="99" className={formFieldClasses} />
                        </div>
                        <div>
                            <label className={labelClasses}>Gender</label>
                            <select name="gender" value={formData.gender} onChange={handleChange} required className={formFieldClasses}>
                                <option value="">Select</option>
                                {genderOptions.map(g => <option key={g} value={g}>{g}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="mt-6">
                        <label className={labelClasses}>My Requirements (Summary)</label>
                        <textarea name="requirements" value={formData.requirements} onChange={handleChange} rows="3" required placeholder="I am Looking for Full Furnished, Private Room in London..." className={formFieldClasses} />
                    </div>
                    <div className="mt-6">
                        <label className={labelClasses}>About Me</label>
                        <textarea name="aboutMe" value={formData.aboutMe} onChange={handleChange} rows="3" required placeholder="Tell potential flatmates a bit about yourself, your lifestyle, and what you're like to live with." className={formFieldClasses} />
                    </div>
                    <div className="mt-6">
                        <label className={labelClasses}>Upload Profile Picture</label>
                        <input type="file" accept="image/*" onChange={handleProfilePictureUpload} className="mt-1 block w-full text-sm text-gray-900 dark:text-gray-100 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100" />
                        {formData.profilePicture && <img src={formData.profilePicture} alt="Profile" className="w-24 h-24 rounded-full object-cover mt-2" />}
                    </div>
                </FormSection>

                <FormSection title="Professional & Educational Status">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                           <label className={labelClasses}>Profession</label>
                           <input type="text" name="profession" value={formData.profession} onChange={handleChange} placeholder="e.g., Software Engineer, Masters Student" className={formFieldClasses} />
                        </div>
                       <div>
                           <label className={labelClasses}>Organization</label>
                           <input type="text" name="organization" value={formData.organization} onChange={handleChange} placeholder="e.g., Google, University of London" className={formFieldClasses} />
                       </div>
                    </div>
                </FormSection>

                <FormSection title="Room Search Preferences">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className={labelClasses}>Budget (£ per month)</label>
                            <input type="number" name="budget" value={formData.budget} onChange={handleChange} required min="0" className={formFieldClasses} />
                        </div>
                       <div>
                            <label className={labelClasses}>Move-in Date</label>
                            <input type="date" name="moveInDate" value={formData.moveInDate} onChange={handleChange} required className={formFieldClasses} />
                       </div>
                    </div>
                    <div>
                        <label className={labelClasses}>Preferred Location(s)</label>
                        <input type="text" name="preferredLocations" value={formData.preferredLocations} onChange={handleChange} required placeholder="e.g., Slough, Canary Wharf, Southall" className={formFieldClasses} />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className={labelClasses}>Room Preference</label>
                            <select name="furnished" value={formData.furnished} onChange={handleChange} required className={formFieldClasses}>
                                <option value="">Select</option>
                                {furnishedOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                            </select>
                        </div>
                       <div>
                           <label className={labelClasses}>Preferred Stay Duration</label>
                           <select name="preferredStay" value={formData.preferredStay} onChange={handleChange} required className={formFieldClasses}>
                               <option value="">Select</option>
                               {stayOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                           </select>
                       </div>
                    </div>
                </FormSection>

                <FormSection title="Desired Roommate Characteristics">
                    <div className="flex flex-wrap gap-4">
                        {roommatePreferences.map(pref => (
                            <label key={pref} className="inline-flex items-center text-gray-700 dark:text-gray-300">
                                <input type="checkbox" name="preferredRoommates" value={pref} checked={formData.preferredRoommates.includes(pref)} onChange={handleChange} className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700" />
                                <span className="ml-2">{pref}</span>
                            </label>
                        ))}
                    </div>
                </FormSection>

                <FormSection title="Manage Your Search Status">
                    <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <div className="text-center">
                            <span className="text-sm font-medium text-gray-800 dark:text-gray-200">Current Status: </span>
                            <span className={`font-bold px-2 py-1 rounded-md text-sm ${formData.status === 'active' ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100'}`}>
                                {formData.status === 'active' ? 'Actively Looking' : 'Room Found'}
                            </span>
                        </div>
                        <button type="button" onClick={handleStatusToggle} disabled={isSubmitting || uploading} className={`w-full sm:w-auto py-2 px-4 border rounded-md font-medium text-white transition disabled:opacity-50 ${formData.status === 'active' ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'}`}>
                            Mark as {formData.status === 'active' ? 'Found' : 'Active'}
                        </button>
                    </div>
                    <p className="text-xs text-center text-gray-500 dark:text-gray-400 mt-2">
                        If you've found a room, mark your profile as "Found". This will move your profile to the bottom of search results and let others know you're no longer looking.
                    </p>
                </FormSection>

                <div className="mt-8 pt-5">
                    <button type="submit" disabled={isSubmitting || uploading} className="w-full py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50">
                        {isSubmitting || uploading ? 'Saving...' : 'Update Profile Details'}
                    </button>
                </div>
            </form>
        </div>
    );
}

async function compressImage(file, options = {}) {
  // Default options aim for just under 100KB
  const defaultOptions = {
    maxSizeMB: 0.07,         // Target ~70KB
    maxWidthOrHeight: 1280,    // Lower the resolution
    useWebWorker: true,
    initialQuality: 0.7       // (Optional) Start compression at a lower quality
  };

  // Merge default options with any custom options provided
  const compressionOptions = { ...defaultOptions, ...options };

  try {
    console.log(`Original file size: ${(file.size / 1024).toFixed(2)} KB`);
    // Loaded on demand: only needed when someone uploads a photo
    const { default: imageCompression } = await import('browser-image-compression');
    const compressedFile = await imageCompression(file, compressionOptions);
    console.log(`Compressed file size: ${(compressedFile.size / 1024).toFixed(2)} KB`);
    return compressedFile;
  } catch (error) {
    console.error('Image compression failed:', error);
    // If compression fails, return the original file to prevent upload failure
    return file;
  }
}



function getInitials(name = "") {
    if (!name) return "PP";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// ✨ MODIFIED: Add this updated component to your file
function LandingPageHeader() {
    return (
        <div className="mb-6 md:mb-8 text-center"> {/* Reduced bottom margin on mobile */}
            <h1 className="text-2xl md:text-3xl font-bold text-indigo-700 dark:text-indigo-300 mb-3 md:mb-4"> {/* Smaller text on mobile */}
                Find Indian Flatmates & Rooms in London, UK
            </h1>
            <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 max-w-3xl mx-auto"> {/* Smaller text on mobile */}
                Are you an Indian student or professional looking for a flat, room, or roommate in London and other UK cities? Browse active listings below or sign up to post your own request.
            </p>
        </div>
    );
}

// Reusable WhatsApp + Call buttons for premium users
function ContactButtons({ phoneNumber, waMessage, size = 'normal', className = '' }) {
    const [isDesktop, setIsDesktop] = React.useState(window.innerWidth >= 1024);

    React.useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!phoneNumber) return null;
    const cleaned = phoneNumber.replace(/\D/g, '');
    const intl = cleaned.startsWith('0') ? '44' + cleaned.slice(1) : cleaned;
    const waUrl = `https://wa.me/${intl}?text=${encodeURIComponent(waMessage)}`;
    const sm = size === 'small';
    const btnBase = sm
        ? 'flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-full transition-colors'
        : 'flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-full transition-colors';
    return (
        <div className={`flex gap-2 flex-wrap items-center ${className}`} onClick={e => e.stopPropagation()}>
            <a href={waUrl} target="_blank" rel="noopener noreferrer"
               className={`${btnBase} bg-green-500 hover:bg-green-600 text-white`}>
                <svg className={sm ? 'w-3 h-3' : 'w-4 h-4'} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.267.651 4.383 1.803 6.166l-1.225 4.469 4.575-1.201zM18.33 14.229c-.301-.15-1.767-.867-2.04-.967-.272-.1-.47-.15-.67.15-.197.299-.771.966-.944 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.299-.018-.462.13-.611.134-.133.297-.347.446-.52.15-.174.199-.299.298-.498.1-.199.05-.374-.025-.524-.075-.15-.67-1.612-.916-2.206-.242-.58-.487-.5-.67-.506-.183-.006-.38-.006-.579-.006-.199 0-.523.074-.797.373-.273.3-.981.957-.981 2.322 0 1.365 1.007 2.699 1.157 2.897.149.199 1.958 3.024 4.793 4.22 2.836 1.196 2.836.797 3.344.746.508-.05 1.767-.717 2.016-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.199-.57-.347z"/>
                </svg>
                WhatsApp
            </a>
            <a href={`tel:${phoneNumber}`}
               className={`${btnBase} bg-blue-500 hover:bg-blue-600 text-white`}>
                <svg className={sm ? 'w-3 h-3' : 'w-4 h-4'} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.948V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z"/>
                </svg>
                Call
            </a>
            {isDesktop && (
                <div className={`hidden lg:block ${sm ? 'text-xs' : 'text-sm'} font-semibold text-gray-700 dark:text-gray-300 pl-2 border-l border-gray-300 dark:border-gray-600`}>
                    <a href={`tel:${phoneNumber}`} className="hover:text-blue-500 transition-colors">
                        {phoneNumber}
                    </a>
                </div>
            )}
        </div>
    );
}

function RoommateTeaserRow() {
    const { db, userId, setShowAuthModal } = useContext(AppContext);
    const navigate = useNavigate();
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!db) return;
        let cancelled = false;
        (async () => {
            try {
                const appId = getFirebaseConfig().appId;
                const q = query(
                    collection(db, `artifacts/${appId}/public/data/roommate_requests`),
                    orderBy('status', 'asc'),
                    orderBy('lastActivity', 'desc'),
                    limit(8)
                );
                const snap = await getDocs(q);
                if (cancelled) return;
                setProfiles(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(p => p.status === 'active'));
            } catch (e) {
                console.error('Failed to load roommate teaser:', e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [db]);

    if (loading || profiles.length < 3) return null;

    const handleCardClick = (profile) => {
        const titleSlug = slugify(profile.requirements || profile.userName || 'profile');
        navigate(`/roommate/${titleSlug}-id-${profile.id}`);
    };

    const handleContactClick = (e) => {
        e.stopPropagation();
        if (!userId) setShowAuthModal(true);
    };

    return (
        <div className="bg-white dark:bg-gray-800 p-4 md:p-6 rounded-lg shadow-md my-6">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg md:text-xl font-bold text-indigo-700 dark:text-indigo-300">
                    👥 People looking for rooms
                </h3>
                <Link to="/roommates" className="text-sm font-semibold text-indigo-600 dark:text-indigo-400 hover:underline whitespace-nowrap">
                    See all →
                </Link>
            </div>
            <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 -mx-4 px-4 md:mx-0 md:px-0">
                {profiles.map(p => (
                    <div
                        key={p.id}
                        onClick={() => handleCardClick(p)}
                        className="snap-start shrink-0 w-64 md:w-72 bg-gray-50 dark:bg-gray-700 p-4 rounded-lg shadow-sm hover:shadow-lg transition cursor-pointer flex flex-col"
                    >
                        <div className="flex items-center mb-3">
                            {p.profilePicture ? (
                                <img src={p.profilePicture} alt="" loading="lazy" decoding="async" className="w-12 h-12 rounded-full object-cover mr-3 border-2 border-indigo-500" />
                            ) : (
                                <div className="w-12 h-12 rounded-full bg-indigo-200 text-indigo-800 flex items-center justify-center text-lg font-bold mr-3 border-2 border-indigo-500 shrink-0">
                                    {getInitials(p.userName || 'U')}
                                </div>
                            )}
                            <div className="min-w-0">
                                <div className="font-bold text-indigo-600 dark:text-indigo-400 line-clamp-1">
                                    {(p.userName || 'Room Seeker').split(' ')[0]}
                                    {p.age ? `, ${p.age}` : ''}
                                </div>
                                <div className="text-xs text-gray-500 dark:text-gray-300 line-clamp-1">
                                    {[p.profession, p.gender].filter(Boolean).join(' · ')}
                                </div>
                            </div>
                        </div>
                        <div className="space-y-1 text-xs text-gray-700 dark:text-gray-300 mb-3">
                            {p.budget && (
                                <div><span className="font-semibold">Budget:</span> <span className="font-bold text-green-600 dark:text-green-400">£{p.budget}/mo</span></div>
                            )}
                            {p.preferredLocations && (
                                <div className="line-clamp-1"><span className="font-semibold">Area:</span> {p.preferredLocations}</div>
                            )}
                            {p.moveInDate && (
                                <div className="line-clamp-1"><span className="font-semibold">Move-in:</span> {formatDateForDisplay(p.moveInDate)}</div>
                            )}
                        </div>
                        <button
                            onClick={handleContactClick}
                            className="mt-auto w-full px-3 py-2 text-xs font-semibold rounded-md bg-indigo-600 hover:bg-indigo-700 text-white transition"
                        >
                            Contact {(p.userName || 'member').split(' ')[0]} →
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

function BrowsePosts({ transientMessage, isPublicView = false, locationFilter = '', hideHeader = false, initialMode = 'rooms' }) {
    const { db, userRole, setShowPricingModal, userProfile, userId, setShowAuthModal, setPendingPremiumUnlock } = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [lastVisible, setLastVisible] = useState(null);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // Public-view tab state, synced with ?tab=roommates|rooms
    const initialTab = (() => {
        if (!isPublicView) return 'rooms';
        const params = new URLSearchParams(location.search);
        const t = params.get('tab');
        if (t === 'rooms' || t === 'roommates') return t;
        return initialMode === 'roommates' ? 'roommates' : 'rooms';
    })();
    const [publicTab, setPublicTab] = useState(initialTab);

    const handleTabChange = (tab) => {
        if (tab === publicTab) return;
        setPublicTab(tab);
        const params = new URLSearchParams(location.search);
        if (tab === (initialMode === 'roommates' ? 'roommates' : 'rooms')) {
            params.delete('tab');
        } else {
            params.set('tab', tab);
        }
        const qs = params.toString();
        navigate(`${location.pathname}${qs ? `?${qs}` : ''}`, { replace: false });
    };

    const PAGE_SIZE = 12;
    const effectiveRole = isPublicView
        ? (publicTab === 'roommates' ? 'I Have Room' : 'I Need Room')
        : userRole;
    const collectionPath = effectiveRole === 'I Have Room' ?
        `artifacts/${getFirebaseConfig().appId}/public/data/roommate_requests` :
        `artifacts/${getFirebaseConfig().appId}/public/data/room_listings`;

    const fetchAndProcessPosts = async (cursor = null) => {
       try {
           const appId = getFirebaseConfig().appId;
           const profilesRef = collection(db, `artifacts/${appId}/public/data/user_profiles`);

           if (!cursor) {
               // Initial load: fetch premium user IDs and first batch of posts in parallel
               const [premiumProfilesSnap, regularSnap] = await Promise.all([
                   getDocs(query(profilesRef, where('isPremium', '==', true))),
                   getDocs(query(
                       collection(db, collectionPath),
                       orderBy('status', 'asc'),
                       orderBy('lastActivity', 'desc'),
                       limit(PAGE_SIZE)
                   ))
               ]);

               const premiumUserIds = premiumProfilesSnap.docs.map(d => d.id);
               const regularPosts = regularSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

               // Fetch all posts belonging to premium users
               let allPremiumPosts = [];
               if (premiumUserIds.length > 0) {
                   const CHUNK_SIZE = 10;
                   const premiumPostPromises = [];
                   for (let i = 0; i < premiumUserIds.length; i += CHUNK_SIZE) {
                       const chunk = premiumUserIds.slice(i, i + CHUNK_SIZE);
                       premiumPostPromises.push(
                           getDocs(query(collection(db, collectionPath), where('userId', 'in', chunk)))
                       );
                   }
                   const premiumSnaps = await Promise.all(premiumPostPromises);
                   premiumSnaps.forEach(snap => {
                       snap.forEach(doc => allPremiumPosts.push({ id: doc.id, ...doc.data(), isPremium: true }));
                   });
                   // Sort premium posts: active first, then by most recent activity
                   allPremiumPosts.sort((a, b) => {
                       if (a.status !== b.status) return a.status < b.status ? -1 : 1;
                       const aTime = a.lastActivity?.toMillis ? a.lastActivity.toMillis() : 0;
                       const bTime = b.lastActivity?.toMillis ? b.lastActivity.toMillis() : 0;
                       return bTime - aTime;
                   });
               }

               // Remove from regular batch any posts already included as premium
               const premiumPostIds = new Set(allPremiumPosts.map(p => p.id));
               const nonPremiumPosts = regularPosts
                   .filter(p => !premiumPostIds.has(p.id))
                   .map(p => ({ ...p, isPremium: false }));

               setPosts([...allPremiumPosts, ...nonPremiumPosts]);

               const lastDoc = regularSnap.docs[regularSnap.docs.length - 1];
               setLastVisible(lastDoc);
               setHasMore(regularSnap.docs.length === PAGE_SIZE);

           } else {
               // Load more: fetch next batch using cursor
               const q = query(
                   collection(db, collectionPath),
                   orderBy('status', 'asc'),
                   orderBy('lastActivity', 'desc'),
                   startAfter(cursor),
                   limit(PAGE_SIZE)
               );
               const documentSnapshots = await getDocs(q);
               const fetchedPosts = documentSnapshots.docs.map(doc => ({ id: doc.id, ...doc.data() }));

               if (fetchedPosts.length === 0) {
                   setHasMore(false);
                   return;
               }

               // Get premium status for the new batch's authors
               const authorIds = [...new Set(fetchedPosts.map(p => p.userId).filter(Boolean))];
               const premiumStatusMap = {};
               if (authorIds.length > 0) {
                   const CHUNK_SIZE = 10;
                   const profilePromises = [];
                   for (let i = 0; i < authorIds.length; i += CHUNK_SIZE) {
                       const chunk = authorIds.slice(i, i + CHUNK_SIZE);
                       profilePromises.push(getDocs(query(profilesRef, where(documentId(), 'in', chunk))));
                   }
                   const allProfileSnapshots = await Promise.all(profilePromises);
                   allProfileSnapshots.forEach(snapshot => {
                       snapshot.forEach(doc => {
                           premiumStatusMap[doc.id] = doc.data().isPremium || false;
                       });
                   });
               }

               const newPostsWithStatus = fetchedPosts.map(post => ({
                   ...post,
                   isPremium: premiumStatusMap[post.userId] || false,
               }));

               // Append new posts and re-sort so all premium posts stay at the top
               setPosts(prevPosts => {
                   const combined = [...prevPosts, ...newPostsWithStatus];
                   const premium = combined.filter(p => p.isPremium);
                   const nonPremium = combined.filter(p => !p.isPremium);
                   return [...premium, ...nonPremium];
               });

               const lastDoc = documentSnapshots.docs[documentSnapshots.docs.length - 1];
               setLastVisible(lastDoc);
               setHasMore(documentSnapshots.docs.length === PAGE_SIZE);
           }

       } catch (err) {
           console.error("Error fetching posts:", err);
           setError("Failed to load posts.");
       }
   };

    useEffect(() => {
        if (!db) return;
        setLoading(true);
        fetchAndProcessPosts().finally(() => setLoading(false));
    }, [db, collectionPath]);

    const handleLoadMore = () => {
        if (!loadingMore && hasMore) {
            setLoadingMore(true);
            fetchAndProcessPosts(lastVisible).finally(() => setLoadingMore(false));
        }
    };

    const handleViewPost = (post, isRoomListing) => {
        const postType = isRoomListing ? 'room' : 'roommate';
        const titleSlug = slugify(isRoomListing ? post.title : post.requirements);
        navigate(`/${postType}/${titleSlug}-id-${post.id}`);
    };

    const filteredPosts = posts.filter(post => {
        let matchesLocation = true;
        if (locationFilter) {
            const locationPart = locationFilter.toLowerCase().split('-india-')[0];
            const locationWithSpace = locationPart.replace(/-/g, ' ');
            let searchableLocation = '';
            if (effectiveRole === 'I Have Room') {
                searchableLocation = (post.preferredLocations || '').toLowerCase();
            } else {
                searchableLocation = ((post.address || '') + ' ' + (post.postcode || '')).toLowerCase();
            }
            matchesLocation = searchableLocation.includes(locationWithSpace);
        }

        let matchesSearch = true;
        if (searchTerm) {
            const searchLower = searchTerm.toLowerCase();
            if (effectiveRole === 'I Have Room') {
                matchesSearch = (
                    (post.userName?.toLowerCase().includes(searchLower)) ||
                    (post.aboutMe?.toLowerCase().includes(searchLower)) ||
                    (post.preferredLocations?.toLowerCase().includes(searchLower))
                );
            } else {
                matchesSearch = (
                    post.title?.toLowerCase().includes(searchLower) ||
                    post.description?.toLowerCase().includes(searchLower) ||
                    post.address?.toLowerCase().includes(searchLower) ||
                    post.postcode?.toLowerCase().includes(searchLower)
                );
            }
        }
        return matchesLocation && matchesSearch;
    });

    if (loading) return <div className="text-center py-8">Loading posts...</div>;
    if (error) return <div className="text-center py-8 text-red-600">Error: {error}</div>;

    return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md my-6">
            {transientMessage && (
                <div className={`p-4 mb-6 rounded-md text-center font-semibold ${transientMessage.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                    {transientMessage.text}
                </div>
            )}
            {isPublicView ? (hideHeader ? null : <LandingPageHeader />) : (
                <h2 className="text-3xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">
                    {effectiveRole === 'I Have Room' ? 'Browse Roommate Requests' : 'Browse Room Listings'}
                </h2>
            )}
            {isPublicView && (
                <div className="flex gap-2 mb-4 border-b border-gray-200 dark:border-gray-700">
                    <button
                        onClick={() => handleTabChange('rooms')}
                        className={`px-4 py-2 font-semibold text-sm transition-colors border-b-2 -mb-px ${
                            publicTab === 'rooms'
                                ? 'text-indigo-600 dark:text-indigo-400 border-indigo-600 dark:border-indigo-400'
                                : 'text-gray-500 dark:text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200'
                        }`}
                    >
                        🏠 Rooms
                    </button>
                    <button
                        onClick={() => handleTabChange('roommates')}
                        className={`px-4 py-2 font-semibold text-sm transition-colors border-b-2 -mb-px ${
                            publicTab === 'roommates'
                                ? 'text-indigo-600 dark:text-indigo-400 border-indigo-600 dark:border-indigo-400'
                                : 'text-gray-500 dark:text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200'
                        }`}
                    >
                        👥 Roommates
                    </button>
                </div>
            )}
            <div className="mb-6">
                <input
                    type="text"
                    placeholder={`Search by ${effectiveRole === 'I Have Room' ? 'bio, location' : 'title, area, city'}...`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700"
                />
            </div>
            {filteredPosts.length === 0 ? (
                <p className="text-center text-gray-600 dark:text-gray-400">No posts found.</p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                     {filteredPosts.map(post => (
                        <div
                            key={post.id}
                            className={`bg-gray-50 dark:bg-gray-700 p-5 rounded-lg shadow-sm hover:shadow-lg transition-all duration-200 cursor-pointer flex flex-col relative ${post.status !== 'active' ? 'grayscale opacity-70' : ''} ${post.isPremium ? 'border-2 border-yellow-400' : ''}`}
                            onClick={() => handleViewPost(post, effectiveRole !== 'I Have Room')}
                        >
                            {post.isPremium && (
                                <div className="absolute top-2 left-2 z-10">
                                    <PremiumBadge isPremium={true} variant="small" />
                                </div>
                            )}
                            {post.status !== 'active' && (
                                <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10 shadow-md">
                                    {effectiveRole === 'I Need Room' ? 'FILLED' : 'FOUND'}
                                </div>
                            )}
                            {(post.status === 'active' || !post.status) && (
                                <CardShareButton
                                    post={post}
                                    isRoomListing={effectiveRole !== 'I Have Room'}
                                    className={`absolute z-10 ${effectiveRole === 'I Have Room' ? 'top-3 right-3' : 'top-7 right-7'}`}
                                />
                            )}
                             {effectiveRole === 'I Have Room' ? (
                                <>
                                    <div className="flex items-center mb-4 pr-10">
                                        {post.profilePicture ? (
                                            <img src={post.profilePicture} alt="Profile" loading="lazy" decoding="async" className="w-16 h-16 rounded-full object-cover mr-4 border-2 border-indigo-500"/>
                                        ) : (
                                            <div className="w-16 h-16 rounded-full bg-indigo-200 text-indigo-800 flex items-center justify-center text-xl font-bold mr-4 border-2 border-indigo-500" style={{ minWidth: "4rem" }}>
                                                {getInitials(post.userName || "U")}
                                            </div>
                                        )}
                                        <div>
                                            <h3 className="text-lg font-bold text-indigo-600 dark:text-indigo-400 line-clamp-1">{post.userName || 'Room Seeker'}</h3>
                                            <div className="text-xs text-gray-500 dark:text-gray-300">{post.profession} ({post.gender}, Age {post.age})</div>
                                        </div>
                                    </div>
                                    <p className="text-gray-600 dark:text-gray-400 text-sm mt-2 flex-grow line-clamp-2">{post.requirements}</p>
                                    <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300 mb-4">
                                        <div className="flex items-center">
                                            <span className="font-semibold w-24">Budget:</span>
                                            <span className="text-lg font-bold text-green-600 dark:text-green-400">£{post.budget} / month</span>
                                        </div>
                                        <div className="flex items-start">
                                            <span className="font-semibold w-24 shrink-0">Looking in:</span>
                                            <span className="flex-1 line-clamp-1">{post.preferredLocations}</span>
                                        </div>
   <div className="flex items-center">
    <span className="font-semibold w-24">Move-in:</span>
    {/* ✨ CHANGE HERE */}
    <span>{formatDateForDisplay(post.moveInDate)}</span>
</div>
                                        <div className="flex items-start">
                                            <span className="font-semibold w-24 shrink-0">Wants to live with:</span>
                                            <span className="flex-1 line-clamp-1">{Array.isArray(post.preferredRoommates) && post.preferredRoommates.length > 0 ? post.preferredRoommates.join(', ') : 'Any'}</span>
                                        </div>
                                    </div>

                                    <p className="text-gray-600 dark:text-gray-400 text-sm mt-2 flex-grow line-clamp-2">{maskPhoneNumbers(post.aboutMe)}</p>
                                    {post.phoneNumber && (
                                        <div className="mt-3">
                                            <LockedContactInfo
                                                isPremium={userProfile?.isPremium || false}
                                                phoneNumber={post.phoneNumber}
                                                userName={post.userName}
                                                onUnlockClick={() => {
                                                    if (!userId) {
                                                        setPendingPremiumUnlock(post);
                                                        setShowAuthModal(true);
                                                    } else {
                                                        setShowPricingModal(true);
                                                    }
                                                }}
                                                variant="inline"
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                {(post.images && post.images.length > 0) ? (
                                    <img src={post.images[0]} alt={post.title} loading="lazy" decoding="async" className="w-full h-48 object-cover rounded-md mb-4"/>
                                ) : (
                                    <div className="w-full h-48 rounded-md mb-4 bg-gray-200 dark:bg-gray-600 flex items-center justify-center">
                                        <svg className="w-16 h-16 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                                        </svg>
                                    </div>
                                )}
                                    <h3 className="text-xl font-semibold text-indigo-600 dark:text-indigo-400 mb-2 line-clamp-1">{maskPhoneNumbers(post.title)}</h3>

                                    <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300 mb-4">
                                        <div className="flex items-center">
                                            <span className="font-semibold w-24 shrink-0">Rent:</span>
                                            <span className="text-lg font-bold text-green-600 dark:text-green-400">£{post.rent} / month</span>
                                        </div>
                                        <div className="flex items-start">
                                            <span className="font-semibold w-24 shrink-0">Location:</span>
                                            <span className="flex-1 line-clamp-1">{post.address}, {post.postcode}</span>
                                        </div>
                                        <div className="flex items-center">
    <span className="font-semibold w-24 shrink-0">Available:</span>
    <span className="flex-1 line-clamp-1">{formatDateForDisplay(post.availableFrom)}</span>
</div>
                                        <div className="flex items-start">
                                            <span className="font-semibold w-24 shrink-0">Room Type:</span>
                                            <span className="flex-1 line-clamp-1">{Array.isArray(post.roomType) ? post.roomType.join(', ') : 'N/A'}</span>
                                        </div>
                                        <div className="flex items-start">
                                            <span className="font-semibold w-24 shrink-0">Tenants:</span>
                                            <span className="flex-1 line-clamp-1">{Array.isArray(post.preferredTenants) ? post.preferredTenants.join(', ') : 'Any'}</span>
                                        </div>
                                    </div>

                                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 flex-grow line-clamp-2">
                                        {maskPhoneNumbers(post.description)}
                                    </p>

                                    <div className="flex flex-wrap gap-2 text-sm text-gray-600 dark:text-gray-400 mt-auto">
                                        {post.amenities?.slice(0, 3).map(amenity => (
                                            <span key={amenity} className="bg-gray-200 dark:bg-gray-600 px-2 py-1 rounded-full text-xs">
                                                {amenity}
                                            </span>
                                        ))}
                                        {post.amenities?.length > 3 && (
                                            <span className="bg-gray-200 dark:bg-gray-600 px-2 py-1 rounded-full text-xs">
                                                +{post.amenities.length - 3} more
                                            </span>
                                        )}
                                    </div>
                                    {post.isPremium && post.phoneNumber && (
                                        <ContactButtons
                                            phoneNumber={post.phoneNumber}
                                            waMessage={`Hi ${post.userName}, I saw your room listing "${post.title}" on IndianFlatmates.co.uk. I'm interested and would like to arrange a viewing. Please let me know when you're available.`}
                                            size="small"
                                            className="mt-3"
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* --- "Load More" button --- */}
 {hasMore && (
                <div className="text-center mt-8">
                    <button onClick={handleLoadMore} disabled={loadingMore} className="px-6 py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700">
                        {loadingMore ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}
            {/* ✅ FIX: The PostDetailModal is NO LONGER rendered here. */}
        </div>
    );
}

// Most listings are never taken down once filled, so warn visitors on old ones
const OLD_POST_DAYS = 90;
function OldPostNotice({ post, isRoomListing }) {
    const timestamp = post.lastActivity || post.createdAt;
    if (!timestamp?.toMillis) return null;
    const ageDays = Math.floor((Date.now() - timestamp.toMillis()) / 86400000);
    if (ageDays < OLD_POST_DAYS) return null;
    const months = Math.floor(ageDays / 30);
    return (
        <div className="mb-4 p-3 rounded-md bg-amber-50 dark:bg-amber-900/30 border-l-4 border-amber-400 text-sm text-amber-900 dark:text-amber-100">
            {isRoomListing
                ? `This listing was last updated about ${months} months ago, so the room may already be taken. Message first to check before planning a viewing.`
                : `This profile was last updated about ${months} months ago, so they may have already found a room.`}
        </div>
    );
}

// A few more rooms from the same area, so visitors who land on a listing
// that doesn't suit them have somewhere to go next
function OtherRoomsInArea({ post }) {
    const { db } = useContext(AppContext);
    const area = areasMentionedIn(`${post.address || ''} ${post.title || ''}`)[0];
    const areaSlug = area?.slug; // a string, so the effect doesn't re-run every render
    const [rooms, setRooms] = useState([]);

    useEffect(() => {
        if (!db || !areaSlug) return;
        let cancelled = false;
        const load = async () => {
            try {
                const q = query(
                    collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/room_listings`),
                    orderBy('status', 'asc'),
                    orderBy('lastActivity', 'desc'),
                    limit(60)
                );
                const snap = await getDocs(q);
                const matches = snap.docs
                    .map(d => ({ id: d.id, ...d.data() }))
                    .filter(r => r.id !== post.id && areasMentionedIn(`${r.address || ''} ${r.title || ''}`).some(a => a.slug === areaSlug))
                    .slice(0, 3);
                if (!cancelled) setRooms(matches);
            } catch (e) {
                console.error('Failed to load other rooms:', e);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [db, areaSlug, post.id]);

    if (!area || rooms.length === 0) return null;

    return (
        <section className="max-w-4xl mx-auto mt-8 mb-6 px-4">
            <div className="flex items-baseline justify-between mb-3">
                <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Other rooms in {area.name}</h2>
                <Link to={`/rooms/${area.slug}`} className="text-sm text-indigo-600 dark:text-indigo-400 hover:underline">See all →</Link>
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {rooms.map(r => (
                    <li key={r.id}>
                        <Link to={`/room/${slugify(r.title)}-id-${r.id}`} className="block h-full bg-white dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition-shadow overflow-hidden">
                            {r.images?.[0] && <img src={r.images[0]} alt={cleanText(maskPhoneNumbers(r.title || 'Room'))} loading="lazy" decoding="async" className="w-full h-32 object-cover" />}
                            <div className="p-3">
                                <p className="font-semibold text-gray-800 dark:text-gray-100 line-clamp-2">{cleanText(maskPhoneNumbers(r.title || 'Room'))}</p>
                                <p className="text-sm text-green-700 dark:text-green-400 font-semibold mt-1">£{r.rent}/month</p>
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </section>
    );
}

// Links from a listing/profile to the area pages it mentions
function AreaLinks({ post, isRoomListing }) {
    const matches = isRoomListing
        ? areasMentionedIn(`${post.address || ''} ${post.title || ''}`).slice(0, 1)
        : areasMentionedIn(post.preferredLocations || '').slice(0, 4);
    if (matches.length === 0) return null;
    return (
        <p className="mb-4 text-sm">
            {isRoomListing ? (
                <Link to={`/rooms/${matches[0].slug}`} className="text-indigo-600 dark:text-indigo-400 font-medium hover:underline">
                    More rooms in {matches[0].name} →
                </Link>
            ) : (
                <>
                    <span className="text-gray-600 dark:text-gray-400">Browse rooms in: </span>
                    {matches.map((m, i) => (
                        <React.Fragment key={m.slug}>
                            {i > 0 && <span className="text-gray-400"> · </span>}
                            <Link to={`/rooms/${m.slug}`} className="text-indigo-600 dark:text-indigo-400 font-medium hover:underline">{m.name}</Link>
                        </React.Fragment>
                    ))}
                </>
            )}
        </p>
    );
}

function PostDetailView({ post, isRoomListing, onStartChat }) {
    const { userId, userProfile, setShowPricingModal, setShowAuthModal, setPendingPremiumUnlock } = useContext(AppContext);
    const navigate = useNavigate();
    const images = post.images || [];
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    const handleBackNavigation = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate('/', { replace: true });
        }
    };

    const handleInitiateChat = () => {
        onStartChat(post);
    };

    const openLightbox = (idx) => {
        setLightboxIndex(idx);
        setLightboxOpen(true);
    };
    const closeLightbox = () => setLightboxOpen(false);
    const prevImage = () => setLightboxIndex((prev) => (prev - 1 + images.length) % images.length);
    const nextImage = () => setLightboxIndex((prev) => (prev + 1) % images.length);

    useEffect(() => {
        if (!lightboxOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === "ArrowLeft") prevImage();
            else if (e.key === "ArrowRight") nextImage();
            else if (e.key === "Escape") closeLightbox();
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [lightboxOpen, images.length]);

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl mx-auto my-8 overflow-y-auto p-6">

            <div className="flex items-center justify-between gap-3 mb-4">
            {/* ✨ MODIFIED: Back Button now uses the smart handler */}
            <button
                onClick={handleBackNavigation}
                className="inline-flex items-center gap-2 text-indigo-600 dark:text-indigo-400 hover:underline text-sm font-semibold"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                {isRoomListing ? 'Back to Listings' : 'Back to Roommate Profiles'}
            </button>
            {/* Share at the top too — the full share buttons are at the bottom of a long page */}
            {(post.status === 'active' || !post.status) && (
                <ShareButton post={post} isRoomListing={isRoomListing} compact />
            )}
            </div>
                <div className="relative">
                {post.isPremium && (
                     <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 text-sm font-bold px-4 py-1 rounded-full z-10 shadow-md flex items-center">
                        <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                        Premium
                    </div>
                )}

            {isRoomListing ? (
                 <>
                     <h1 className="text-3xl font-bold text-indigo-700 dark:text-indigo-300 mb-2">{maskPhoneNumbers(post.title)}</h1>
                     <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">Posted by: {post.userName}</p>
                     <OldPostNotice post={post} isRoomListing />
                     <AreaLinks post={post} isRoomListing />

                     {isRoomListing && images.length > 0 && (
                         <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-4">
                             {images.map((img, index) => (
                                 <img
                                     key={index}
                                     src={img}
                                     alt={`${cleanText(maskPhoneNumbers(post.title || 'Room'))} (${index + 1} of ${images.length})`}
                                     className="w-full h-32 object-cover rounded-md cursor-pointer hover:scale-105 transition-transform"
                                     onClick={() => openLightbox(index)}
                                 />
                             ))}
                         </div>
                     )}
                     {lightboxOpen && images.length > 0 && (
                         <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-[9999]">
                             <button
                                 onClick={closeLightbox}
                                 className="absolute top-6 right-10 p-2 bg-gray-800 bg-opacity-70 rounded-full text-white hover:bg-opacity-90 transition"
                             >
                                 <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                     <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                 </svg>
                             </button>
                             <div className="relative flex flex-col items-center">
                                 <img
                                     src={images[lightboxIndex]}
                                     alt={`${cleanText(maskPhoneNumbers(post.title || 'Room'))} (${lightboxIndex + 1} of ${images.length})`}
                                     className="max-h-[70vh] max-w-[90vw] rounded-lg shadow-2xl"
                                 />
                                 <div className="flex justify-between w-full mt-6">
                                     <button
                                         onClick={prevImage}
                                         className="px-6 py-3 bg-white bg-opacity-40 rounded-full text-3xl font-bold text-gray-900 hover:bg-opacity-70 transition"
                                     >&lt;</button>
                                     <button
                                         onClick={nextImage}
                                         className="px-6 py-3 bg-white bg-opacity-40 rounded-full text-3xl font-bold text-gray-900 hover:bg-opacity-70 transition"
                                     >&gt;</button>
                                 </div>
                                 <div className="mt-2 text-white text-sm opacity-70">{lightboxIndex + 1} / {images.length}</div>
                             </div>
                         </div>
                     )}
                     <p className="text-gray-700 dark:text-gray-300 mb-4">{maskPhoneNumbers(post.description)}</p>
                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-gray-700 dark:text-gray-300 mb-4">
                         <p><strong>Rent:</strong> £{post.rent} / month</p>
                         <p><strong>Deposit:</strong> £{post.deposit}</p>
                         <p><strong>Location:</strong> {post.address}, {post.postcode}</p>
                         <p><strong>Room Type:</strong> {Array.isArray(post.roomType) ? post.roomType.join(', ') : post.roomType}</p>
<p><strong>Available From:</strong> {formatDateForDisplay(post.availableFrom)}</p>
                         <p><strong>Preferred Tenants:</strong> {post.preferredTenants?.join(', ') || 'Any'}</p>
                     </div>
                     <div className="mb-4">
                         <h3 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">Amenities:</h3>
                         <div className="flex flex-wrap gap-2">
                             {post.amenities?.map(amenity => (
                                 <span key={amenity} className="bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 px-3 py-1 rounded-full text-sm">
                                     {amenity}
                                 </span>
                             ))}
                         </div>
                     </div>
                 </>
            ) : (
                 <>
                     <div className="flex items-center mb-4">
                         <img
                             src={post.profilePicture || `https://placehold.co/100x100/a78bfa/ffffff?text=PP`}
                             alt="Profile"
                             className="w-24 h-24 rounded-full object-cover mr-4 border-2 border-indigo-500"
                         />
                         <div>
                             <h1 className="text-3xl font-bold text-indigo-700 dark:text-indigo-300">
                                 {post.userName || 'Roommate Seeker'}
                             </h1>
                             <p className="text-gray-600 dark:text-gray-300 text-lg">
                                 {post.profession}
                             </p>
                         </div>
                     </div>
                     <OldPostNotice post={post} isRoomListing={false} />
                     <AreaLinks post={post} isRoomListing={false} />
                      <div className="mb-4">
                        <h3 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">My Requirements:</h3>
                        <p className="text-gray-700 dark:text-gray-300">{maskPhoneNumbers(post.requirements)}</p>
                    </div>
                     <div className="mb-4">
                        <h3 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">About Me:</h3>
                        <p className="text-gray-700 dark:text-gray-300">{post.aboutMe}</p>
                    </div>
                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-gray-700 dark:text-gray-300 mb-4">
                         <p><strong>Budget:</strong> £{post.budget} / month</p>
                         <p><strong>Preferred Locations:</strong> {post.preferredLocations}</p>
<p><strong>Move-in Date:</strong> {formatDateForDisplay(post.moveInDate)}</p>
                         <p><strong>Stay:</strong> {post.preferredStay}</p>
                     </div>
                     <div className="mb-4">
                         <h3 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">Preferred Roommates:</h3>
                         <div className="flex flex-wrap gap-2">
                             {post.preferredRoommates?.map(pref => (
                                 <span key={pref} className="bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 px-3 py-1 rounded-full text-sm">
                                     {pref}
                                 </span>
                             ))}
                         </div>
                     </div>
                 </>
            )}

                        {/* Premium contact info - using LockedContactInfo component */}
            {post.phoneNumber && (
                <div className="my-4">
                    <LockedContactInfo
                        isPremium={userProfile?.isPremium || false}
                        phoneNumber={post.phoneNumber}
                        userName={post.userName}
                        onUnlockClick={() => {
                            if (!userId) {
                                setPendingPremiumUnlock(post);
                                setShowAuthModal(true);
                            } else {
                                setShowPricingModal(true);
                            }
                        }}
                        variant="card"
                    />
                </div>
            )}
             </div>

            <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-600">
                {(post.status === 'active' || !post.status) ? (
                    <>
                        <h3 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-3">Contact {post.userName?.split(' ')[0]}</h3>
                        <div className="flex flex-col sm:flex-row items-center gap-3 flex-wrap">
                             {post.userId !== userId && (<button
                                 onClick={handleInitiateChat}
                                 className="w-full sm:w-auto flex-grow py-2 px-4 rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition duration-200"
                             >
                                 Message User
                             </button>)}
                            <ShareButton post={post} isRoomListing={isRoomListing} />
                        </div>
                    </>
                ) : (
<div className="text-center p-3 rounded-md bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200">
                        <p className="font-semibold">This listing is no longer active.</p>
                        <p className="text-sm">
                            {isRoomListing
                                ? "The room has been marked as FILLED."
                                : "This user has already FOUND a room."
                            }
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}



// --- My Posts Component (MODIFIED) ---
function MyPosts({ onSuccess }) {
    const { db, storage, userId, userRole } = useContext(AppContext);
    const [myPosts, setMyPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');
    const [editingPost, setEditingPost] = useState(null);
    const showToast = useToast();

    const collectionName = userRole === 'I Have Room' ? 'room_listings' : 'roommate_requests';
    const collectionPath = `artifacts/${getFirebaseConfig().appId}/public/data/${collectionName}`;

    useEffect(() => {
        // Clear message after 5 seconds
        if (message) {
            const timer = setTimeout(() => setMessage(''), 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    useEffect(() => {
        if (!db || !userId) return;
        setLoading(true);
        setError(null);
        const q = query(collection(db, collectionPath), where('userId', '==', userId), orderBy('createdAt', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedPosts = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

                           // ✨ MODIFIED: Sort by updatedAt (falling back to createdAt) on the client
            fetchedPosts.sort((a, b) => {
                const timeA = (a.lastActivity || a.createdAt)?.toMillis() || 0;
                const timeB = (b.lastActivity || b.createdAt)?.toMillis() || 0;
                return timeB - timeA;
            });

            const activePosts = fetchedPosts.filter(p => p.status === 'active' || !p.status);
            const inactivePosts = fetchedPosts.filter(p => p.status && p.status !== 'active');

            setMyPosts([...activePosts, ...inactivePosts]);
            setLoading(false);
        }, (err) => {
            console.error("Error fetching my posts:", err);
            setError("Failed to load your posts.");
            setLoading(false);
        });

        return () => unsubscribe();
    }, [db, userId, collectionPath]);

    const handleDelete = async (postId) => {
        if (!db) return;
        if (window.confirm("Are you sure you want to delete this post? This action cannot be undone.")) {
            try {
                const postToDelete = myPosts.find(post => post.id === postId);
                if (postToDelete && postToDelete.images && postToDelete.images.length > 0) {
                    await Promise.all(postToDelete.images.map(url => {
                        const imageRef = ref(storage, url);
                        return deleteObject(imageRef).catch(error => {
                           if (error.code !== 'storage/object-not-found') {
                                console.error("Error deleting image from storage:", error);
                           }
                        });
                    }));
                }
                await deleteDoc(doc(db, collectionPath, postId));
                setMessage('Post deleted successfully!');
                showToast('Post deleted successfully!', 'success');
            } catch (e) {
                console.error("Error deleting document or images: ", e);
                setMessage('Failed to delete post.');
            }
        }
    };

    const handleMarkAsFilled = async (postId, currentStatus) => {
        if (!db) return;
        const newStatus = currentStatus === 'active' ? 'filled' : 'active';
        try {
            await updateDoc(doc(db, collectionPath, postId), { status: newStatus });
            setMessage(`Post marked as ${newStatus} successfully!`);
        } catch (e) {
            console.error("Error updating document: ", e);
            setMessage('Failed to update post status.');
            showToast('Failed to update post status.', 'error');
        }
    };

    const handleEdit = (post) => {
        setEditingPost(post);
    };

    const handleUpdatePost = async (updatedData) => {
        if (!db || !editingPost) return;
        try {
            await updateDoc(doc(db, collectionPath, editingPost.id), updatedData);
            setEditingPost(null); // Close the modal
            // 🚀 NEW: Call the success handler to redirect the user
            onSuccess('Post updated successfully!');
            showToast('Post updated successfully!', 'success');
        } catch (e) {
            console.error("Error updating document: ", e);
            // This error should be shown inside the modal for better UX
            // For now, we'll let the modal handle its own errors.
        }
    };

    if (loading) {
        return <div className="text-center py-8 text-gray-700 dark:text-gray-300">Loading your posts...</div>;
    }

    if (error) {
        return <div className="text-center py-8 text-red-600 dark:text-red-400">Error: {error}</div>;
    }

    return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md my-6">
            <h2 className="text-3xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">My Posts</h2>
            {message && (
                <div className={`p-3 mb-4 rounded-md ${message.includes('successfully') ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'}`}>
                    {message}
                </div>
            )}
            {myPosts.length === 0 ? (
                <p className="text-center text-gray-600 dark:text-gray-400">You haven't created any posts yet.</p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {myPosts.map(post => (
                        <div key={post.id} className={`bg-gray-50 dark:bg-gray-700 p-5 rounded-lg shadow-sm flex flex-col relative ${post.status !== 'active' ? 'grayscale opacity-70' : ''}`}>
                             {post.status !== 'active' && (
                                <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10 shadow-md">
                                    {post.status === 'filled' ? 'FILLED' : 'FOUND'}
                                </div>
                            )}
                            {userRole === 'I Have Room' ? (
                                <>
                                    {post.images && post.images.length > 0 && (
                                        <img
                                            src={post.images[0]}
                                            alt={post.title}
                                            className="w-full h-40 object-cover rounded-md mb-4"
                                        />
                                    )}
                                    <h3 className="text-xl font-semibold text-indigo-600 dark:text-indigo-400 mb-2 line-clamp-1">{maskPhoneNumbers(post.title)}</h3>
                                    <p className="text-gray-700 dark:text-gray-300 mb-2 line-clamp-2">{maskPhoneNumbers(post.description)}</p>
                                    <div className="text-lg font-bold text-green-600 dark:text-green-400 mb-2">£{post.rent} / month</div>
                                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                                        {post.address}, {post.postcode}
                                    </p>
                                    <p className={`text-sm font-medium mt-auto pt-2 ${post.status === 'active' ? 'text-green-500' : 'text-red-500'}`}>
                                        Status: {post.status === 'active' ? 'Active' : (post.status === 'filled' ? 'Filled' : 'Found')}
                                    </p>
                                </>
                            ) : ( // This case is not currently used via UI but included for completeness
                                <>
                                    <div className="flex items-center mb-4">
                                        <img
                                            src={post.profilePicture || `https://placehold.co/100x100/a78bfa/ffffff?text=PP`}
                                            alt="Profile"
                                            className="w-16 h-16 rounded-full object-cover mr-4 border-2 border-indigo-500"
                                        />
                                        <div>
                                            <h3 className="text-xl font-semibold text-indigo-600 dark:text-indigo-400">
                                                My Profile
                                            </h3>
                                            <p className="text-sm text-gray-600 dark:text-gray-300">
                                                Budget: £{post.budget} | Loc: {post.preferredLocations}
                                            </p>
                                        </div>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300 flex-grow mb-3 line-clamp-3">{maskPhoneNumbers(post.requirements || post.aboutMe)}</p>
                                    <p className={`text-sm font-medium mt-auto pt-2 ${post.status === 'active' ? 'text-green-500' : 'text-red-500'}`}>
                                        Status: {post.status === 'active' ? 'Active' : 'Found'}
                                    </p>
                                </>
                            )}
                            <div className="flex space-x-2 mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
                                <button
                                    onClick={() => handleEdit(post)}
                                    className="px-3 py-1 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600 transition duration-200"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(post.id)}
                                    className="px-3 py-1 bg-red-500 text-white text-sm rounded-md hover:bg-red-600 transition duration-200"
                                >
                                    Delete
                                </button>
                                <button
                                    onClick={() => handleMarkAsFilled(post.id, post.status)}
                                    className={`px-3 py-1 text-white text-sm rounded-md transition duration-200 ${post.status === 'active' ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'}`}
                                >
                                    Mark as {post.status === 'active' ? (userRole === 'I Have Room' ? 'Filled' : 'Found') : 'Active'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {editingPost && (
                <EditPostModal
                    post={editingPost}
                    onClose={() => setEditingPost(null)}
                    onSave={handleUpdatePost}
                    isRoomListing={userRole === 'I Have Room'}
                />
            )}
        </div>
    );
}

function PostDetailModal({ post, onClose, isRoomListing, onStartChat }) {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="relative w-full max-w-2xl max-h-[90vh]">
                 <PostDetailView post={post} isRoomListing={isRoomListing} onStartChat={onStartChat} />
                 <button
                    onClick={onClose}
                    className="absolute top-3 right-3 p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                </button>
            </div>
        </div>
    );
}

// --- Edit Post Modal (UNCHANGED) ---
function EditPostModal({ post, onClose, onSave, isRoomListing }) {
    const { storage, userId } = useContext(AppContext);
    const [formData, setFormData] = useState({ ...post, images: post.images || [], profilePicture: post.profilePicture || null });
    const [message, setMessage] = useState('');
    const [uploading, setUploading] = useState(false);

    const [imageFiles, setImageFiles] = useState([]);
    const [imagesToDelete, setImagesToDelete] = useState([]);

    const roomTypes = ['Single', 'Double', 'En-suite', 'Studio', 'Shared'];
    const tenantPreferences = ['Male', 'Female', 'Student', 'Professional', 'Any'];
    const allAmenities = ['WiFi', 'Parking', 'Bills included', 'Furnished', 'Washing Machine', 'Gym access', 'Balcony'];
    const roommatePreferences = ['Student', 'Professional', 'Male', 'Female', 'Vegetarian', 'Non-Vegetarian', 'Non-Smoker', 'Any'];
    const furnishedOptions = ['Furnished', 'Unfurnished', 'Either'];
    const stayOptions = ['Short-term', 'Long-term', '6 months', '12 months', 'Other'];

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            const currentArray = formData[name] || [];
            setFormData(prev => ({
                ...prev,
                [name]: checked
                    ? [...currentArray, value]
                    : currentArray.filter(item => item !== value)
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + imageFiles.length + (formData.images?.length || 0) > 10) {
            setMessage('You can upload a maximum of 10 images total.');
            return;
        }
        setMessage('');
        setImageFiles(prev => [...prev, ...files]);
    };

    const removeExistingImage = (indexToRemove) => {
        const imageUrl = formData.images[indexToRemove];
        if (imageUrl) {
            setImagesToDelete(prev => [...prev, imageUrl]);
            setFormData(prev => ({
                ...prev,
                images: prev.images.filter((_, index) => index !== indexToRemove),
            }));
        }
    };

    const removeNewImage = (indexToRemove) => {
        setImageFiles(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const handleProfilePictureUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !storage || !userId) return;
        setUploading(true);
        setMessage('Uploading new profile picture...');
        try {
            if (formData.profilePicture) {
                const oldRef = ref(storage, formData.profilePicture);
                await deleteObject(oldRef).catch(err => console.log("Old profile pic not found, proceeding."));
            }

            const options = { maxSizeMB: 0.5, maxWidthOrHeight: 500 };
            const compressedFile = await compressImage(file, {
                maxWidthOrHeight: 500
            });
            const imageRef = ref(storage, `artifacts/${getFirebaseConfig().appId}/user_profiles/${userId}/profile_picture.jpg`);
            const snapshot = await uploadBytes(imageRef, compressedFile);
            const downloadURL = await getDownloadURL(snapshot.ref);
            setFormData(prev => ({ ...prev, profilePicture: downloadURL }));
            setMessage('New profile picture uploaded successfully!');
        } catch (e) {
            console.error("Error uploading profile picture:", e);
            setMessage('Failed to upload profile picture. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUploading(true);
        setMessage('Saving changes...');

        try {
            for (const url of imagesToDelete) {
                const imageRef = ref(storage, url);
                await deleteObject(imageRef).catch(error => {
                    if (error.code !== 'storage/object-not-found') {
                        console.error("Error deleting image from storage:", error);
                    }
                });
            }

            const newImageUrls = [];
           for (const file of imageFiles) {
                // ✨ MODIFIED: Use the standard helper
                const compressedFile = await compressImage(file);

                const imageName = `${userId}-${Date.now()}-${compressedFile.name}`;
                const imageRef = ref(storage, `artifacts/${getFirebaseConfig().appId}/room_listings/${imageName}`);
                const snapshot = await uploadBytes(imageRef, compressedFile);
                const downloadURL = await getDownloadURL(snapshot.ref);
                newImageUrls.push(downloadURL);
            }

            const finalImageUrls = [...formData.images, ...newImageUrls];

            onSave({ ...formData, images: finalImageUrls, lastActivity: serverTimestamp() });


        } catch (e) {
            console.error("Error updating images or post:", e);
            setMessage('Failed to save changes: ' + e?.message);
            setUploading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto relative p-6">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                </button>
                <h2 className="text-2xl font-bold mb-6 text-indigo-700 dark:text-indigo-300 text-center">
                    Edit {isRoomListing ? 'Room Listing' : 'Roommate Request'}
                </h2>
                {message && (
                    <div className="p-3 mb-4 rounded-md bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">
                        {message}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-6">
                    {isRoomListing ? (
                        <>
                           <FormSection title="Lister & Contact Details">
                                 <div>
                                    <label htmlFor="userName" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Your Name</label>
                                    <input
                                        type="text"
                                        id="userName"
                                        name="userName"
                                        value={formData.userName || ''}
                                        onChange={handleChange} // ✨ ADD THIS LINE
                                        required // ✨ ADD THIS LINE
                                        className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700" // ✨ REMOVED 'readOnly' and 'cursor-not-allowed'
                                    />
                                </div>
                                <div>
                                    <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Contact Number</label>
                                    <input type="tel" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber || ''} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700" />
                                </div>

                            </FormSection>
                            <FormSection title="Property & Listing Details">
                                <div>
                                    <label htmlFor="title" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Title</label>
                                    <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700" />
                                </div>
                                <div>
                                    <label htmlFor="description" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Description</label>
                                    <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows="4" required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700"></textarea>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="address" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Area/Locality</label>
                                        <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700" />
                                    </div>
                                    <div>
                                        <label htmlFor="postcode" className="block text-sm font-medium text-gray-700 dark:text-gray-300">City</label>
                                        <input type="text" id="postcode" name="postcode" value={formData.postcode} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700" />
                                    </div>
                                </div>
                            </FormSection>

                            <FormSection title="Rental Terms">
                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="rent" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Rent (£ per month)</label>
                                        <input
                                            type="number"
                                            id="rent"
                                            name="rent"
                                            value={formData.rent}
                                            onChange={handleChange}
                                            required
                                            min="0"
                                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="deposit" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Deposit (£)</label>
                                        <input
                                            type="number"
                                            id="deposit"
                                            name="deposit"
                                            value={formData.deposit}
                                            onChange={handleChange}
                                            required
                                            min="0"
                                            className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="availableFrom" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Available From</label>
                                    <input
                                        type="date"
                                        id="availableFrom"
                                        name="availableFrom"
                                        value={formData.availableFrom}
                                        onChange={handleChange}
                                        required
                                        className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 dark:bg-gray-700"
                                    />
                                </div>
                            </FormSection>

                             <FormSection title="Room & Tenant Specifics">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Room Type</label>
                                    <div className="flex flex-wrap gap-3">
                                        {roomTypes.map(type => (
                                            <label key={type} className="inline-flex items-center">
                                                <input type="checkbox" name="roomType" value={type} checked={(formData.roomType || []).includes(type)} onChange={handleChange} className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700" />
                                                <span className="ml-2 text-gray-700 dark:text-gray-300">{type}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Preferred Tenants</label>
                                    <div className="flex flex-wrap gap-3">
                                        {tenantPreferences.map(pref => (
                                            <label key={pref} className="inline-flex items-center">
                                                <input type="checkbox" name="preferredTenants" value={pref} checked={(formData.preferredTenants || []).includes(pref)} onChange={handleChange} className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700" />
                                                <span className="ml-2 text-gray-700 dark:text-gray-300">{pref}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Amenities</label>
                                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                                        {allAmenities.map(amenity => (
                                            <label key={amenity} className="inline-flex items-center">
                                                <input type="checkbox" name="amenities" value={amenity} checked={(formData.amenities || []).includes(amenity)} onChange={handleChange} className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700" />
                                                <span className="ml-2 text-gray-700 dark:text-gray-300">{amenity}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </FormSection>
                            <FormSection title="Manage Images">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Add More Images (max 10 total)</label>
                                <input type="file" name="images" accept="image/*" multiple onChange={handleImageUpload} className="mt-1 block w-full text-sm text-gray-900 dark:text-gray-100 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100" />

                                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">Current images:</p>
                                <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                                    {formData.images?.map((image, index) => (
                                        <div key={index} className="relative group rounded-lg overflow-hidden shadow-sm">
                                            <img src={image} alt={`Room ${index + 1}`} className="w-full h-32 object-cover" />
                                            <button type="button" onClick={() => removeExistingImage(index)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" aria-label="Remove image">
                                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                            </button>
                                        </div>
                                    ))}
                                    {imageFiles.map((file, index) => (
                                        <div key={`new-${index}`} className="relative group rounded-lg overflow-hidden shadow-sm">
                                            <img src={URL.createObjectURL(file)} alt={`New upload ${index + 1}`} className="w-full h-32 object-cover" />
                                            <button type="button" onClick={() => removeNewImage(index)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" aria-label="Remove new image">
                                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </FormSection>
                        </>
                    ) : ( // Edit form for Roommate Request
                        <>
                           <FormSection title="Personal & Contact Information">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Full Name</label>
                                        <input type="text" name="userName" value={formData.userName || ''} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700" />
                                    </div>
                                     <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Contact Number</label>
                                        <input type="tel" name="phoneNumber" value={formData.phoneNumber || ''} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700" />
                                    </div>
                                </div>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">About Me</label>
                                    <textarea name="aboutMe" value={formData.aboutMe} onChange={handleChange} rows="3" required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700" />
                                </div>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Upload Profile Picture</label>
                                    <input type="file" id="profilePicture" name="profilePicture" accept="image/*" onChange={handleProfilePictureUpload} className="mt-1 block w-full text-sm text-gray-900 dark:text-gray-100 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100" />
                                    {formData.profilePicture && (
                                        <div className="mt-4 w-32 h-32 rounded-full overflow-hidden mx-auto border-2 border-indigo-500 shadow-md">
                                            <img src={formData.profilePicture} alt="Profile Preview" className="w-full h-full object-cover" />
                                        </div>
                                    )}
                                </div>
                            </FormSection>
                            <FormSection title="Room & Roommate Preferences">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="budget" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Budget (£ per month)</label>
                                        <input type="number" id="budget" name="budget" value={formData.budget} onChange={handleChange} required min="0" className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700" />
                                    </div>
                                    <div>
                                        <label htmlFor="moveInDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Move-in Date</label>
                                        <input type="date" id="moveInDate" name="moveInDate" value={formData.moveInDate} onChange={handleChange} required className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700" />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Preferred Roommates</label>
                                    <div className="flex flex-wrap gap-3">
                                        {roommatePreferences.map(pref => (
                                            <label key={pref} className="inline-flex items-center">
                                                <input type="checkbox" name="preferredRoommates" value={pref} checked={(formData.preferredRoommates || []).includes(pref)} onChange={handleChange} className="form-checkbox h-5 w-5 text-indigo-600 rounded border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700" />
                                                <span className="ml-2 text-gray-700 dark:text-gray-300">{pref}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="requirements" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Description of Requirements</label>
                                    <textarea id="requirements" name="requirements" value={formData.requirements} onChange={handleChange} rows="3" className="mt-1 block w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-gray-50 dark:bg-gray-700"></textarea>
                                </div>
                            </FormSection>
                        </>
                    )}
                    <button
                        type="submit"
                        disabled={uploading}
                        className="w-full mt-6 py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-200"
                    >
                        {uploading ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </div>
        </div>
    );
}

// --- ChatList (UNCHANGED) ---
function ChatList({ onClose }) {
    const { db, userId } = useContext(AppContext);
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedConversation, setSelectedConversation] = useState(null);

    useEffect(() => {
        if (!db || !userId) {
            setLoading(false);
            return;
        };

        const conversationsRef = collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/conversations`);

        const q = query(
            conversationsRef,
            where('participants', 'array-contains', userId),
            orderBy('lastMessageTimestamp', 'desc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const convos = snapshot.docs.map(convoDoc => {
                const data = convoDoc.data();
                const otherUserId = data.participants.find(p => p !== userId);
                const otherUserName = data.participantNames?.[otherUserId] || 'Unknown User';

                return {
                    id: convoDoc.id,
                    ...data,
                    otherUserName,
                    otherUserId
                };
            });
            setConversations(convos);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching conversations:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [db, userId]);

    if (loading) {
        return <div className="text-center p-4">Loading conversations...</div>;
    }

    if (selectedConversation) {
        const recipient = { userId: selectedConversation.otherUserId, userName: selectedConversation.otherUserName };
        return <Chat recipient={recipient} onBack={() => setSelectedConversation(null)} />;
    }

    return (
        <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg my-6 max-w-4xl mx-auto">
                        <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-indigo-700 dark:text-indigo-300">Messages</h2>
<button
    onClick={onClose}
    className="p-2 rounded-full border border-gray-300 dark:border-gray-600 text-gray-500 hover:text-gray-800 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500"
    aria-label="Close messages"
>
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
</button>
            </div>
            {loading ? (
                   <p className="text-center text-gray-500">Loading conversations...</p>
            ) : conversations.length === 0 ? (
                <div className="text-center py-10 px-4">
                    <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                    <h3 className="mt-2 text-lg font-medium text-gray-900 dark:text-gray-100">No messages yet</h3>
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">When you start a new conversation, it will appear here.</p>
                </div>
            ) : (
                <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                    {conversations.map(convo => {
                        const unreadCount = convo.unreadCount?.[userId] || 0;
                        return (
                            <li key={convo.id} onClick={() => setSelectedConversation(convo)} className="p-3 sm:p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer rounded-lg transition-colors">
                                <div className="flex items-center space-x-4">
                                    <div className="flex-shrink-0">
                                        <div className="w-12 h-12 bg-indigo-500 text-white flex items-center justify-center rounded-full font-bold text-xl">
                                            {getInitials(convo.otherUserName)}
                                        </div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center justify-between">
                                            <p className={`text-md font-bold ${unreadCount > 0 ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-900 dark:text-gray-100'}`}>{convo.otherUserName}</p>
                                            <p className="text-xs text-gray-500 dark:text-gray-400">{formatTimestamp(convo.lastMessageTimestamp)}</p>
                                        </div>
                                        <div className="flex items-center mt-1">
                                            {unreadCount > 0 && (
                                                <span className="w-2 h-2 mr-2 bg-red-500 rounded-full"></span>
                                            )}
                                            <p className={`text-sm truncate ${unreadCount > 0 ? 'text-gray-800 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`}>
                                                {convo.lastMessage}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            )}
        </div>
    );
}

// --- NEW COMPONENT: DateSeparator (UNCHANGED) ---
function DateSeparator({ date }) {
    return (
        <div className="flex justify-center my-4">
            <span className="bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-3 py-1 text-xs font-semibold rounded-full">
                {formatDateSeparator(date)}
            </span>
        </div>
    );
}


// --- Chat Component (UNCHANGED) ---
function Chat({ recipient, onBack }) {
    const { db, userId, userProfile } = useContext(AppContext);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const messagesEndRef = React.useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const getConversationId = (userId1, userId2) => {
        return [userId1, userId2].sort().join('_');
    };

    const conversationId = getConversationId(userId, recipient.userId);

useEffect(() => {
        if (!db || !userId || !conversationId || !userProfile || !recipient) return;

        const conversationRef = doc(db, `artifacts/${getFirebaseConfig().appId}/public/data/conversations/${conversationId}`);

        // This operation will now:
        // 1. CREATE the doc with participants + names if it's new.
        // 2. MERGE the unread count update into the doc if it exists.
        // This satisfies both your `create` and `update` security rules.
        setDoc(conversationRef, {
            participants: [userId, recipient.userId],
            participantNames: {
                [userId]: userProfile.name,
                [recipient.userId]: recipient.userName,
            },
            unreadCount: {
                [userId]: 0
            }
        }, { merge: true })
        .catch(err => console.error("Error initializing conversation:", err));

    // Add userProfile and recipient to the dependency array
    }, [db, userId, conversationId, userProfile, recipient]);

    useEffect(() => {
        if (!db || !conversationId) return;
        const messagesRef = collection(db, `artifacts/${getFirebaseConfig().appId}/public/data/conversations/${conversationId}/messages`);
        const q = query(messagesRef, orderBy("timestamp", "asc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setMessages(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, [db, conversationId]);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (newMessage.trim() === '') return;

        const conversationRef = doc(db, `artifacts/${getFirebaseConfig().appId}/public/data/conversations/${conversationId}`);
        const messagesRef = collection(conversationRef, 'messages');

        await addDoc(messagesRef, {
            text: newMessage,
            senderId: userId,
            receiverId: recipient.userId,
            timestamp: serverTimestamp(),
        });

        await setDoc(conversationRef, {
            participants: [userId, recipient.userId],
            participantNames: {
                [userId]: userProfile.name,
                [recipient.userId]: recipient.userName,
            },
            lastMessage: newMessage,
            lastMessageTimestamp: serverTimestamp(),
        }, { merge: true });

        await updateDoc(conversationRef, {
            [`unreadCount.${recipient.userId}`]: increment(1)
        });

        setNewMessage('');
    };

    const renderMessages = () => {
        const chatContent = [];
        let lastMessageDate = null;

        messages.forEach(msg => {
            if (!msg.timestamp) return;

            const currentDate = msg.timestamp.toDate();

            if (!lastMessageDate || currentDate.toDateString() !== lastMessageDate.toDateString()) {
                chatContent.push(<DateSeparator key={`sep-${msg.id}`} date={currentDate} />);
                lastMessageDate = currentDate;
            }

            chatContent.push(
                <div key={msg.id} className={`flex items-end gap-2 ${msg.senderId === userId ? 'justify-end' : 'justify-start'}`}>
                    <div className={`py-2 px-3 rounded-xl max-w-xs md:max-w-md flex flex-col ${msg.senderId === userId ? 'bg-indigo-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100'}`}>
                        <p className="text-sm break-words">{msg.text}</p>
                        <span className="text-xs self-end text-gray-500 dark:text-gray-400 opacity-80 ml-2 mt-1">
                            {formatTimestampForChat(msg.timestamp)}
                        </span>
                    </div>
                </div>
            );
        });

        return chatContent;
    };

    return (
        <div className="flex flex-col h-[calc(100vh-12rem)] bg-white dark:bg-gray-800 rounded-lg shadow-md">
            <div className="p-3 border-b border-gray-200 dark:border-gray-700 flex items-center space-x-3">
                <button
                    onClick={onBack}
                    className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                    aria-label="Back to messages"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                </button>
                <div className="flex items-center space-x-3">
                     <div className="w-10 h-10 bg-indigo-500 text-white flex items-center justify-center rounded-full font-bold">
                         {getInitials(recipient.userName)}
                     </div>
                    <h2 className="text-xl font-bold">{recipient.name || recipient.userName}</h2>
                </div>
            </div>
            <div className="flex-1 p-4 overflow-y-auto space-y-2 bg-gray-50 dark:bg-gray-900">
                {renderMessages()}
                <div ref={messagesEndRef} />
            </div>
            <form onSubmit={handleSendMessage} className="p-4 border-t border-gray-200 dark:border-gray-700 flex">
                <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type a message..."
                    className="flex-1 p-2 border border-gray-300 dark:border-gray-600 rounded-l-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-100"
                />
                <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-r-md hover:bg-indigo-700">Send</button>
            </form>
        </div>
    );
}

// Listing URL + prefilled WhatsApp share link, used by the share buttons on
// the listing page and the browse cards
function getShareLinks(post, isRoomListing) {
    const postType = isRoomListing ? 'room' : 'roommate';
    const titleSlug = slugify(isRoomListing ? post.title : post.requirements);
    const shareUrl = `https://indianflatmates.co.uk/${postType}/${titleSlug}-id-${post.id}`;

    const house  = String.fromCodePoint(0x1F3E0); // 🏠
    const pin    = String.fromCodePoint(0x1F4CD); // 📍
    const money  = String.fromCodePoint(0x1F4B0); // 💰
    const search = String.fromCodePoint(0x1F50D); // 🔍
    // First name only for roommate requests — the message is forwarded into
    // groups of strangers
    const firstName = (post.userName || 'Someone').split(' ')[0];
    const waText = isRoomListing
        ? `${house} *Room Available – IndianFlatmates*\n\n*${maskPhoneNumbers(post.title)}*\n${pin} ${post.address}, London\n${money} £${post.rent}/month${post.billsIncluded ? ' (bills included)' : ''}\n\nSee the full listing:\n${shareUrl}`
        : `${search} *Roommate Request – IndianFlatmates*\n\n*${firstName}* is looking for a room in *${post.preferredLocations}*\n${money} Budget: £${post.budget}/month\n\nSee the full profile:\n${shareUrl}`;

    return { shareUrl, waUrl: `https://wa.me/?text=${encodeURIComponent(waText)}` };
}

const WhatsAppIcon = ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.267.651 4.383 1.803 6.166l-1.225 4.469 4.575-1.201zM18.33 14.229c-.301-.15-1.767-.867-2.04-.967-.272-.1-.47-.15-.67.15-.197.299-.771.966-.944 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.299-.018-.462.13-.611.134-.133.297-.347.446-.52.15-.174.199-.299.298-.498.1-.199.05-.374-.025-.524-.075-.15-.67-1.612-.916-2.206-.242-.58-.487-.5-.67-.506-.183-.006-.38-.006-.579-.006-.199 0-.523.074-.797.373-.273.3-.981.957-.981 2.322 0 1.365 1.007 2.699 1.157 2.897.149.199 1.958 3.024 4.793 4.22 2.836 1.196 2.836.797 3.344.746.508-.05 1.767-.717 2.016-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.199-.57-.347z"/>
    </svg>
);

// Small round WhatsApp share button for browse cards (the card itself is
// clickable, so the click must not bubble up and open the listing)
function CardShareButton({ post, isRoomListing, className = '' }) {
    const { waUrl } = getShareLinks(post, isRoomListing);
    return (
        <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className={`inline-flex items-center justify-center w-9 h-9 rounded-full text-white bg-green-500 hover:bg-green-600 shadow-md transition-colors ${className}`}
            aria-label="Share on WhatsApp"
            title="Share on WhatsApp"
        >
            <WhatsAppIcon className="w-5 h-5" />
        </a>
    );
}

function ShareButton({ post, isRoomListing, compact = false }) {
    const [copied, setCopied] = useState(false);
    const { shareUrl, waUrl } = getShareLinks(post, isRoomListing);

    if (compact) {
        return (
            <a
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium text-white bg-green-500 hover:bg-green-600 transition-colors shadow-sm"
                aria-label="Share on WhatsApp"
            >
                <WhatsAppIcon className="w-4 h-4" />
                Share
            </a>
        );
    }

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch {
            // fallback: select a temp input
            const el = document.createElement('input');
            el.value = shareUrl;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        }
    };

    return (
        <div className="flex items-center gap-2 flex-wrap">
            {/* WhatsApp share */}
            <a
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium text-white bg-green-500 hover:bg-green-600 transition-colors shadow-sm"
                aria-label="Share on WhatsApp"
            >
                <WhatsAppIcon className="w-4 h-4" />
                Share on WhatsApp
            </a>

            {/* Copy link */}
            <button
                onClick={handleCopyLink}
                className="inline-flex items-center gap-1.5 px-4 py-2 border border-gray-300 dark:border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                aria-label="Copy link"
            >
                {copied ? (
                    <>
                        <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
                        Copied!
                    </>
                ) : (
                    <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>
                        Copy Link
                    </>
                )}
            </button>
        </div>
    );
}


function WelcomeMessage({ userRole, onClose }) {
    const message = userRole === 'I Need Room'
? "Complete your profile so flat owners can find you easily. Profiles with more details receive better and faster responses!"
: "Create your first room listing to attract tenants. Listings with clear details and photos get the most attention!";

    useEffect(() => {
        const timer = setTimeout(onClose, 10000); // Auto-dismiss after 7 seconds
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed bottom-5 right-5 w-full max-w-sm bg-indigo-600 text-white p-4 rounded-lg shadow-lg z-50 animate-fade-in-up">
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <div className="ml-3">
                    <p className="text-sm font-medium">{message}</p>
                </div>
                <div className="ml-auto pl-3">
                    <button onClick={onClose} className="-mx-1.5 -my-1.5 p-1.5 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white">
                        <span className="sr-only">Dismiss</span>
                        <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

// --- Timestamp Formatting Helper Functions (UNCHANGED) ---
function formatTimestamp(timestamp) {
    if (!timestamp?.toDate) {
        return '';
    }
    const now = new Date();
    const messageDate = timestamp.toDate();

    const diffSeconds = Math.round((now.getTime() - messageDate.getTime()) / 1000);

    if (diffSeconds < 60) return `${diffSeconds}s ago`;
    const diffMinutes = Math.round(diffSeconds / 60);
    if (diffMinutes < 60) return `${diffMinutes}m ago`;
    const diffHours = Math.round(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours}h ago`;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const aWeekAgo = new Date(today);
    aWeekAgo.setDate(today.getDate() - 7);

    const messageDay = new Date(messageDate);
    messageDay.setHours(0, 0, 0, 0);

    if (messageDay.getTime() === yesterday.getTime()) {
        return 'Yesterday';
    }
    if (messageDay > aWeekAgo.getTime()) {
        return messageDate.toLocaleDateString('en-GB', { weekday: 'short' }); // "Sun", "Mon", etc.
    }

    return messageDate.toLocaleDateString('en-GB'); // "dd/mm/yyyy"
}

function formatDateSeparator(date) {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);

    const messageDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (messageDay.getTime() === todayDay.getTime()) {
        return 'Today';
    }
    if (messageDay.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
    }
    if (date > aWeekAgo) {
        return date.toLocaleDateString('en-GB', { weekday: 'long' }); // e.g., "Sunday"
    }
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}

function formatTimestampForChat(timestamp) {
    if (!timestamp?.toDate) {
        return '';
    }
    const messageDate = timestamp.toDate();
    return messageDate.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
    });
}


export default App;